// events.js
// !function(t){t.hdtEvts=function(){"use strict";const t={},r=function(t){switch(t){case"_1":return document.body;break;default:return document}};return t.on=function(t,n,e,i){if(typeof n==="string")n=r(n);if(!n||!e)return;i=i||false;if(!n.hdtEvts)n.hdtEvts={};t.split(",").forEach(function(t){t=t.trim();if(n.hdtEvts[t])return;n.addEventListener(t.split(".")[0],e,i);n.hdtEvts[t]=e})},t.off=function(t,n){if(typeof n==="string")n=r(n);if(!n)return;t.split(",").forEach(function(t){t=t.trim();if(!n.hdtEvts[t])return;n.removeEventListener(t.split(".")[0],n.hdtEvts[t]);delete n.hdtEvts[t]})},t}()}(window);
// https://forum.xda-developers.com/t/list-of-tlink-versions-availables.4387577/page-10
const html = document.documentElement;
const getDir = html.getAttribute("dir");
const isRTL = ("rtl" == getDir);
// https://shopify.dev/docs/themes/architecture/sections/integrate-sections-with-the-theme-editor#javascript-events
const adnmEvts = {
  select: 'shopify:block:select',
  deselect: 'shopify:block:deselect',
  seSelect: 'shopify:section:select',
  seDeselect: 'shopify:section:deselect',
  seLoad: 'shopify:section:load',
  seUnload: 'shopify:section:unload',
  seReorder: 'shopify:section:reorder'
}
// try {
//   themeHDN.spStorage = ('sessionStorage' in window && window.sessionStorage !== null);
//   window.sessionStorage.setItem('hdt', 'test');
//   window.sessionStorage.removeItem('hdt');
// }
// catch (err) {
//   themeHDN.spStorage = false;
// }

// Selector
var $4 = (selector, container = document) => {
	return container.querySelector(selector);
};
var $id4 = (selector) => {
	return document.getElementById(selector);
};
var $$4 = (selector, container = document) => {
	return [...container.querySelectorAll(selector)];
};

// Memory leaks
var checkObj = (obj, member, msg, checkNot = true) => {
  if ( checkNot ? !member.has(obj) : member.has(obj) ) throw TypeError("Cannot " + msg);
};
var fnCheck = (obj, member, method) => {
  checkObj(obj, member, "access private method");
  //console.log('fnCheck')
  return method;
};
var collectableAdd = (obj, member, value) => {
  checkObj(obj, member, "Cannot add the same private member more than once", false);
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
  //console.log('collectableAdd', member,obj)
};
var collectableSet = (obj, member, value, setter) => {
  checkObj(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var collectableGet = (obj, member, getter) => {
  checkObj(obj, member, "read from private field");
  //console.log('collectableGet', getter ? getter : member, obj)
  return getter ? getter.call(obj) : member.get(obj);
};

// var getterAdd = (ws, key) => {
//   if (!ws instanceof WeakSet || ws.has(key)) return;
//   ws.add(key);
// }
// var getterWmSet = (wm, key, value, override = false) => {
//   if (!wm instanceof WeakMap || (wm.has(key) && !override )) return;
//   wm.set(key, value);
// }

var getterAdd = (ww, key, value, override = false) => {
  //console.log('override', override );
  if (!override && ww.has(key) ) return;
  //console.log('addd', !override, ww.has(key), value );
  (ww instanceof WeakSet) ? ww.add(key) : ww.set(key, value);
};
var getterGet = (wm, key, value) => {
  if ( !wm.has(key)) {
    if (value) {
      getterAdd(wm, key, value, true);
    } else {
      return false;
    }
  }
  return wm.get(key);
};
var getterRunFn = (ww, key, fn) => {
  if ( !ww.has(key)) throw TypeError(ww + "no exist");
  return fn;
};
var getterDelete = (ww, key) => {
  if ( ww.has(key)) ww.delete(key);
};
var _thu = { nvt: 1 };
// utilities js
function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
  formatString = format || window.themeHDN.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}
function throttle(callback) {
  let requestId = null, lastArgs;
  const later = (context) => () => {
    requestId = null;
    callback.apply(context, lastArgs);
  };
  const throttled = (...args) => {
    lastArgs = args;
    if (requestId === null) {
      requestId = requestAnimationFrame(later(this));
    }
  };
  throttled.cancel = () => {
    cancelAnimationFrame(requestId);
    requestId = null;
  };
  return throttled;
}

// function throttle(fn, delay) {
//   let lastCall = 0;
//   return function (...args) {
//     const now = new Date().getTime();
//     if (now - lastCall < delay) {
//       return;
//     }
//     lastCall = now;
//     return fn(...args);
//   };
// }
// function debounce(fn, delay) {
//   let timer = null;
//   return (...args) => {
//     clearTimeout(timer);
//     timer = setTimeout(() => {
//       fn.apply(this, args);
//     }, delay);
//   };
// }
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function waitForEvent(element, eventName) {
  return new Promise((resolve) => {
    const done = (event) => {
      if (event.target === element) {
        element.removeEventListener(eventName, done);
        resolve(event);
      }
    };
    element.addEventListener(eventName, done);
  });
}
// http://rocha.la/JavaScript-bitwise-operators-in-practice
function getUID(prefix = 'hdt') {
  do prefix += crypto.randomUUID ? crypto.randomUUID() : ~~(Math.random() * 1000000)
  while ($id4(prefix))
  return prefix
}
function _matchMedia(breakpoint, fn) {
  switch (breakpoint) {
    case 'phone':
      return window.matchMedia('screen and (max-width: 767px)').matches;

    case 'tablet':
      return window.matchMedia('screen and (min-width: 768px) and (max-width: 1149px)').matches;

    case 'supports-hover':
      return window.matchMedia('screen and (hover: hover) and (pointer: fine)').matches;

    case 'motion':
      return window.matchMedia('(prefers-reduced-motion: no-preference)').matches;

    case 'motion-reduce':
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    default:
      return window.matchMedia(breakpoint).onchange = fn;
      // return window.matchMedia(breakpoint).addEventListener("change", fn);
      // https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/change_event
      // _theme.matchMedia('screen and (min-width: 1025px)', (event) => {
      //   if (event.matches) {

      //   } else {
      //   }
      // });
  }
}
function createImg(imgObj) {
  const image = new Image(imgObj.width, imgObj.height),
  attrs = imgObj.attrs || {};
  for (const key in attrs) {
    image.setAttribute(key, attrs[key]);
  }
  image.alt = imgObj.alt || "";
  image.src = imgObj.src;
  image.srcset = renderSrcset(imgObj.src, JSON.parse(imgObj.attrs['data-widths']));

  if (imgObj.onload) {
    image.addEventListener("load", function() {
      const parentImage = image.parentElement;
      if (!parentImage) return;
      parentImage.removeAttribute('loading');
      parentImage.setAttribute('loaded', '');
    }, {once : true});
  }

  return image;
}
function renderSrcset(src, widths) {
  let imgURl = new URL(src.startsWith("//") ? `https:${src}` : src),
      maxWidth = parseInt( imgURl.searchParams.get("width") || widths[widths.length - 1]);
  return widths.filter((width) => width <= maxWidth).map((width) => {
    imgURl.searchParams.set("width", width.toString());
    return `${imgURl.href} ${width}w`;
  }).join(", ");
}
function isFunction(functionToCheck) {
  return (typeof functionToCheck === "function");
}

const _cachedFetch = new Map();
async function cachedFetch(url, view = '', options) {
  //console.log('cachedFetch', url)
  const urlView = url + view;
  //console.log(view, urlView)
  if (_cachedFetch.has(urlView)) return Promise.resolve(new Response(new Blob([_cachedFetch.get(urlView)])));
  const res = await fetch(url, options);
  if (res.status === 200) {
    const contentType = res.headers.get("Content-Type");
    if (contentType && (contentType.match(/text\//i)) || contentType.match(/application\/json/i)) {
      res.clone().text().then((content) => {
        _cachedFetch.set(urlView, content);
      });
    }
  }
  return res;
};

const JSONProducts = {};
class getJSONProduct {
  static load(productHandle) {
    if (!productHandle) {
      return;
    }
    if (JSONProducts[productHandle]) {
      return JSONProducts[productHandle];
    }
    JSONProducts[productHandle] = new Promise(async (resolve, reject) => {
      const response = await fetch(`${Shopify.routes.root}products/${productHandle}.js`);
      if (response.ok) {
        const responseAsJson = await response.json();
        resolve(responseAsJson);
      } else {
        reject(`${productHandle} not loaded json`);
      }
    });
    return JSONProducts[productHandle];
  }
};

// Visibilitychange
function visibilitychangeFn(options) {
  if (!options.observes) return;
  const checkVisibility = () => {
    if (document.visibilityState === 'visible') {
      if (isFunction(options.play) && options.observes.isInview) options.play();
    } else if (isFunction(options.pause)) {
      options.pause();
    }
  }
  document.addEventListener('visibilitychange', checkVisibility);

}

/**
 * Wrap tables in a container div to make them scrollable when needed
 */
function rteWrapTable(doc = document) {
  const tables = $$4('.hdt-rte table:not(.hdt-wrapper-added)', doc);
  if (tables.length == 0) return
  tables.forEach((table) => {
    table.classList.add('hdt-wrapper-added');
    table.outerHTML = `<div class="hdt-scrollable-wrapper">${table.outerHTML}</div>`;
  });
}

/**
 * Add aria-describedby attribute to external and new window links
 */
function accessibleLinks(doc = document) {
  const { hostname } = window.location,
  links = $$4('a[href]:not([aria-describedby])', doc);
  if (links.length == 0) return;

  links.forEach((link) => {
    const isExternal  = link.hostname !== hostname,
        isTargetBlank = link.getAttribute('target') === '_blank';

    if (isTargetBlank) {
      link.setAttribute('aria-describedby', isExternal ? 'a11y-new-window-external-message' : 'a11y-new-window-message');
      const rel = link.getAttribute('rel');
      if (!rel || rel.indexOf('noopener') === -1) {
        link.setAttribute('rel',`${rel ? rel + ' '  : ''}noopener`);
      }
    } else if (isExternal) {
      link.setAttribute('aria-describedby', 'a11y-external-message');
    }
  });
}



/** Link Mylti Lang **/
function localeUrl(doc = document) {
  const {root} = Shopify.routes,
        {hostname} = window.location;
  if ( root == '/' ) return;
  $$4('a[href="/"]', doc).forEach((el) => el.setAttribute('href', root ));
  $$4(`a[href*="${hostname}/"]:not([href*="${hostname + root}"],[href*="@"],[href*="preview_theme_id="])`, doc).forEach((el) => el.setAttribute('href', el.getAttribute('href').replace( `${hostname}/`, hostname + root ) ));
};

/*
1. Component carousel
2. Component scrollsnap
3. Component scrolling text
4. Component Countdown Timer
5. Component Drawner
6. Component Modal
*/



var _config2, _userConfig2,
_mouseTrack, mouseTrack_fn,
_mouseCompare, mouseCompare_fn,
_mouseenterHandler, mouseenterHandler_fn,
_mouseleaveHandler, mouseleaveHandler_fn,
_handleHover, handleHover_fn,
_defaultOptions2,
_timeoutId,
_onEnter,
_onExit,
_elem2,
_keyid;
class HoverIntent {
  constructor(elem, userConfig, keyid) {
    //this.elem = elem;
    const keyid_ = { key:keyid || elem }
    this.keyid_ = keyid_;
    getterAdd(_keyid, keyid_, keyid_);
    getterAdd(_elem2, keyid_, elem);
    getterAdd(_userConfig2, keyid_, userConfig);
    getterAdd(_mouseTrack, keyid_, mouseTrack_fn.bind(this));
    getterAdd(_mouseCompare, keyid_);
    getterAdd(_handleHover, keyid_);
    getterAdd(_mouseenterHandler, keyid_);
    getterAdd(_mouseleaveHandler, keyid_);
    getterAdd(_timeoutId, keyid_, void 0);
    getterAdd(_onEnter, keyid_);
    getterAdd(_onExit, keyid_);
    // console.log(_elem2)
    // this.init();
    // current X and Y position of mouse, updated during mousemove tracking (shared across instances)
    // this.cX
    // this.cY
    // if (!this.config || !this.config.onEnter || !this.config.onExit) {
    //   throw 'onEnter and onExit callbacks must be provided';
    // }

    // holds current element state
    getterGet(_elem2, keyid_).isActive = false;
    getterGet(_elem2, keyid_)?.addEventListener('mouseenter', getterRunFn(_handleHover, keyid_, handleHover_fn).bind(this, keyid_) );
    getterGet(_elem2, keyid_)?.addEventListener('mouseleave', getterRunFn(_handleHover, keyid_, handleHover_fn).bind(this, keyid_) );
  }
  get config() {
    return getterGet(_config2, getterGet(_keyid, this.keyid_) , Object.assign(getterGet(_defaultOptions2, _thu), getterGet(_userConfig2, getterGet(_keyid, this.keyid_))));
  }
}
_keyid = new WeakMap();
_config2 = new WeakMap();
_userConfig2 = new WeakMap();
_mouseTrack = new WeakMap();
_mouseCompare = new WeakSet();
_mouseenterHandler = new WeakSet();
_mouseleaveHandler = new WeakSet();
_handleHover = new WeakSet();
_defaultOptions2 = new Map();
getterAdd(_defaultOptions2, _thu, {
  exitDelay: 0,
  interval: 100,
  sensitivity: 6
});
_timeoutId = new WeakMap();
_elem2 = new WeakMap();
_onEnter = new WeakSet();
_onExit = new WeakSet();

// saves the current pointer position coordinates based on the given mousemove event
mouseTrack_fn = function(ev) {
  this.cX = ev.pageX;
  this.cY = ev.pageY;
};
// compares current and previous mouse positions
mouseCompare_fn = function(elem2, keyid_) {
  if (Math.sqrt( (this.prevX - this.cX)*(this.prevX - this.cX) + (this.prevY - this.cY)*(this.prevY - this.cY) ) < this.config.sensitivity) {

    elem2?.removeEventListener('mousemove', getterGet(_mouseTrack, keyid_));
    //delete this.timeoutId;
    getterDelete(_timeoutId, keyid_);

    if (elem2.isActive) {
      this.config.onExit(elem2);
      //getterRunFn(_onExit, this, this.config.onExit).call(elem2);
      elem2.isActive = false;
    }
    // set hoverIntent state as active for this element (permits `out` handler to trigger)
    elem2.isActive = true;
    // overwrite old mouseenter event coordinates with most recent pointer position
    this.ev.pageX = this.cX;
    this.ev.pageY = this.cY;
    delete this.prevX;
    delete this.prevY;
    // trigger hover
    return this.config.onEnter(elem2);
    //return getterRunFn(_onEnter, this, this.config.onEnter).call(elem2);
    // elem2?.addEventListener('mouseleave', this._mouseleaveHandler );
  } else {
    //  set previous coordinates for next comparison
    this.prevX = this.cX;
    this.prevY = this.cY;
    // use self-calling timeout, guarantees intervals are spaced out properly (avoids JavaScript timer bugs)
    getterAdd(_timeoutId, keyid_, setTimeout(() => {
      getterRunFn(_mouseCompare, keyid_, mouseCompare_fn).call(this, elem2, keyid_);
    }, this.config.interval), true);
    // this.timeoutId = setTimeout(() => {
    //   getterRunFn(_mouseCompare, this, mouseCompare_fn).call(this);
    // }, this.config.interval);
  }
};
mouseenterHandler_fn = function(elem2, keyid_) {
  // do nothing if already active
  //clearTimeout(this.pollTimer);
  if (elem2.isActive) {
    //clearTimeout(this.exitTimer);
    return;
  }
  // set "previous" X and Y position based on initial entry point
  this.prevX = this.ev.pageX;
  this.prevY = this.ev.pageY;

  // update "current" X and Y position based on mousemove
  elem2?.removeEventListener('mousemove', getterGet(_mouseTrack, keyid_));
  elem2?.addEventListener('mousemove', getterGet(_mouseTrack, keyid_, mouseTrack_fn.bind(this)));

  // start polling interval (self-calling timeout) to compare mouse coordinates over time
  // this.timeoutId = setTimeout(() => {
  //   getterRunFn(_mouseCompare, this, mouseCompare_fn).call(this);
  // }, this.config.interval);
  getterAdd(_timeoutId, keyid_, setTimeout(() => {
    getterRunFn(_mouseCompare, keyid_, mouseCompare_fn).call(this, elem2, keyid_);
  }, this.config.interval), true);
};
mouseleaveHandler_fn = function(elem2, keyid_) {
  //clearTimeout(this.exitTimer);
  // do nothing if not already active
  if (!elem2.isActive) return;
  //clearTimeout(this.pollTimer);
  // unbind expensive mousemove event
  elem2?.removeEventListener('mousemove', getterGet(_mouseTrack, keyid_));
  // this.timeoutId = setTimeout(() => {
  //   this.config.onExit(elem2);
  //   elem2.isActive = false;
  //   //elem2?.removeEventListener('mouseleave', this._mouseleaveHandler );
  // }, this.config.exitDelay);
  getterAdd(_timeoutId, keyid_, setTimeout(() => {
    this.config.onExit(elem2);
    //getterRunFn(_onExit, this, this.config.onExit).call(elem2);
    //console.log('elem2', elem2, this.config)
    elem2.isActive = false;
  }, this.config.exitDelay), true);
};
handleHover_fn = function(keyid_, e) {
  // cloned event to pass to handlers (copy required for event object to be passed in IE)
  this.ev = Object.assign({}, e);
  // clear any existing timeout
  //if (this.timeoutId) { this.timeoutId = clearTimeout(this.timeoutId); }
  getterAdd(_timeoutId, keyid_, clearTimeout(getterGet(_timeoutId, keyid_)), true);
  getterRunFn((e.type === 'mouseenter') ? _mouseenterHandler : _mouseleaveHandler , keyid_, (e.type === 'mouseenter') ? mouseenterHandler_fn : mouseleaveHandler_fn ).call(this, getterGet(_elem2, keyid_), keyid_);
};
// 1. Component carousel
// https://codesandbox.io/s/embla-carousel-github-issue-39-forked-p6sn2g?file=/src/css/embla.css
// https://www.embla-carousel.com/plugins/auto-height
import { Carousel, ClassNames, AutoHeight, navUICenter, Autoplay, navHandlers, dotHandlers, FocusTrap, Delegate, animate, scroll, timeline, inView, stagger } from 'vendor';
//import ClassNames from 'slider-autoplay'
Carousel.globalOptions = { direction: getDir }

var _slider_classes = {
  noSlides   : 'is-no-slides',
  prepared   : 'is--prepared',
  enabled    : 'is--enabled'
},
_slider_defaults = {
  loop: false,
  align: 'start',
  containScroll: 'trimSnaps', //keepSnaps
  skipSnaps: true,
  watchSlides: false,
  //watchResize: false,
  // watchResize: (sliderApi) => {
  //   this.classList.remove(_slider_classes.enabled);
  //   return true;
  // },
  watchDrag: 'smart',
  slidesToScroll: 'auto',
  inViewThreshold: 0.5, // 0.25 A high view threshold is recommended.
  classNames: true, // nathan custom
  autoHeight: false, // nathan custom
  autoPlay: 0, // nathan custom
  //stopOnInteraction: false,
  pauseOnHover: false,
  // isMedia: false, // nathan custom
  // thumbNav: false, // nathan custom
  // thumbVertical: false, // nathan custom
  navUI: false, // nathan custom
  navUICenter: false, // nathan custom
  dotUI: false, // nathan custom
  controlUI: false, // nathan custom
  //sliderApi: false, // nathan custom
  a11ySlide: true, // nathan custom
  a11yKeyBoard: true, // nathan custom
  a11yControls: true, // nathan custom
  // max: true, // nathan custom, option of navUICenter
  inView: 'is-in-view'
},
_delegate1, _control_ui, control_ui_fn,
_control_slider, control_slider_fn,
_control_items,
_slider_api, _options_slider,
_toggle_slider_ready, toggle_slider_ready_fn,
_destroy_slider, destroy_slider_fn,
_on_select_slider, on_select_slider_fn,
str_slide = 'hdt-slider__slide';
//_on_settle_slider = new WeakSet(), on_settle_slider_fn;
class Slider extends HTMLElement {
  constructor() {
    super();
    getterAdd(_control_ui, this);
    getterAdd(_delegate1, this, new Delegate(document.body));
    getterAdd(_toggle_slider_ready, this);
    getterAdd(_destroy_slider, this);
    getterAdd(_on_select_slider, this);
    getterAdd(_control_slider, this);
    getterAdd(_options_slider, this, Object.assign( {}, _slider_defaults, JSON.parse(this.getAttribute("config") || '{}') ));
    getterAdd(_control_items, this, $$4(`[hdt-slider-controls][aria-controls="${this.id}"] > button`));
   // getterAdd(_on_settle_slider, this);

    if (getterGet(_options_slider, this).watchDrag == 'onlyTypeImage') {
      getterGet(_options_slider, this).watchDrag = (sliderApi, event) => {
        //console.log(sliderApi)
        const media = event.target.closest('[data-media-type]');
        return media ? media.getAttribute('data-media-type') == 'image' : true;
      }
    } else if (getterGet(_options_slider, this).watchDrag == 'smart') {
      getterGet(_options_slider, this).watchDrag = (sliderApi, event) => {
        //console.log(sliderApi)
        //return sliderApi.internalEngine().slideLooper.canLoop();
        return sliderApi.scrollSnapList().length > 1;
      }
    }
    // https://github.com/The4-Theme-Dev/Ecomus/issues/65
    if (getterGet(_options_slider, this).watchResize == '#65') {
      getterGet(_options_slider, this).watchResize = (sliderApi, entries) => {
        //console.log(sliderApi)
        for (const entry of entries) {
          //console.log('sss entry00', entry.contentRect.height, entry.target.prevHeight)
          if (sliderApi.containerNode() === entry.target && entry.contentRect.height != entry.target.prevHeight ) {
            entry.target.prevHeight = entry.contentRect.height;
            return true;
          } else if (sliderApi.containerNode() === entry.target) {
            return false;
          }
          //console.log('sss entry 1111')
          window.requestAnimationFrame(() => {
            sliderApi.reInit();
            sliderApi.emit('resize');
          })
          break;
        }
        return false;
      }
    }

    if (!this.id) this.id = getUID();
  }
  /**
   * scroll to custom
   */
  // scrollToTarget(target, bl) {
  //   getterGet(_slider_api, this).scrollTo(getterGet(_slider_api, this).slideNodes().indexOf(target), bl || !_matchMedia("motion"));
  // }
  // scrollToIndex(index, bl) {
  //   getterGet(_slider_api, this).scrollTo(parseInt(index), bl || !_matchMedia("motion"));
  // }
  goToTarget(target, bl) {
    this.goToIndex(getterGet(_slider_api, this).slideNodes().indexOf(target), bl || !_matchMedia("motion"));
  }
  goToIndex(slideIndex, bl) {
    let i, j = parseInt(slideIndex);
    const snapListLength = getterGet(_slider_api, this).scrollSnapList().length;
    if (getterGet(_slider_api, this).slideNodes().length !== snapListLength) {
      const {slideRegistry} = getterGet(_slider_api, this).internalEngine();
      for (i = 0; i < slideRegistry.length; i++) {
        //console.log(i, snapListLength - 1 )
        if (slideRegistry[i].indexOf(j) > -1) { j = i; break; }
      }
    }
    getterGet(_slider_api, this).scrollTo(Math.min(j, snapListLength - 1), bl || !_matchMedia("motion"));
  }
  get isActive() {
    return getterGet(_slider_api, this).internalEngine().options.active;
  }
  // get indexSelected() {
  //   return getterGet(_slider_api, this).selectedScrollSnap();
  // }
  reInit(options = {}) {
    getterGet(_slider_api, this).reInit(options);
  }

  connectedCallback() {

    // Adding plugins
    const plugins = [];
    if (getterGet(_options_slider, this).classNames) plugins.push( ClassNames({inView: 'is-in-view'}) );
    if (getterGet(_options_slider, this).autoHeight) plugins.push( AutoHeight() );
    if (getterGet(_options_slider, this).navUI && getterGet(_options_slider, this).navUICenter) plugins.push( navUICenter() ); // { max: getterGet(_options_slider, this).max}
    if (getterGet(_options_slider, this).autoPlay) {
      const autoplayOptions = {
        delay: getterGet(_options_slider, this).autoPlay,
        //stopOnInteraction: getterGet(_options_slider, this).stopOnInteraction,
        stopOnInteraction: false,
        stopOnMouseEnter: getterGet(_options_slider, this).pauseOnHover
      }
      plugins.push( Autoplay(autoplayOptions) );
    }
    getterAdd(_slider_api, this, Carousel($4('.hdt-slider__viewport', this) || this, getterGet(_options_slider, this), plugins));
    // Need test, debug
    // this.sliderApi = getterGet(_slider_api, this);
    //if (getterGet(_options_slider, this).sliderApi) this.sliderApi = getterGet(_slider_api, this);
    getterGet(_slider_api, this)
    .on("init", getterRunFn(_toggle_slider_ready, this, toggle_slider_ready_fn).bind(this))
    .on("resize", getterRunFn(_toggle_slider_ready, this, toggle_slider_ready_fn).bind(this))
    .on("reInit", getterRunFn(_toggle_slider_ready, this, toggle_slider_ready_fn).bind(this))
    .on("select", getterRunFn(_on_select_slider, this, on_select_slider_fn).bind(this))
    //.on("settle", getterRunFn(_on_settle_slider, this, on_settle_slider_fn).bind(this))
    .on("destroy", getterRunFn(_destroy_slider, this, destroy_slider_fn).bind(this));

    // Adding event
    if (getterGet(_options_slider, this).navUI) {
      const nextBtns = $$4(`button[name="next"][aria-controls="${this.id}"]`);
       $$4(`button[name="previous"][aria-controls="${this.id}"]`).forEach((prevBtn, index) => {
        if (prevBtn && nextBtns[index]) {
          const removePrevNextBtnsClickHandlers = navHandlers( getterGet(_slider_api, this), prevBtn, nextBtns[index]);
          getterGet(_slider_api, this).on('destroy', removePrevNextBtnsClickHandlers);
        }
      });
    }
    if (getterGet(_options_slider, this).dotUI) {
      $$4(`[hdt-slider-dots][aria-controls="${this.id}"]`).forEach((dotWrapp) => {
        if (dotWrapp) {
          const removeDotBtnsAndClickHandlers = dotHandlers( getterGet(_slider_api, this), dotWrapp );
          getterGet(_slider_api, this).on('destroy', removeDotBtnsAndClickHandlers);
        }
      });
    }
    if (getterGet(_options_slider, this).controlUI && getterGet(_control_items, this).length > 0) {
      getterGet(_delegate1,this).on("click", `[hdt-slider-controls][aria-controls="${this.id}"] > button`, getterRunFn(_control_slider, this, control_slider_fn).bind(this));
      getterGet(_slider_api, this)
      .on("init", getterRunFn(_control_ui, this, control_ui_fn).bind(this))
      .on("reInit", getterRunFn(_control_ui, this, control_ui_fn).bind(this))
      .on("select", getterRunFn(_control_ui, this, control_ui_fn).bind(this))
      .on("destroy", getterRunFn(_control_ui, this, control_ui_fn).bind(this));
    }
    if (this.hasAttribute('modal-reint') ) {
      $id4('hdt-quick-view-modal')?.addEventListener('dialog:beforeOpen', ()=> {
        this.reInit(getterGet(_options_slider, this));
      }, { once: true });
    }
    if (Shopify.designMode) {
      this.addEventListener(adnmEvts.select, (event) => {
        let target = event.target;
        //console.log('adnmEvts.select', event.detail, getterGet(_slider_api, this).slideNodes().indexOf(event.target))
        if (!target.classList.contains(str_slide)) target = target.closest(`.${str_slide}`);
        this.goToTarget( target, event.detail.load );
        // setTimeout(() => {
        //   getterGet(_slider_api, this).scrollTo( getterGet(_slider_api, this).slideNodes().indexOf(event.target), event.detail.load );
        // }, event.detail.load ? 10 : 0);
      });
    }
  }
  disconnectedCallback() {
    if (getterGet(_slider_api, this)) getterGet(_slider_api, this).destroy();
  }
}
_slider_api = new WeakMap();
_options_slider = new WeakMap();
_delegate1 = new WeakMap();
_control_items = new WeakMap();
_toggle_slider_ready = new WeakSet();
toggle_slider_ready_fn = function(sliderApi, event) {
  const isResizeEvent = (event === "resize");
  //console.log('event', event, sliderApi.rootNode() )
  const toggleClass = isResizeEvent ? "remove" : "add",
        isFade      = this.hasAttribute('isfade');
  this.classList[toggleClass](_slider_classes.enabled);
  //setTimeout(() => this.classList.add(_slider_classes.enabled));
  if (isResizeEvent && isFade ) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => { sliderApi.reInit(); }, 4);
  }
  if ( !isResizeEvent && isFade ) {
    // Inactivate transform
    sliderApi.internalEngine().translate.toggleActive(false);
    sliderApi.internalEngine().translate.clear();
  }
};
_destroy_slider = new WeakSet();
destroy_slider_fn= function() {
  //clearTimeout(this.timeout);
  this.classList.remove(_slider_classes.enabled);
  getterGet(_delegate1,this).off();
};
_control_ui = new WeakSet();
control_ui_fn = function(slider_api) {
  if (!this.isActive) return;
  const indexSelected = slider_api.selectedScrollSnap();
  getterGet(_control_items, this).forEach((item) => item.setAttribute("aria-current", item.value == indexSelected));
};
_control_slider = new WeakSet();
control_slider_fn = function(event, target) {
  if (target.getAttribute("aria-current") !== "true") this.goToIndex(target.value);
};
_on_select_slider = new WeakSet();
on_select_slider_fn = function(sliderApi, eventName) {
  //console.log(sliderApi, eventName)
  this.dispatchEvent(new CustomEvent(`${eventName}:slide`, { bubbles: false, detail: { sliderApi, eventName } }));
};
// on_settle_slider_fn = function(sliderApi, event) {
//   const { limit, location, scrollTo } = sliderApi.internalEngine();
//   if (location.get() > limit.max) {
//     scrollTo.index(0, 0);
//   }
//   if (location.get() < limit.min) {
//     scrollTo.index(sliderApi.scrollSnapList().length - 1, 1);
//   }
// };

class SliderLazy extends Slider {
  constructor() { super(); }
  connectedCallback() { }
  InitLazy() { super.connectedCallback(); }
};

var _slideshow_animate, slideshow_animate_fn;
class SlideShow extends Slider {
  constructor() {
    super();
    getterAdd(_slideshow_animate, this);
  }
  connectedCallback() {
    super.connectedCallback();
    getterGet(_slider_api, this).on( 'init', getterRunFn(_slideshow_animate, this, slideshow_animate_fn).bind(this) );
    getterGet(_slider_api, this).on( 'reInit', getterRunFn(_slideshow_animate, this, slideshow_animate_fn).bind(this) );
    getterGet(_slider_api, this).on( 'select', getterRunFn(_slideshow_animate, this, slideshow_animate_fn).bind(this) );
    getterGet(_slider_api, this).on( 'destroy', getterRunFn(_slideshow_animate, this, slideshow_animate_fn).bind(this) );
  }
  isVisible(element) {
    // https://stackoverflow.com/questions/1343237/how-to-check-elements-visibility-via-javascript
    return element.offsetWidth > 0 || element.offsetHeight > 0;;
  }
}
_slideshow_animate = new WeakSet();
slideshow_animate_fn = function(sliderApi) {
  const index = sliderApi.selectedScrollSnap(),
  prevIndex = sliderApi.previousScrollSnap(),
  reveals = $$4('[reval]', sliderApi.slideNodes()[index]),
  prevReveals = $$4('[reval]', sliderApi.slideNodes()[prevIndex]),
  revealsVisible = reveals.filter((el) => this.isVisible(el)),
  prevRevealsVisible = prevReveals.filter((el) => this.isVisible(el));
  if (revealsVisible.length == 0) return;
  animate(revealsVisible, {
    opacity: [0, 1], transform: ["translateY(150px)", "translateY(0)"]
  }, {
    duration: 0.25,
    easing: "ease",
    delay: stagger(0.15, { start: 0.4, easing: [0, 0.87, 0.58, 1] })
  });
  if (prevRevealsVisible.length > 0 && index != prevIndex) {
    animate(prevRevealsVisible, {
    opacity: [1, 0], transform: ["translateY(0)", "translateY(25px)"]
    }, {
      duration: 0.15,
      easing: "ease",
      delay: stagger(0.1, { start: 0.4, easing: [0, 0.87, 0.58, 1] })
    });
  }
};

var _slider_sync_control = new WeakMap(),
_slider_sync_select, slider_sync_select_fn,
_slider_sync_control_select, slider_sync_control_select_fn;
class SliderSync extends Slider {
  constructor() {
    super();
    getterAdd(_slider_sync_control, this, $id4(this.getAttribute("aria-controls")));
    getterAdd(_slider_sync_select, this);
    getterAdd(_slider_sync_control_select, this);
  }
  connectedCallback() {
    //console.log(super)
    super.connectedCallback();

    if ( !getterGet(_slider_api, getterGet(_slider_sync_control, this)) ) return;

    getterGet(_slider_api, getterGet(_slider_sync_control, this)).on( 'select', getterRunFn(_slider_sync_control_select, this, slider_sync_control_select_fn).bind(this) );
    getterGet(_slider_api, this).on( 'select', getterRunFn(_slider_sync_select, this, slider_sync_select_fn).bind(this) );

    getterGet(_slider_api, getterGet(_slider_sync_control, this)).on( 'destroy', () => {
      getterGet(_slider_api, this).off( 'select', getterRunFn(_slider_sync_select, this, slider_sync_select_fn).bind(this) );
    });
    getterGet(_slider_api, this).on( 'destroy', () => {
      getterGet(_slider_api, getterGet(_slider_sync_control, this)).off( 'select', getterRunFn(_slider_sync_control_select, this, slider_sync_control_select_fn).bind(this) );
    });
    // getterGet(_slider_api, getterGet(_slider_sync_control, this)).on("scroll", (sliderApi) => {
    //   console.log('sliderObservesApi scroll')
    //   const emblaMainLocation = sliderApi.internalEngine().location.get();
    //   const emblaCopyCatEngine = getterGet(_slider_api, this).internalEngine();

    //   emblaCopyCatEngine.translate.to(emblaMainLocation);
    //   emblaCopyCatEngine.location.set(emblaMainLocation);
    //   emblaCopyCatEngine.target.set(emblaMainLocation);
    //   emblaCopyCatEngine.scrollTo.distance(0, false);
    // });
    // getterGet(_slider_api, this).on("scroll", (sliderApi) => {
    //   console.log('sliderApi scroll')
    //   const emblaMainLocation = sliderApi.internalEngine().location.get();
    //   const emblaCopyCatEngine = getterGet(_slider_api, getterGet(_slider_sync_control, this)).internalEngine();

    //   emblaCopyCatEngine.translate.to(emblaMainLocation);
    //   emblaCopyCatEngine.location.set(emblaMainLocation);
    //   emblaCopyCatEngine.target.set(emblaMainLocation);
    //   emblaCopyCatEngine.scrollTo.distance(0, false);
    // });
  }
}
_slider_sync_select = new WeakSet();
slider_sync_select_fn = function(slider_api) {
  if (getterGet(_slider_api, getterGet(_slider_sync_control, this)).selectedScrollSnap() != slider_api.selectedScrollSnap()) getterGet(_slider_api, getterGet(_slider_sync_control, this)).scrollTo( slider_api.selectedScrollSnap() );
}
_slider_sync_control_select = new WeakSet();
slider_sync_control_select_fn = function(slider_api) {
  if (getterGet(_slider_api, this).selectedScrollSnap() != slider_api.selectedScrollSnap()) getterGet(_slider_api, this).scrollTo( slider_api.selectedScrollSnap() );
}

var _slider_thumbs_control = new WeakMap(),
_add_thumb_btns_click_handlers, add_thumb_btns_click_handlers_fn,
_add_toggle_thumb_btns_active, add_toggle_thumb_btns_active_fn;
class SlideThumb extends Slider {
  // constructor() {
  //   super();
  // }
  connectedCallback() {
    getterAdd(_slider_thumbs_control, this, $id4(this.getAttribute("aria-controls")));
    if (this.hasAttribute('stagger')) {
      animate(
        $$4('[reval]', this),
        {
          opacity: [0, 1],
          transform: ["scale(.5) rotate(90deg) skew(15deg)", "scale(1) rotate(0deg) skew(0deg)"]
        },
        {
          duration: 0.2,
          delay: stagger(0.3, { easing: "ease-out" })
        }
      ).finished.then(() => {
        this.classList.add('stagger-finished');
      });
    }
    if ( !getterGet(_slider_thumbs_control, this) ) return;
    super.connectedCallback();
    const sliderApiMain = getterGet(_slider_api, getterGet(_slider_thumbs_control, this)),
    sliderApiThumb = getterGet(_slider_api, this);
    if ( !_matchMedia("phone") && !_matchMedia("tablet") ) sliderApiThumb.containerNode().style.setProperty('max-height',`${sliderApiMain.slideNodes()[sliderApiMain.selectedScrollSnap()].clientHeight + 10}px`);
    getterAdd(_add_thumb_btns_click_handlers, this);
    getterAdd(_add_toggle_thumb_btns_active, this);

    const removeThumbBtnsClickHandlers = getterRunFn(_add_thumb_btns_click_handlers, this, add_thumb_btns_click_handlers_fn).call(this, sliderApiMain, sliderApiThumb);
    const removeToggleThumbBtnsActive = getterRunFn(_add_toggle_thumb_btns_active, this, add_toggle_thumb_btns_active_fn).call(this, sliderApiMain, sliderApiThumb);
    sliderApiMain.on('destroy', removeThumbBtnsClickHandlers).on('destroy', removeToggleThumbBtnsActive);
    sliderApiThumb.on('destroy', removeThumbBtnsClickHandlers).on('destroy', removeToggleThumbBtnsActive);
  }
}
_add_thumb_btns_click_handlers = new WeakSet();
add_thumb_btns_click_handlers_fn = function(_, sliderApiThumb) {
  const slides = $$4('.hdt-slider__slide', this);
  const scrollToIndex = (slideNode) => {
    const index = sliderApiThumb.slideNodes().indexOf(slideNode);
    if (index > -1) getterGet(_slider_thumbs_control, this).goToIndex(index)
  };
  slides.forEach( (slideNode) => slideNode.addEventListener('click', scrollToIndex.bind(this, slideNode), false) );
  return () => {
    slides.forEach((slideNode) => slideNode.removeEventListener('click', scrollToIndex.bind(this, slideNode), false) );
  }

  // $$4('.hdt-slider__slide', this).forEach((slideNode) => {
  //   slideNode.addEventListener('click', ()=> {
  //     const index = sliderApiThumb.slideNodes().indexOf(slideNode);
  //     if (index > -1) getterGet(_slider_thumbs_control, this).goToIndex(index)
  //     //if (index > -1) getterGet(_slider_thumbs_control, this).goToIndex(index)
  //   }, false)
  // });

  // return () => {
  //   // slidesThumbs.forEach((slideNode, index) => {
  //   //   slideNode.removeEventListener('click', scrollToIndex[index], false)
  //   // })
  //   $$4('.hdt-slider__slide', this).forEach((slideNode) => {
  //     slideNode.addEventListener('click', ()=> {
  //       const index = sliderApiThumb.slideNodes().indexOf(slideNode);
  //       if (index > -1) getterGet(_slider_thumbs_control, this).goToIndex(index)
  //     }, false)
  //   });
  // }
};
_add_toggle_thumb_btns_active = new WeakSet();
add_toggle_thumb_btns_active_fn = function(sliderApiMain, sliderApiThumb) {
  //const slidesThumbs = sliderApiThumb.slideNodes();
  const toggleThumbBtnsState = () => {
    this.goToIndex(sliderApiMain.selectedScrollSnap());
    //const previous = sliderApiMain.previousScrollSnap()
    //slidesThumbs[previous].classList.remove('is-thumb-selected');
    $4('.is-thumb-selected', this)?.classList.remove('is-thumb-selected');
    sliderApiThumb.slideNodes()[sliderApiMain.selectedScrollSnap()].classList.add('is-thumb-selected');
    //if ( !_matchMedia("phone") && !_matchMedia("tablet") ) sliderApiThumb.containerNode().style.setProperty('max-height',`${sliderApiMain.slideNodes()[sliderApiMain.selectedScrollSnap()].clientHeight + 10}px`);
  }

  sliderApiMain.on('select', toggleThumbBtnsState)
  sliderApiThumb.on('init', toggleThumbBtnsState)
  sliderApiThumb.on('reInit', toggleThumbBtnsState)

  return () => {
    sliderApiThumb.slideNodes()[sliderApiMain.selectedScrollSnap()].classList.remove('is-thumb-selected');
  }
};
var _slider_counter = new WeakMap(),
_update_total_counter, update_total_counter_fn,
_update_current_counter, update_current_counter_fn;
class SlideCounter extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_update_total_counter, this);
    getterAdd(_update_current_counter, this);
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    getterAdd(_slider_counter, this, $id4(this.getAttribute('slider')));

    if (!getterGet(_slider_counter, this)) return;
    getterGet(_slider_api, getterGet(_slider_counter, this)).on('init', getterRunFn(_update_total_counter, this, update_total_counter_fn).bind(this), { signal: this.#abortController.signal })
    getterGet(_slider_api, getterGet(_slider_counter, this)).on('reInit', getterRunFn(_update_total_counter, this, update_total_counter_fn).bind(this), { signal: this.#abortController.signal })
    getterGet(_slider_api, getterGet(_slider_counter, this)).on('select', getterRunFn(_update_current_counter, this, update_current_counter_fn).bind(this), { signal: this.#abortController.signal })
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get total() {
    return $4('[update-total]', this);
  }
  get current() {
    return this._current = this._current || $4('[update-current]', this);
  }
};
_update_total_counter = new WeakSet();
update_total_counter_fn = function(sliderApi) {
  if (!getterGet(_slider_counter, this).isActive) return;
  this.total.textContent = sliderApi.scrollSnapList().length;
  getterRunFn(_update_current_counter, this, update_current_counter_fn).call(this, sliderApi);
};
_update_current_counter = new WeakSet();
update_current_counter_fn = function(sliderApi) {
  this.current.textContent = sliderApi.selectedScrollSnap() + 1;
};

customElements.define('hdt-slider', Slider);
customElements.define('hdt-slider-lazy', SliderLazy);
customElements.define('hdt-slideshow', SlideShow);
customElements.define('hdt-slider-sync', SliderSync);
customElements.define('hdt-slider-thumb', SlideThumb);
customElements.define('hdt-slider-counter', SlideCounter);

// 2. Component scrollsnap
class Scrollnap extends HTMLElement {
  constructor() {
    super();
    this.slider = $4('[id^="Scroller-"]',this) || this;
    this.sliderItems = $$4('[id^="Scroll-"]',this);
    this.enableSliderLooping = false;
    this.currentPageElement = $4('.hdt-scrollsnap-counter--current',this);
    this.pageTotalElement = $4('.hdt-scrollsnap-counter--total',this);
    this.prevButton = $4('button[name="previous"]',this);
    this.nextButton = $4('button[name="next"]',this);
    this.dotButtons =  $$4('.hdt-scrollsnap-dot__link',this);
    this.sliderFirstItemNode = this.sliderItems[0];

    if (!this.slider) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    //this.setSlideVisibility();
    if (this.nextButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    if (this.dotButtons.length) {
      this.dotButtons.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    }
  }

  get isScrollable() {
    //this.scrollWidth !== this.clientWidth || this.scrollHeight !== this.clientHeight
    return this.slider.scrollWidth !== this.slider.clientWidth;
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
    this.classList.toggle("is-scrollable", this.isScrollable);
  }

  resetPages() {
    this.sliderItems = $$4('[id^="Scroll-"]', this);
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider) return;
    //if (!this.slider || !this.nextButton) return;
    //this.setSlideVisibility();
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.dotButtons.length) {
      this.dotButtons.forEach((link) => {
        link.classList.remove('hdt-scrollsnap-dot__link--active');
        link.removeAttribute('aria-current');
      });
      //console.log(this.currentPage)
      this.dotButtons[this.currentPage - 1]?.classList.add('hdt-scrollsnap-dot__link--active');
      this.dotButtons[this.currentPage - 1]?.setAttribute('aria-current', true);
    }

    if (this.enableSliderLooping || !this.nextButton ) return;
    //console.log(this.isSlideVisible(this.sliderItemsToShow[0]), this.slider.scrollLeft)
    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + step * this.sliderItemOffset : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.dotButtons.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.setSlidePosition(slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
      behavior: _matchMedia("motion") ? "smooth" : "auto"
    });
  }

  // setSlideVisibility(event) {
  //   this.sliderItemsToShow.forEach((item, index) => {
  //     const linkElements = item.querySelectorAll('a');
  //     if (index === this.currentPage - 1) {
  //       if (linkElements.length)
  //         linkElements.forEach((button) => {
  //           button.removeAttribute('tabindex');
  //         });
  //       item.setAttribute('aria-hidden', 'false');
  //       item.removeAttribute('tabindex');
  //     } else {
  //       if (linkElements.length)
  //         linkElements.forEach((button) => {
  //           button.setAttribute('tabindex', '-1');
  //         });
  //       item.setAttribute('aria-hidden', 'true');
  //       item.setAttribute('tabindex', '-1');
  //     }
  //   });
  //   this.wasClicked = false;
  // }

}
customElements.define('hdt-scrollsnap', Scrollnap);

class ScrollBar extends HTMLElement {
  connectedCallback() {
    if (!this.scrolledElement) return;
    this.scrolledElement.addEventListener("scroll", throttle(this._updateScrollProgress.bind(this)));
    if (window.ResizeObserver) {
      new ResizeObserver(this._updateScrollProgress.bind(this)).observe(this.scrolledElement);
    }
  }
  get scrolledElement() {
    return this._scrolledElement = this._scrolledElement || $id4(this.getAttribute("observes"));
  }
  _updateScrollProgress() {
    const scrollLeft = !isRTL ? this.scrolledElement.scrollLeft : Math.abs(this.scrolledElement.scrollLeft),
    advancement = (scrollLeft + this.scrolledElement.clientWidth) / this.scrolledElement.scrollWidth;
    this.style.setProperty("--scrollbar-progress", Math.max(0, Math.min(advancement, 1)).toFixed(6));
  }
};
customElements.define("hdt-scrollbar", ScrollBar);

// https://addmorescripts.github.io/hystModal/
var _delegate = new WeakMap(), _controller = new WeakMap(),
 _focusTrap, _config,
_updateSlot, updateSlot_fn,
_toggleClicked, toggleClicked_fn,
_locked, locked_fn, _isLocked,
//_scrollPosition,
_allowOutsideClick, allowOutsideClick_fn, _allowOutsideClickTouch, allowOutsideClickTouch_fn, _allowOutsideClickMouse, allowOutsideClickMouse_fn,
_originalParentBeforeAppend,
counterDialogOpened = 0;
class DialogBase extends HTMLElement {
  constructor() {
    super();
    getterAdd( _delegate, this, new Delegate(document.body));
    getterAdd( _controller, this, void 0);
    collectableAdd(this, _focusTrap, void 0);
    collectableAdd(this, _config, void 0);
    collectableAdd(this, _toggleClicked);
    collectableAdd(this, _updateSlot);
    collectableAdd(this, _originalParentBeforeAppend, void 0);
    collectableAdd(this, _allowOutsideClick);
    collectableAdd(this, _allowOutsideClickTouch);
    collectableAdd(this, _allowOutsideClickMouse);
    collectableAdd(this, _isLocked, false);
    collectableAdd(this, _locked);
    //getterAdd(_scrollPosition, this, 0);

    if (this.shadowDomTemplate) {
      this.attachShadow({ mode: "open" }).appendChild($id4(this.shadowDomTemplate).content.cloneNode(true));
      this.shadowRoot.addEventListener("slotchange", (event) => fnCheck(this, _updateSlot, updateSlot_fn).call(this, event.target));
    }
    this.addEventListener("dialog:forceClose", (event) => {
      this.closeDialog();
      event.stopPropagation();
    });
    // // for iOS 15, prevents re-hiding of footer
    // this.addEventListener('pointermove', e => {
    //   e.preventDefault()
    // })

    // // bonus for iOS 14, prevents re-hiding of footer
    // this.addEventListener('touchmove', e => {
    //   e.preventDefault()
    // })

  }

  static get observedAttributes() {
    return ["id", "open"];
  }
  updateBtbsOpen(btn) {
    if (this.id && btn) {
      btn.removeEventListener("click", getterRunFn(_toggleClicked, this, toggleClicked_fn).bind(this) );
      btn.addEventListener("click", getterRunFn(_toggleClicked, this, toggleClicked_fn).bind(this) );
    }
  }
  connectedCallback() {
    if (this.config.appendToBody == 'smart') this.config.appendToBody = _matchMedia("phone");
    if (this.config.noScroll == 'smart') this.config.noScroll = _matchMedia("phone");
    if (this.id) this.delegate.off().on("click", this.stringControls,  getterRunFn(_toggleClicked, this, toggleClicked_fn).bind(this) );
    collectableSet(this, _controller, new AbortController());
    this.setAttribute("role", "dialog");
    if (this.shadowDomTemplate) {
      this.selectorPartName("overlay")?.addEventListener("click", this.closeDialog.bind(this), { signal: this.abortController.signal });
      $$4("slot", this.shadowRoot).forEach((slot) => fnCheck(this, _updateSlot, updateSlot_fn).call(this, slot));
    }
    if (Shopify.designMode && !this.hasAttribute('un-detect')) {
      this.addEventListener(adnmEvts.select, (event) => this.openDialog(event.detail.load), { signal: this.abortController.signal });
      this.addEventListener(adnmEvts.deselect, () => this.closeDialog(false), { signal: this.abortController.signal });
      this._shopifySection = this._shopifySection || this.closest(".shopify-section");
      if (this._shopifySection) {
        if (this.hasAttribute("detect-adm-se-evt")) {
          this._shopifySection.addEventListener(adnmEvts.seSelect, (event) => this.openDialog(!event.detail.load), { signal: this.abortController.signal });
          this._shopifySection.addEventListener(adnmEvts.seDeselect, this.closeDialog.bind(this), { signal: this.abortController.signal });
        }
        this._shopifySection.addEventListener(adnmEvts.seUnload, () => this.remove(), { signal: this.abortController.signal });
      }
    }
  }

  disconnectedCallback() {
    this.abortController.abort();
    this.delegate.off();
    this.focusTrap?.deactivate({ onDeactivate: () => {} });
    if (collectableGet(this, _isLocked) ) {
      collectableSet(this, _isLocked, false);
      fnCheck(this, _locked, locked_fn).call(this);
    }
  }

  get delegate() {
    return getterGet(_delegate, this);
  }

  get abortController() {
    return getterGet(_controller, this);
  }

  get open() {
    return this.hasAttribute("open");
  }

  get defaultTemplate() {
    return null;
  }

  get shadowDomTemplate() {
    return this.getAttribute("template") || this.defaultTemplate;
  }

  get defaultConfig() {
    return {
      catchFocus: true, // If true – when modal window is opened, focus will looped on active elements inside modal. When modal window closing, focus returning on previous selector.
        preventScrollFocus: true, // By default, focus() will scroll to the element if not in viewport. It can produce unintended effects like scrolling back to the top of a modal. If set to true, no scroll will happen.
        allowOutsideClick: true,
      noScroll: true,  // If true - the scrolling will be blocked when the window is opened. If false, scrolling is not blocked (if the modal window is high, double scrolling may occur)
      appendToBody: false // If true - will add dialog to body
      //,reopenTrigger: false
    }
  }

  get userConfig() {
    return Object.assign(JSON.parse(this.getAttribute("config") || '{}'));
  }

  get config() {
    return collectableSet(this, _config, collectableGet(this, _config) || Object.assign( this.defaultConfig, this.userConfig ) );
  }

  // get noScroll() {
  //   return true;
  // }

  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      // case "id":
      //   if (newValue) {
      //     this.delegate.off().on("click", this.stringControls, getterRunFn(_toggleClicked, this, toggleClicked_fn).bind(this));
      //   }
      //   break;
      // case "closing":
      //   if (newValue === "immediate") {
      //     this.animateClose().finish();
      //   }
      //   break;

      case "open":
        collectableSet(this, _isLocked, this.open);

        this.allButton.forEach((btn) => btn.setAttribute("aria-expanded", newValue === null ? "false" : "true"));

        if (oldValue === null && (newValue === "" || newValue === "immediate")) {
          collectableSet(this, _originalParentBeforeAppend, null);
          this.style.setProperty("display", "block");
          this.style.zIndex = parseInt(this.config.zIndex || 999) + $$4('[open-dialog]').length;
          this.dispatchEvent(new CustomEvent("dialog:beforeOpen"));
          //console.log(this.config)
          if (this.config.appendToBody && this.parentElement !== document.body) {
            collectableSet(this, _originalParentBeforeAppend, this.parentElement);
            document.body.append(this);
            ++counterDialogOpened;
          }
          const animationControls = this.animateOpen();
          if (newValue === "immediate") {
            animationControls.finish();
          }
          animationControls.finished.then(() => {
            this.dispatchEvent(new CustomEvent("dialog:afterOpen"));
            this.setAttribute("opened",'');
          });
          if (this.config.catchFocus) {
            this.focusTrap.activate({
              checkCanFocusTrap: () => animationControls.finished
            });
          }
          if (this.config.noScroll) {
            ++counterDialogOpened;
            collectableSet(this, _isLocked, true);
            fnCheck(this, _locked, locked_fn).call(this);
            //html.classList.add("no-scroll");
          }
        } else if (oldValue !== null && newValue === null) {
          this.dispatchEvent(new CustomEvent("dialog:beforeClose"));
          this.removeAttribute("opened");

          const animationControls = this.animateClose();
          if (this.getAttribute('closing') === "immediate") {
            animationControls.finish();
          }
          const hidePromise = animationControls.finished;
          hidePromise.then(() => {
            this.dispatchEvent(new CustomEvent("dialog:doneClose"));
            if (this.parentElement === document.body && collectableGet(this, _originalParentBeforeAppend)) {
              collectableGet(this, _originalParentBeforeAppend).appendChild(this);
              collectableSet(this, _originalParentBeforeAppend, null);
            }
            this.style.setProperty("display", "none");
            this.dispatchEvent(new CustomEvent("dialog:afterClose"));
            this.style.removeProperty('z-index');
            this.removeAttribute("closing");
          });
          this.focusTrap?.deactivate({
            checkCanReturnFocus: () => hidePromise
          });
          if (this.config.noScroll) {
            collectableSet(this, _isLocked, false);
            fnCheck(this, _locked, locked_fn).call(this);
            //html.classList.toggle("no-scroll", --counterDialogOpened > 0);
          }
        }
        this.dispatchEvent(new CustomEvent("toggle", { bubbles: true }));
        break;
    }
  }

  openDialog(_animate = true) {
    if (this.open) return Promise.resolve();
    //console.log(counterDialogOpened)
    this.setAttribute("open", _animate ? "" : "immediate");
    this.setAttribute("open-dialog", "");
    return waitForEvent(this, "dialog:afterOpen");
  }

  closeDialog(_animate = true) {
    if (!this.open) return Promise.resolve();
    this.setAttribute("closing", _animate ? "" : "immediate");
    this.removeAttribute("open");
    this.removeAttribute("open-dialog");
    //this.style.removeProperty('z-index');
    return waitForEvent(this, "dialog:afterClose");
  }

  animateOpen() {
    return animate(this, {}, { duration: 0 });
  }

  animateClose() {
    return animate(this, {}, { duration: 0 });
  }

  /**
   * Decide which element to focus first when the dialog focus is trapped. By default, the first focusable element
   * will be focused, but this can be overridden by passing a selector in the "initial-focus" attribute
   */
  get initialFocus() {
    return this.hasAttribute("initial-focus") ? this.getAttribute("initial-focus") === "false" ? false : $4(this.getAttribute("initial-focus"), this) : this.hasAttribute("tabindex") ? this : $4('input:not([type="hidden"])', this) || false;
  }
  /**
   * When "clickOutsideDeactivates" is true, this method is called on the final click destination. If this method
   * returns true, then the dialog closes (if false, the dialog remains in its current state). By default, this
   * will close the dialog if a click is done outside the dialog. However, this may be overridden in children classes
   * to provide custom behavior (for instance, to only allow some elements to close the dialog)
   */
  hideForOutsideClickTarget(target) {
    return !this.contains(target);
  }
  /**
   * When "clickOutsideDeactivates" is set to true, this method allows to control which element, when clicked, allows
   * to pass-through and have its behavior being executed
   */
  allowOutsideClickForTarget(target) {
    return false;
  }

  /**
   * Get the focus trap element configured with all the other attributes
   */
  get focusTrap() {
   // console.log(this, this.shadowRoot)
    return collectableSet(
      this, _focusTrap, collectableGet(this, _focusTrap)
      ||
      new FocusTrap([this, this.shadowRoot], {
        onDeactivate: this.closeDialog.bind(this),
        allowOutsideClick: this.config.allowOutsideClick ? fnCheck(this, _allowOutsideClick, allowOutsideClick_fn).bind(this) : false,
        //allowOutsideClick: this.config.allowOutsideClick ? this.allowOutsideClick_fn.bind(this) : false,
        // allowOutsideClick: false,
        initialFocus: _matchMedia("supports-hover") ? this.initialFocus : false,
        fallbackFocus: this,
        preventScroll: this.config.preventScrollFocus
     })
    );
  }

  selectorPartName(name) {
    return this.shadowRoot?.querySelector(`[part="${name}"]`);
  }

  get stringControls() {
    return `[aria-controls="${this.id}"]:not([section-id])`;
  }

  /**
   * Get all the elements controlling this dialog (typically, button). An element controls this dialog if it has an
   * aria-controls attribute matching the ID of this dialog element
   */
  get allButton() {
    return $$4(this.stringControls, this.getRootNode());
  }

};
_isLocked = new WeakMap();
_config = new WeakMap();
_focusTrap = new WeakMap();
_toggleClicked = new WeakSet();
toggleClicked_fn = function(event) {
  event?.preventDefault();
  if (event) {
    const target = event.target;
    this.btnOpening = target.tagName === 'BUTTON' || target.tagName === 'A' ? target : target.closest('button') || target;
    if ( this.btnOpening.hasAttribute('close-dialog') ) $id4(this.btnOpening.getAttribute('close-dialog'))?.closeDialog();
    if ( this.btnOpening.hasAttribute('open-mylti') ) this.removeAttribute('open');
  }
  this.open ? this.closeDialog() : this.openDialog(true, this.btnOpening);
};
//_scrollPosition = new WeakMap();
_locked = new WeakSet();

// https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
// https://codepen.io/geoffgraham/pen/LogERe
// https://gist.github.com/grayghostvisuals/7669377
// https://pqina.nl/blog/how-to-prevent-scrolling-the-page-on-ios-safari/
//themeHDN.curPosLocked = 0; // current Position Locked
locked_fn = function() {
  //console.log('counterDialogOpened 1: ',counterDialogOpened)
  if (!collectableGet(this, _isLocked)) {
    if ( counterDialogOpened < 1 ) {
      --counterDialogOpened
      return;
    }
    //console.log('_isLocked: ')
    //html.classList.add("hdt-scroll-auto");
    html.classList.toggle("no-scroll", --counterDialogOpened > 0);
    //window.scrollTo(0, themeHDN.curPosLocked);
    //html.classList.remove("hdt-scroll-auto");
  } else {
    // if ( counterDialogOpened == 1  ) {
    //   themeHDN.curPosLocked = window.scrollY || document.body.scrollTop + (html && html.scrollTop || 0);
    //   html.style.setProperty("--scroll-y", `${-themeHDN.curPosLocked}px`);
    // }
    html.classList.add("no-scroll");
    // this.stickyHeader = this.stickyHeader || $4('hdt-sticky-header');
    // console.log( this.stickyHeader)
    // if (this.stickyHeader) this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
  }
};
_updateSlot = new WeakSet();
updateSlot_fn = function(slot) {
  if (!["header", "sticky", "body", "footer"].includes(slot.name)) return;
  slot.parentElement.hidden = slot.assignedElements({ flatten: true }).length === 0;
};
_originalParentBeforeAppend = new WeakMap();

_allowOutsideClick = new WeakSet();
allowOutsideClick_fn = function(event) {
  if ("TouchEvent" in window && event instanceof TouchEvent) {
    return fnCheck(this, _allowOutsideClickTouch, allowOutsideClickTouch_fn).call(this, event);
  } else {
    return fnCheck(this, _allowOutsideClickMouse, allowOutsideClickMouse_fn).call(this, event);
  }
};
_allowOutsideClickTouch = new WeakSet();
allowOutsideClickTouch_fn = function(event) {
  event.target.addEventListener("touchend", (subEvent) => {
    const endTarget = document.elementFromPoint(subEvent.changedTouches.item(0).clientX, subEvent.changedTouches.item(0).clientY);
    if (this.hideForOutsideClickTarget(endTarget)) {
      this.closeDialog();
    }
  }, { once: true, signal: this.abortController.signal });
  return this.allowOutsideClickForTarget(event.target);
};
_allowOutsideClickMouse = new WeakSet();
allowOutsideClickMouse_fn = function(event) {
  //console.log(event)
  if (event.type !== "click") {
    return false;
  }
  if (this.hideForOutsideClickTarget(event.target)) {
    this.closeDialog();
  }
  if (this.allowOutsideClickForTarget(event.target)) {
    return true;
  }
  let target = event.target, closestControl = event.target.closest("[aria-controls]");
  if (closestControl && closestControl.getAttribute("aria-controls") === this.id) {
    target = closestControl;
  }
  return this.id !== target.getAttribute("aria-controls");
};

customElements.define("hdt-dialog", DialogBase);

class wrappCloseBtn extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", () => this.dispatchEvent(new CustomEvent("dialog:forceClose", { bubbles: true, cancelable: true, composed: true })));
  }
};
customElements.define("wrapp-close-btn", wrappCloseBtn);

class cartOpenable extends DialogBase {
  animateOpen() {
    let content = this.selectorPartName('content'),
    overlay = this.selectorPartName('overlay');
    return timeline([
      [overlay, { opacity: [0, 1] }, { duration: 0.15 }],
      [content, { transform: ["translateY(100%)", "translateY(0)"] }, { duration: 0.2, easing: "ease-in", at: "-0.075"  }]
    ]);
    //animate(this, { transform: ["translateY(100%)", "translateY(0)"] }, { duration: 0.2, easing: "ease-in" });
  }
  animateClose() {
    let content = this.selectorPartName('content'),
    overlay = this.selectorPartName('overlay');
    return timeline([
      [content, { transform: ["translateY(0)", "translateY(100%)"] }, { duration: 0.2, easing: "ease-out" }],
      [overlay, { opacity: [1, 0] }, { duration: 0.15, at: "-0.1" }]
    ]);
    //return animate(this, { transform: ["translateY(0)", "translateY(100%)"] }, { duration: 0.2, easing: "ease-in" });
  }
};
customElements.define("hdt-cart-openable", cartOpenable);

import { computePosition, shift, flip, offset, arrow } from 'vendor';
// https://floating-ui.com/docs/misc#3d-transforms
var _roundByDPR, roundByDPR_fn,
_translateByDPR, translateByDPR_fn,
_init, init_fn,
_dpr;
var updatePositionFloatingEl = function(button, floatingEl, arrowEl, _placement, useTranslate = true, _offset = 16, _staticSide = '-8px') {

    // this.arrplacementRTL = {
    //   'left': 'right',
    //   'left-start': 'right-start',
    //   'left-end': 'right-end',
    //   'right': 'left',
    //   'right-start': 'left-start',
    //   'right-end': 'left-end'
    // };
    //button._this = button._this || { button };
    getterAdd(_init, this);
    getterAdd(_translateByDPR, this);
    getterAdd(_roundByDPR, this);
    getterRunFn(_init, this, init_fn).call(this, button, floatingEl, arrowEl, _placement, useTranslate, _offset, _staticSide);
    //console.log(_init, _translateByDPR, _roundByDPR)
  }
  // getPlacement(placement) {
  //   return isRTL ? (this.arrplacementRTL[placement] || placement) : placement;
  // }
_dpr = new Map();
getterAdd(_dpr, _thu, window.devicePixelRatio || 1);
_roundByDPR = new WeakSet();
_translateByDPR = new WeakSet();
_init = new WeakSet();
roundByDPR_fn = function(value) {
  return Math.round(value * getterGet(_dpr, _thu)) / getterGet(_dpr, _thu);
};
translateByDPR_fn = function(x, y) {
  return getterGet(_dpr, _thu) > 1 ? `translate3d(${getterRunFn(_roundByDPR, this, roundByDPR_fn).call(this, x)}px,${getterRunFn(_roundByDPR, this, roundByDPR_fn).call(this, y)}px,0)` : `translate(${getterRunFn(_roundByDPR, this, roundByDPR_fn).call(this, x)}px,${getterRunFn(_roundByDPR, this, roundByDPR_fn).call(this, y)}px)`;
};
init_fn = function(button, floatingEl, arrowEl, _placement, useTranslate, _offset, _staticSide) {
  computePosition(button, floatingEl, {
    //placement: getPlacement(_placement),
    placement: _placement,
    middleware: [
      offset(parseInt(_offset)),
      flip({
        //fallbackPlacements: ['left', 'right', 'top', 'bottom'],
        fallbackPlacements: ['top', 'bottom'],
      }),
      shift({padding: 0}),
      arrow({
        element: arrowEl,
      }),
    ]
  }).then(({x, y, placement, middlewareData}) => {
    if (useTranslate) {
      this.objStyle = {
        top: '0',
        left: '0',
        transform: getterRunFn(_translateByDPR, this, translateByDPR_fn).call(this, x, y),
      }
    } else {
      this.objStyle = {
        left: `${x}px`,
        top: `${y}px`,
      };
    }
    Object.assign(floatingEl.style, this.objStyle);
    //console.log(middlewareData.arrow)
    if (middlewareData.arrow && arrowEl) {
      const {x: arrowX, y: arrowY} = middlewareData.arrow;
      const staticSide = {
        top: 'bottom',
        right: 'left',
        bottom: 'top',
        left: 'right',
      }[placement.split('-')[0]];

      Object.assign(arrowEl.style, {
        left: arrowX != null ? `${arrowX}px` : '',
        top: arrowY != null ? `${arrowY}px` : '',
        right: '',
        bottom: '',
        [staticSide]: _staticSide,
      });
    }

  });
};

class Popover extends DialogBase {
  connectedCallback() {
    super.connectedCallback();
    this.allButton.forEach((control) => control.setAttribute("aria-haspopup", "dialog"));
    if (this.config.closeRichlistSelect) {
      this.addEventListener("richlist:select", this.closeDialog, { signal: this.abortController.signal });
    }
  }

  get defaultTemplate() {
    return 'hdt-tmp-popover';
  }

  get userConfig() {
    return Object.assign(
      { noScroll: 'smart', appendToBody: 'smart' }, JSON.parse(this.getAttribute("config") || '{}')
    );
    // return Object.assign(
    //   JSON.parse(this.getAttribute("config") || '{}'),
    //   { noScroll: _matchMedia("phone"), appendToBody: _matchMedia("phone")}
    // );
  }

  get placement() {
    return this.getAttribute("placement") || 'bottom';
  }
  get arrowEl() {
    return this.selectorPartName('arrow');
  }
  updatePos() {
    updatePositionFloatingEl.call(this, this.btnOpening, this, this.arrowEl, this.placement);
  }

  animateOpen() {
    let content = this.selectorPartName('content'),
    closeButton = this.selectorPartName('outside-close-button');
    this.style.display = "block";
    //console.log('isPhone:', _matchMedia("phone"))
    if (_matchMedia("phone")) {
      Object.assign(this.style, {
        top: null,
        left: '0px',
        right: null,
        bottom: '0px',
        transform: null,
      });
      // this.style.left = "0px";
      // this.style.right = null;
      // this.style.bottom = "0px";
      // this.style.top = null;
      // this.style.transform = null;
      return timeline([
        [this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.15 }],
        [content, { clipPath: ["inset(100% 0 0 0 round 8px)", "inset(0 0 0 0 round 8px"] }, { duration: 0.4, easing: [0.86, 0, 0.07, 1] }],
        [content.children, { opacity: [0, 1] }, { duration: 0.15 }],
        [closeButton, { opacity: [0, 1] }, { at: "<", duration: 0.15 }]
      ]);
    } else {
      //console.log(this.btnOpening)
     this.updatePos();
      return timeline([
        [this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.15 }],
        [content, { clipPath: "none" }, { at: "<", duration: 0 }],
        [content.children, { opacity: 1 }, { at: "<", duration: 0 }]
      ]);
    }
  }

  animateClose() {
    if (_matchMedia("phone")) {
      let content = this.selectorPartName('content'),
      closeButton = this.selectorPartName('outside-close-button');
      return timeline([
        [closeButton, { opacity: [null, 0] }, { duration: 0.15 }],
        [content.children, { opacity: [null, 0] }, { at: "<", duration: 0.15 }],
        [content, { clipPath: [null, "inset(100% 0 0 0 round 8px)"] }, { duration: 0.4, easing: [0.86, 0, 0.07, 1] }],
        [this, { opacity: [null, 0], visibility: ["visible", "hidden"] }, { duration: 0.15 }]
      ]);
    } else {
      return timeline(this, { opacity: [null, 0], visibility: ["visible", "hidden"], transform: ["translateY(0)", "translateY(25%)"] }, { duration: 0.15 });
    }
  }
}
customElements.define("hdt-popover", Popover);

var _find_title, find_title_fn,
_tooltip_ids,
_create_tooltip, create_tooltip_fn,
_tooltip_thiss,
dt_original_title = 'data-original-title';
// https://kazzkiq.github.io/balloon.css/
// class baseTooltip extends HTMLElement {
//   constructor() {
//     super();
//     if (this.placement == 'none') return;
//     getterAdd(_find_title, this);
//     getterAdd(_create_tooltip, this);
//     getterAdd(_tooltip_ids, this, getUID());
//     //$id4(getterGet(_tooltip_ids, this))
//   }
//   connectedCallback() {
//     // run on mobile
//     // this.addEventListener("touchstart", this.onEnter.bind(this, this));
//     // this.addEventListener("touchend", this.onExit.bind(this));
//     if (_matchMedia('supports-hover') && this.placement != 'none') {
//       new HoverIntent(
//         this,
//         {
//           onEnter: this.onEnter.bind(this),
//           onExit: this.onExit.bind(this),
//           exitDelay: 0, interval: 80, sensitivity: 6
//         },
//         this,
//       );
//     }
//   }
//   disconnectedCallback() {
//     $id4(getterGet(_tooltip_ids, this))?.remove();
//   }

//   get placement() {
//     return this.getAttribute("placement") || 'bottom';
//   }
//   get arrowEl() {
//     return $4('.hdt-tooltip__arrow', $id4(getterGet(_tooltip_ids, this)));
//   }
//   onEnter() {
//     getterRunFn(_create_tooltip, this, create_tooltip_fn).call(this, getterGet(_tooltip_ids, this), getterRunFn(_find_title, this, find_title_fn).call(this));
//     updatePositionFloatingEl.call(this, this, $id4(getterGet(_tooltip_ids, this)), this.arrowEl, this.placement, true, 6, '-4px');
//   }
//   onExit() {
//     $id4(getterGet(_tooltip_ids, this))?.remove();
//   }
// };
_tooltip_thiss = new WeakMap();
class btnTooltip extends HTMLElement {
  constructor() {
    super();
    getterAdd(_find_title, this);
    getterAdd(_create_tooltip, this);
    getterAdd(_tooltip_ids, this, getUID());
  }
  connectedCallback() {
    // run on mobile
    // this.addEventListener("touchstart", this.onEnter.bind(this, this));
    // this.addEventListener("touchend", this.onExit.bind(this));
    if (_matchMedia('supports-hover') && this.placement != 'none') {
      new HoverIntent(
        this,
        {
          onEnter: this.onEnter.bind(this),
          onExit: this.onExit.bind(this),
          exitDelay: 0, interval: 80, sensitivity: 6
        },
        this,
      );
    }
  }
  disconnectedCallback() {
    $id4(getterGet(_tooltip_ids, this))?.remove();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue != newValue && oldValue !== null) {
      this.dispatchEvent(new CustomEvent('theme4:update:tooltip', {
        bubbles: true, detail : 'the4'
      }));
    }
  }
  onEnter = () => {
    if (this.innerText.length && this.hasAttribute('will-hidden-txt')) return;
    this.controller = new AbortController();
    getterRunFn(_create_tooltip, this, create_tooltip_fn).call(this, getterGet(_tooltip_ids, this), getterRunFn(_find_title, this, find_title_fn).call(this));
    const $tooltip_id = $id4(getterGet(_tooltip_ids, this));
    updatePositionFloatingEl.call(this, this, $tooltip_id, this.arrowEl, this.placement, true, 6, '-4px');
    this.addEventListener('theme4:update:tooltip', (e) =>  {
      $4('.hdt-tooltip__inner', $tooltip_id).textContent = getterRunFn(_find_title, this, find_title_fn).call(this);
      updatePositionFloatingEl.call(this, this, $tooltip_id, this.arrowEl, this.placement, true, 6, '-4px');
    }, { signal: this.controller.signal });
  }
  onExit = () => {
    const $tooltip_id = $id4(getterGet(_tooltip_ids, this));
    if ($tooltip_id) {
      this.controller.abort();
      $tooltip_id.remove();
    }
  }
  get placement() {
    return this.getAttribute("placement") || 'bottom';
  }
  get arrowEl() {
    return $4('.hdt-tooltip__arrow', $id4(getterGet(_tooltip_ids, this)));
  }
}
// class labelTooltip extends HTMLElement {
//   constructor() {
//     super();
//     this.baseTooltip = new BaseTooltip(this);
//   }
//   connectedCallback() {
//     this.baseTooltip.connectedCallback();
//   }
//   disconnectedCallback() {
//     this.baseTooltip.disconnectedCallback();
//   }
// }
// class linkTooltip extends HTMLElement {
//   constructor() {
//     super();
//     this.baseTooltip = new BaseTooltip(this);
//   }
//   connectedCallback() {
//     this.baseTooltip.connectedCallback();
//   }
//   disconnectedCallback() {
//     this.baseTooltip.disconnectedCallback();
//   }
// }
_tooltip_ids = new WeakMap();
_find_title = new WeakSet();
find_title_fn = function() {

  if ( this.hasAttribute('data-txt-tt')) return this.getAttribute('data-txt-tt');

  const firstElementChild = this.firstElementChild || this;
  let text = ($4('[tt-title]', this) || this.lastElementChild || this).textContent;
  // if (this.hasAttribute('title') && typeof this.getAttribute(dt_original_title) != 'string') {
  if (firstElementChild.hasAttribute('aria-label') ) {
    text = firstElementChild.getAttribute('aria-label');
  } else if (firstElementChild.hasAttribute(dt_original_title) ) {
    text = firstElementChild.getAttribute(dt_original_title);
  } else if ( firstElementChild.hasAttribute('title') && !firstElementChild.hasAttribute(dt_original_title)) {
     text = firstElementChild.getAttribute('title') || '';
     firstElementChild.setAttribute(dt_original_title, text);
     firstElementChild.setAttribute('title', '')
  }
  if (!this.hasAttribute('tt-dynamic')) this.setAttribute('data-txt-tt', (text || '').trim());

  return text;
};
_create_tooltip = new WeakSet();
create_tooltip_fn = function(id, title) {
  document.body.append(document.createRange().createContextualFragment(`<hdt-tooltip-dialog id="${id}" class="hdt-tooltip" role="tooltip"><div class="hdt-tooltip__arrow"></div><div class="hdt-tooltip__inner">${title}</div></hdt-tooltip-dialog>`));
};
class Tooltip extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    animate(this, { opacity: [0, .9], visibility: ["visible", "visible"] }, { duration: .3, easing: "ease" });
  }
  //disconnectedCallback() {}
}
customElements.define("hdt-tooltip", btnTooltip);
// customElements.define("hdt-label-tooltip", labelTooltip);
// customElements.define("hdt-a-tooltip", linkTooltip);
customElements.define("hdt-tooltip-dialog", Tooltip);

var _onOptionClicked, onOptionClicked_fn, _onKeyDown, onKeyDown_fn;
class Richlist extends HTMLElement {
  constructor() {
    super();
    collectableAdd(this, _onOptionClicked);
    collectableAdd(this, _onKeyDown);
    this.addEventListener("keydown", fnCheck(this, _onKeyDown, onKeyDown_fn));
  }
  connectedCallback() {
    $$4('[role="option"]',this).forEach((option) => {
      option.addEventListener("click", fnCheck(this, _onOptionClicked, onOptionClicked_fn).bind(this));
    });
  }
  static get observedAttributes() {
    return ["selected"];
  }
  /**
   * @param {string} value
   */
  set selected(value) {
    this.setAttribute("selected", value);
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "selected" && oldValue !== null && newValue !== oldValue) {
      $$4('[role="option"]',this).forEach((option) => {
        if (option.value === newValue) {
          option.setAttribute("aria-selected", "true");
          $$4(`[aria-owns="${this.id}"]`).forEach((btnOwn) => {
            const btnText = $4('[change-text]', btnOwn),
            _btnText = btnText || btnOwn;
            _btnText.textContent = option.getAttribute("title") || option.innerText || option.value;
          });
          option.dispatchEvent(new CustomEvent("richlist:change", {
            bubbles: true,
            detail: {
              value: option.value
            }
          }));
        } else {
          option.setAttribute("aria-selected", "false");
        }
      });
    }
  }

}
_onOptionClicked = new WeakSet();
onOptionClicked_fn = function(event) {
  //console.log(event)
  const value = event.currentTarget.value;
  this.selected = value;
  event.currentTarget.dispatchEvent(new CustomEvent("richlist:select", {
    bubbles: true,
    detail: { value }
  }));
};
_onKeyDown = new WeakSet();
onKeyDown_fn = function(event) {
  if (event.key === "ArrowUp") {
    event.target.previousElementSibling?.focus();
    event.preventDefault();
  } else if (event.key === "ArrowDown") {
    event.target.nextElementSibling?.focus();
    event.preventDefault();
  }
};
customElements.define("hdt-richlist", Richlist);

class Modal extends DialogBase {
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("aria-modal", "true");
  }

  get effect() {
    return this.getAttribute('effect') || 'fade';
  }

  get defaultTemplate() {
    return 'hdt-tmp-modal';
  }
  animateOpen() {
    if (!_matchMedia('phone')) {
      return (this.effect == 'fade') ?
      animate(this, { opacity: [0, 1] }, { duration: 0.2 }) :
      timeline([
        [this.selectorPartName("overlay"), { opacity: [0, 1] }, { duration: 0.2, easing: [0.645, 0.045, 0.355, 1] }],
        [this.selectorPartName("content"), { transform: ["translateX(-200px)", "translateX(0)"], opacity: [0, 1] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: "<" }],
        [this.selectorPartName("close-button"), { opacity: [0, 1] }, { duration: 0.2, easing: [0.645, 0.045, 0.355, 1] }]
      ]);
      //return animate(this, { opacity: [0, 1] }, { duration: 0.2 });
    } else {
      return timeline([
        [this.selectorPartName("overlay"), { opacity: [0, 1] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] }],
        [this.selectorPartName("content"), { transform: ["translateY(100%)", "translateY(0)"] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: "<" }]
      ]);
    }
  }
  animateClose() {
    if (!_matchMedia('phone')) {
      return (this.effect == 'fade') ?
      animate(this, { opacity: [1, 0] }, { duration: 0.2 }) :
      timeline([
        [this.selectorPartName("overlay"), { opacity: [1, 0] }, { duration: 0.2, easing: [0.645, 0.045, 0.355, 1] }],
        [this.selectorPartName("content"), { transform: ["translateX(0)", "translateX(200px)"], opacity: [1, 0] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: "<" }],
        [this.selectorPartName("close-button"), { opacity: [1, 0] }, { duration: 0.2, easing: [0.645, 0.045, 0.355, 1] }]
      ]);
      //return animate(this, { opacity: [1, 0] }, { duration: 0.2 });
    } else {
      return timeline([
        [this.selectorPartName("overlay"), { opacity: [1, 0] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] }],
        [this.selectorPartName("content"), { transform: ["translateY(0)", "translateY(100%)"] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: "<" }]
      ]);
    }
  }
}
customElements.define("hdt-modal", Modal);

class Drawer extends Modal {
  get defaultTemplate() {
    return 'hdt-tmp-drawer';
  }
  get effect() {
    let effectLg = this.getAttribute('effect-lg');
    return (effectLg && !_matchMedia('phone') && !_matchMedia('tablet') ) ? effectLg : (this.getAttribute('effect') || 'left');
  }
  get codeEffect() {
    switch (this.effect) {
      case 'left':
        return ["translateX(calc(var(--value-logical-flip) * -100%))", "translateX(0)"];
      case 'right':
        return ["translateX(calc(var(--value-logical-flip) * 100%))", "translateX(0)"];
      case 'top':
        return ["translateY(-100%)", "translateY(0)"];
      default:
        // bottom
        return ["translateY(100%)", "translateY(0)"];
    }
  }
  animateOpen() {
    this.selectorPartName("content").style.marginInlineStart = this.effect === "right" ? "auto" : 0;
    const transform = this.codeEffect;
    return timeline([
      [this.selectorPartName("overlay"), { opacity: [0, 1] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] }],
      [this.selectorPartName("footer"), { opacity: [0, 1] }, { duration: 0.6, easing: [0.645, 0.045, 0.355, 1], at: "<" }],
      [this.selectorPartName("content"), { transform }, { duration: 0.3, at: "<",  easing: "ease" }],
      [this.selectorPartName("outside-close-button"), { opacity: [0, 1] }, { duration: 0.2, at: "<", easing: [0.645, 0.045, 0.355, 1] }]
    ]);
  }
  animateClose() {
    const transform = this.codeEffect.reverse();
    return timeline([
      [this.selectorPartName("footer"), { opacity: [1, 0] }, { duration: 0.6, easing: [0.645, 0.045, 0.355, 1] }],
      [this.selectorPartName("content"), { transform }, { duration: 0.3, at: "<",  easing: "ease"  }],
      [this.selectorPartName("outside-close-button"), { opacity: [1, 0] }, { duration: 0.2, at: "<", easing: [0.645, 0.045, 0.355, 1] }],
      [this.selectorPartName("overlay"), { opacity: [1, 0] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1], at: "<" }]
    ]);
  }
}
customElements.define("hdt-drawer", Drawer);

var _reveal, reveal_fn, _input, input_fn;
class BeforeAfter extends HTMLElement {
  constructor() {
    super();
    getterAdd(_reveal, this);
    getterAdd(_input, this);
    //console.log($4('.hdt-bf__range', this))
  }
  connectedCallback() {
    $4('.hdt-bf__range', this).addEventListener("input", getterRunFn( _input, this, input_fn).bind(this));
    this.beforeVal = $4('.hdt-bf__range', this).value;
    inView(this, getterRunFn(_reveal, this, reveal_fn).bind(this), { margin: "0px 0px -44% 0px" });
  }
}
_reveal = new WeakSet();
reveal_fn = function(info) {
  animate((progress) => {
    // this.style.getPropertyValue("--percent-val")
    this.style.setProperty("--percent-val", this.beforeVal * progress);
  }, { duration: 0.6, easing: [0.85, 0, 0.15, 1] });
};
_input = new WeakSet();
input_fn = function(e) {
  this.style.setProperty("--percent-val", e.target.value);
};
customElements.define("hdt-before-after", BeforeAfter);

//const aniHdt = 'hdt-visible-animate';
class Countdown extends HTMLElement {

  // https://codepen.io/SitePoint/pen/QpwRxz
  // flip demo https://codepen.io/creativeocean/pen/pWXgNG

  timezoneString = themeHDN.settings.shopTimezone ? ` GMT${themeHDN.settings.shopTimezone}` : "";

  constructor() {
    super();
    this.selectors = {
      "days": "[data-days]",
      "hours": "[data-hours]",
      "minutes": "[data-minutes]",
      "seconds": "[data-seconds]"
    }

    this.classes = {
      "enabled": "hdt-cd--enabled",
      "hide": "hdt-cd--hide",
      "complete": "hdt-cd--complete"
    }

    this.arrayMth = {
      "1": "january",
      "2": "february",
      "3": "march",
      "4": "april",
      "5": "may",
      "6": "june",
      "7": "july",
      "8": "august",
      "9": "september",
      "10": "october",
      "11": "november",
      "12": "december"
    }

    this.defaults = {
      "idTmp": null,
      "hasZero": true,
      "hideTimerOnComplete": true
    }
    cancelAnimationFrame(this.myReq);
    const options = Object.assign({}, this.defaults,  JSON.parse(this.getAttribute('config') || '{}'));
    this.date =  new Date(Date.parse(this.arrayMth[options.month] + ' ' + options.date + this.timezoneString));
    if (isNaN(this.date)) return;
    this.hideTimerOnComplete = options.hideTimerOnComplete;
    this.countDownTime = this.date.getTime();

    if (options.idTmp) {
      const idTmp = $id4(options.idTmp);
      if (idTmp) this.innerHTML = idTmp.innerHTML;
    }

    this.daysEl    = $4(this.selectors.days,this);
    this.hoursEl   = $4(this.selectors.hours,this);
    this.minutesEl = $4(this.selectors.minutes,this);
    this.secondsEl = $4(this.selectors.seconds,this);
    this.hasZero   = options.hasZero;
    this.playing   = false;

    //this.timerInterval = setInterval(this.timerLoop.bind(this), 1000);
    this.init();

    inView(this, (info) => {
      this.play();
      this.isInview = true;
      return (leaveInfo) =>  {
        this.pause();
        this.isInview = false;
      }
    }, { margin: "0px 0px 150px 0px" })

    // listen for visibility change event
    visibilitychangeFn({
      observes: this,
      play: this.play.bind(this),
      pause: this.pause.bind(this)
    });
    // this.myReq = requestAnimationFrame(this.timerLoop.bind(this));
    // this.classList.add(this.classes.enabled);
    //this.destroy();
  }

  init() {
    if (this.playing) return;
    if (!this.myReq) this.classList.add(this.classes.enabled);
    this.play();
  }
  // pad value with zero
  // pad(value) {
  //   return (this.padZero + value).slice(-2);
  // }
	// https://stackoverflow.com/questions/6466135/adding-extra-zeros-in-front-of-a-number-using-jquery
	// pad (str, max = 2) {
  //     str = str.toString();
  //     return (str.length < max) ? '0' + str : str;
	// }

  timerLoop() {
    //window.requestAnimationFrame(() => {
      // Get today's date and time
      const now = new Date().getTime(); // Find the distance between now and the count down date

      const distance = this.countDownTime - now; // Time calculations for days, hours, minutes and seconds

      const days    = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours   = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(distance % (1000 * 60) / 1000);

      if (distance < 0) {
        this.destroy();
        // this.daysEl?.updateValue(0, this.hasZero);
        // this.hoursEl?.updateValue(0, this.hasZero);
        // this.minutesEl?.updateValue(0, this.hasZero);
        // this.secondsEl?.updateValue(0, this.hasZero);

        // If the count down is finished, write some text
        this.classList.add(this.classes.complete);
        if (this.hideTimerOnComplete) {
          this.classList.add(this.classes.hide);
          // if (this.parentNode) {
          //   this.parentNode.classList.add(this.classes.hide);
          // }
        }

      } else {
        if (!this.daysEl) hours = hours + days * 24;
        this.daysEl?.updateValue(days, this.hasZero);
        this.hoursEl?.updateValue(hours, this.hasZero);
        this.minutesEl?.updateValue(minutes, this.hasZero);
        this.secondsEl?.updateValue(seconds, this.hasZero);
        this.myReq = requestAnimationFrame(this.timerLoop.bind(this));
      }

  }

  play() {
    if (this.playing) return;
    //console.log('play')
    this.myReq = requestAnimationFrame(this.timerLoop.bind(this));
    this.playing = true;
  }

  pause() {
    if (!this.playing) return;
    //console.log('pause')
    //this.timerInterval && clearInterval(this.timerInterval);
    cancelAnimationFrame(this.myReq);
    this.playing = false;
  }

  destroy() {
    //this.timerInterval && clearInterval(this.timerInterval);
    this.pause();
    this.classList.remove(this.classes.enabled);
  }

};
class CountdownAmount extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    let flipHtml = [...this.textContent].map(() => `<hdt-countdown-number part="number" effect="${ this.getAttribute("effect") }" style="display: inline-block">0</hdt-countdown-number>`);
    this.shadowRoot.appendChild(document.createRange().createContextualFragment(flipHtml.join("")));
  }
  updateValue(value, hasZero) {
    let numPad = Math.min(99, value).toString().padStart(2, "0");
    this.textContent = numPad;
    [...numPad].forEach((num, index) => {
      this.shadowRoot.children[index].setAttribute("number", num);
    });
    if (this.nextElementSibling && this.nextElementSibling.shadowRoot) {
      let i = 0;
      for (; i < 2; i++) {
        this.nextElementSibling.shadowRoot.children[i].setAttribute("amount", numPad);
      }
    }
    //this.nextElementSibling.setAttribute("amount", numPad);
    if (!hasZero) this.shadowRoot.children[0].style.display = (numPad < 10 ) ? 'none' : 'inline-block';
  }
};
class CountdownAmountNumber extends HTMLElement {
  static observedAttributes = ["number"];
  constructor() {
    super();
    // Effect config
    this.e = {
      //O: 0,
      Y: 0,
      S: 1,
      R: 0
    };
    this.runFrist = 0;

    switch(this.getAttribute("effect")) {
      case 'move_top':
        this.e.Y = -8;
        this.e.Y2 = 8;
        break;
      case 'move_bottom':
        this.e.Y = 6;
        this.e.Y2 = -6;
        break;
      case 'scale':
        this.e.S = .5;
        break;
      case 'rotate':
        this.e.R = 180;
        this.e.S = .68;
        break;
    }
    this.attachShadow({ mode: "open" }).appendChild(document.createRange().createContextualFragment("<div><slot></slot></div>"));
  }
  async attributeChangedCallback(name, oldValue, newValue) {
    ++this.runFrist;
    if (this.getAttribute("effect") == 'none' || (this.runFrist == 2)) {
      return this.textContent = newValue;
    }
    if (oldValue === null || oldValue === newValue) return;
    await animate(this.shadowRoot.firstElementChild, { opacity: [1, 0], transform: ["translateY(0) rotate(0deg) scale(1)", `translateY(${this.e.Y}px) rotate(${this.e.R}deg) scale(${this.e.S})`] }, { duration: 0.25, easing: [0.64, 0, 0.78, 0] }).finished;
    this.textContent = newValue;
    animate(this.shadowRoot.firstElementChild, { opacity: [0, 1], transform: [`translateY(${ this.e.Y2 || this.e.Y }px) rotate(${this.e.R}deg) scale(${this.e.S})`, "translateY(0) rotate(0deg) scale(1)"] }, { duration: 0.25, delay: 0.1, easing: [0.22, 1, 0.36, 1] });
  }
};
class CountdownText extends HTMLElement {
  static observedAttributes = ["amount"];
  constructor() {
    super();
    if (!this.hasAttribute('singular')) return;
    this.attachShadow({ mode: "open" });
    let i = 0;
    let textHtml = "";
    for (; i < 2; i++) {
      textHtml += `<hdt-countdown-unit ${ i ? 'singular' : 'plural'} part="unit" style="grid-area: 1 / -1; will-change: opacity; opacity: ${ i ? 0 : 1 };">${ i ? this.getAttribute('singular') : this.textContent }</hdt-countdown-unit>`;
    }
    this.shadowRoot.appendChild(document.createRange().createContextualFragment(textHtml));
  }
  // async attributeChangedCallback(name, oldValue, newValue) {
  //   if (oldValue === null || oldValue === newValue) {
  //     return;
  //   }
  //   this.shadowRoot.firstElementChild.style.opacity = (newValue == 1) ? 0 : 1;
  //   this.shadowRoot.lastElementChild.style.opacity = (newValue == 1) ? 1 : 0;
  // }
};
class CountdownUnit extends HTMLElement {
  static observedAttributes = ["amount"];
  constructor() {
    super();
  }
  async attributeChangedCallback(name, oldValue, newValue) {
    // if (oldValue === null || oldValue === newValue) {
    //   return;
    // }
    if (oldValue === newValue) {
      return;
    }
    // if ( this.hasAttribute('plural') ) {
    //   this.style.opacity = (newValue == 1) ? 0 : 1;
    // } else {
    //   this.style.opacity = (newValue == 1) ? 1 : 0;
    // }
    this.style.opacity = this.hasAttribute('plural') ? (newValue == 1) ? 0 : 1 : (newValue == 1) ? 1 : 0;
    // this.shadowRoot.firstElementChild.style.opacity = (newValue == 1) ? 0 : 1;
    // this.shadowRoot.lastElementChild.style.opacity = (newValue == 1) ? 1 : 0;
  }
};
customElements.define('hdt-countdown', Countdown);
customElements.define('hdt-countdown-amount', CountdownAmount);
customElements.define('hdt-countdown-number', CountdownAmountNumber);
customElements.define('hdt-countdown-text', CountdownText);
customElements.define('hdt-countdown-unit', CountdownUnit);

var _details = new WeakMap(),
_summary = new WeakMap(),
_content = new WeakMap(),
_on_keydown = new WeakSet(), on_keydown_fn;
// , _keydown_handler = new WeakMap();
// _on_focus_out = new WeakSet(), on_focus_out_fn;
// _on_toggle = new WeakSet(), on_toggle_fn;
class Accordion extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_details, this, $4('details', this));
    getterAdd(_summary, this, $4('summary', this));
    getterAdd(_content, this, getterGet(_summary, this).nextElementSibling);
    getterAdd(_on_keydown, this);
    //getterAdd(_keydown_handler, this, getterRunFn(_on_keydown, this, on_keydown_fn).bind(this));
    // getterAdd(_on_focus_out, this);
    // getterAdd(_on_toggle, this);
  }
  connectedCallback() {
    this.#abortController = new AbortController();

    //if (this.hasAttribute('sp-focusout'))getterGet(_details, this).addEventListener('focusout', getterRunFn(_on_focus_out, this, on_focus_out_fn).bind(this), { signal: this.#abortController.signal });
    // getterGet(_details, this).addEventListener('toggle', getterRunFn(_on_toggle, this, on_toggle_fn).bind(this), { signal: this.#abortController.signal });
    getterGet(_summary, this).addEventListener("click", this._onSummaryClicked.bind(this), { signal: this.#abortController.signal });
    getterGet(_summary, this).addEventListener("pick", this._onSummaryClicked.bind(this), { signal: this.#abortController.signal });
    getterGet(_details, this).addEventListener("keydown", getterRunFn(_on_keydown, this, on_keydown_fn).bind(this), { signal: this.#abortController.signal });
    if (Shopify.designMode) {
      this.addEventListener(adnmEvts.select, () => this.toggle(), { signal: this.#abortController.signal });
      this.addEventListener(adnmEvts.deselect, () => this.toggle(false), { signal: this.#abortController.signal });
    }
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get open() {
    return getterGet(_details, this).hasAttribute('open');
  }
  toggle(setOpen = true) {
    if ( (setOpen && !this.open) || (!setOpen && this.open)) {
      getterGet(_summary, this)?.dispatchEvent(new CustomEvent("pick", { detail: { offClick: true }}));
    }
  }
  _onSummaryClicked(event) {
    event.preventDefault();
    if ( !event?.detail?.offClick && getterGet(_summary, this).hasAttribute("data-url") && this.hasAttribute('only-click-icon') && !event.target.hasAttribute('accordion-icon') ) {
      return window.location.href = getterGet(_summary, this).getAttribute("data-url");
    }
    getterGet(_details, this).style.overflow = "hidden";
    getterGet(_summary, this).setAttribute('aria-expanded', `${!this.open}`);
    if (this.open) {
      timeline([
        [getterGet(_content, this), { opacity: 0 }, { duration: 0.15 }],
        [getterGet(_details, this), { height: [`${getterGet(_details, this).clientHeight}px`, `${getterGet(_summary, this).clientHeight}px`] }, { duration: 0.25, at: "<", easing: "ease" }]
      ]).finished.then(() => {
        getterGet(_details, this).style.height = null;
        getterGet(_details, this).style.overflow = null;
        getterGet(_details, this).removeAttribute('open');
      });
    } else {
      getterGet(_details, this).setAttribute('open', '');
      timeline([
        [getterGet(_details, this), { height: [`${getterGet(_summary, this).clientHeight}px`, `${getterGet(_details, this).scrollHeight}px`] }, { duration: 0.25, easing: "ease" }],
        [getterGet(_content, this), { opacity: [0, 1], transform: ["translateY(4px)", `translateY(0)`] }, { duration: 0.15, at: "-0.1" }]
      ]).finished.then(() => {
        getterGet(_details, this).style.height = null;
        getterGet(_details, this).style.overflow = null;
      });
    }
  }
};
// on_focus_out_fn = function(e) {
// console.log(e)
//   setTimeout(() => {
//     if (!this.contains(document.activeElement)) getterGet(_summary, this)?.dispatchEvent(new CustomEvent("click", { detail: { offClick: true }}));
//   });
// };
// on_toggle_fn = function(e) {
//   console.log(e)
// };
on_keydown_fn = function(e) {
  // console.log('swwww')
  // console.log(e.key, e.target)
  if (e.key != 'Enter' || !e.target?.hasAttribute('accordion-icon')) return;
  // console.log('eee 111')
  e.preventDefault();
  e.stopPropagation();
  e.target.click();
  // this.toggle(this.open);
};
customElements.define("hdt-accordion", Accordion);

// class AccordionUrl extends Accordion {
// }
// customElements.define("hdt-accordion-url", AccordionUrl);

class Tab extends HTMLElement {
  #abortController;
  connectedCallback() {
    if (!this.idControls) return;
    this.buttons = $$4('button', this);
    this.items = $$4('[tab-item]', this.idControls);
    this.#abortController = new AbortController();
    this.oldIndex = 0;
    this.buttons.forEach( (button) => button.addEventListener("click", () => this._onButtonClicked(button, this.buttons.indexOf(button)), { signal: this.#abortController.signal }) );
    if (Shopify.designMode) {
      this.addEventListener(adnmEvts.select, (e) => e.target.click() );
    }
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get idControls() {
    return $id4(this.getAttribute("aria-controls"));
  }

  /**
   * Create the animation controls for the enter animation
   */
  animateHide() {
    return animate(this.items[this.oldIndex], { opacity: [1, 0], transform: ["translateY(0px)", "translateY(19px)"] }, { duration: 0.2, easing: "ease-in" });
  }
  /**
   * Create the animation controls for the leave animation
   */
  animateShow(newIndex) {
    return animate(this.items[newIndex], { opacity: [0, 1], transform: ["translateY(19px)", "translateY(0px)" ] }, { duration: 0.1, delay: 0.1, easing: "ease-out" });
  }
  _onButtonClicked(button, newIndex) {
    //console.log(newIndex, this.oldIndex)
    //this.#abortController.abort;
    if (button.getAttribute("aria-current") === "true") return;

    this.buttons.forEach((btn, index) => btn.setAttribute('aria-current', (newIndex == index).toString()));
    //this.buttons[newIndex].setAttribute('aria-current','true');
    //this.buttons.forEach((button, index) => button.setAttribute("aria-current", newIndex === index ? "true" : "false"));

    const animateHidePromise = this.animateHide().finished;
    animateHidePromise.then(() => {
      this.items[this.oldIndex].removeAttribute("tab-selected");
      this.oldIndex = newIndex;
      this.items[newIndex].setAttribute('tab-selected', '');
      this.animateShow(newIndex)
    });
  }

};
customElements.define('hdt-tab', Tab);

var _wrapper;
class Marquee extends HTMLElement {
  constructor() {
    super();
    this.classes = {
      enabled  : 'hdt-marquee--enabled',
      duplicate: 'hdt-marquee--duplicate'
    }
    this.oldWidth = 0;

    this.attachShadow({ mode: "open" }).appendChild(document.createRange().createContextualFragment("<slot part='wrapper'></slot>"));
    this.init();

    const resizeObserver = new ResizeObserver(entries => this.init());
    resizeObserver.observe(this);

    if (_matchMedia('motion')) {
      inView(this, (info) => {

        this.animation.play();
        this.isInview = true;
        // console.log('play')
        return (leaveInfo) =>  {
          this.animation.pause();
          this.isInview = false;
          //console.log('pause')
        }
      }, { margin: "250px" })

      // listen for visibility change event
      visibilitychangeFn({
        observes: this,
        play: this.animation.play,
        pause: this.animation.pause
      });
    }
  }

  get wrapper() {
    //return this._wrapper = this._wrapper || this.shadowRoot.querySelector('[part="wrapper"]')
    return getterGet(_wrapper, this, this.shadowRoot.querySelector('[part="wrapper"]'));
  }

  init() {
    if (this.clientWidth < this.oldWidth ) return;
    this.oldWidth = this.clientWidth;
    this.prepareContent();
    this.calculateWidthRatio();
  }

  prepareContent() {
    // remove holder init class
    this.classList.remove(this.classes.enabled);

    // remove duplicated content
    //this.marqueeInner?.classList.remove(this.classes.animation);
    var boxes = $$4('.'+this.classes.duplicate,this);
    if (boxes.length) {
      boxes.forEach(e => e.remove());
    }
  }

  calculateWidthRatio() {
    let multiply = (Math.ceil(this.clientWidth / this.firstElementChild.offsetWidth)+1),
    clone,
    i;
    // calc speed
    // https://stackoverflow.com/questions/38118002/css-marquee-speed
    // this.style.setProperty('--marquee-delay', `${((this.firstElementChild.offsetWidth / 100) * this.getAttribute('speed')).toFixed(3)}s`);
    // By dividing the width by a certain value (100 in the example), we can adjust the speed of the "marquee" effect

    // Duplicate content at least once

    const frag = document.createDocumentFragment();
    for (i = 0; i < multiply; i++) {
      clone = this.firstElementChild.cloneNode(true);
      clone.setAttribute('aria-hidden',true);
      clone.classList.add(this.classes.duplicate);
      clone.style.setProperty('--index', i + 1);
      frag.appendChild(clone);
    }
    this.append(frag);
    // Add holder init class
    this.classList.add(this.classes.enabled);

    if (_matchMedia('motion')) {
      // if ( this.animation) this.animation.cancel();
      this.animation = animate(this.wrapper, { transform: ["translateX(0)", `translateX(calc(var(--value-logical-flip) * var(--dir-logical) * 100%))`] }, {
        duration: 1 / parseFloat(this.getAttribute("speed")) * (this.wrapper.clientWidth / 350),
        easing: "linear",
        repeat: Infinity
      });
      if (this.hasAttribute('pause-on-pointer-enter')) {
        this.addEventListener("mouseenter", this.onmouseenter);
        this.addEventListener("touchstart", this.onmouseenter);
      }
      // this.animation.pause();
    }
  }
  onmouseenter() {
    this.animation.pause();
    this.addEventListener("mouseleave", this.onmouseleave);
    this.addEventListener("touchend", this.onmouseleave);
  }
  onmouseleave() {
    this.animation.play();
    this.removeEventListener( 'mouseleave', this.onmouseleave );
    this.removeEventListener( 'touchend', this.onmouseleave );
  }
  disconnectedCallback() {
    getterDelete(_wrapper, this);
    this.removeEventListener("mouseenter", this.onmouseenter);
    this.removeEventListener("touchstart", this.onmouseenter);
  }
};
_wrapper = new WeakMap();
customElements.define('hdt-marquee', Marquee);

var _effect, effect_fn, _img_effect = new WeakMap();
class ImageEffect extends HTMLElement {
  constructor() {
    super();
    getterAdd(_effect, this);
    getterAdd(_img_effect, this, $4('picture img, img', this));
  }
  connectedCallback() {
    //if (_matchMedia('motion')) fnCheck(this, _effect, effect_fn).call(this);
    if (_matchMedia('motion') && getterGet(_img_effect, this) ) getterRunFn(_effect, this, effect_fn).call(this);
  }
}
_effect = new WeakSet();
effect_fn = function() {
  const getEffect = this.getAttribute('eff');
  if ( getEffect === 'ambient' ) {
    // ambient
    animate(getterGet(_img_effect, this), { transform: ["rotate(0deg) translateX(1em) rotate(0deg) scale(1.2)", "rotate(360deg) translateX(1em) rotate(-360deg) scale(1.2)"] }, {
      duration: 30,
      easing: "linear",
      repeat: Infinity
    });
  } else if ( getEffect === 'parallax' ) {
    // parallax
    const getScale = parseFloat(this.style.getPropertyValue("--parallax-scale") || 1.3),
    [scale, translate] = [getScale, 0.15 * 100 / getScale],
    isFirstSection = this.closest(".hdt-section").matches(":first-child");
    scroll(
      animate(getterGet(_img_effect, this), { transform: [`scale(${scale}) translateY(-${translate}%)`, `scale(${scale}) translateY(${translate}%)`] }, { easing: "linear" }),
      {
        target: getterGet(_img_effect, this),
        offset: [isFirstSection ? "start start" : "start end", "end start"]
      }
    );
  }
};
customElements.define("hdt-effect-img", ImageEffect);

// var _updateSizes, updateSizes_fn, _optimumx;
// class ImageLazy extends HTMLImageElement {
//   constructor() {
//     super(...arguments);
//     if (this.getAttribute('data-sizes') === 'auto') {
//       getterAdd(_optimumx, this, this.getAttribute('data-optimumx') || 1);
//       getterAdd(_updateSizes, this);
//       getterRunFn(_updateSizes, this, updateSizes_fn).call(this);
//       this.resizeObserver = new ResizeObserver(entries => getterRunFn(_updateSizes, this, updateSizes_fn).call(this));
//       this.resizeObserver.observe(this);
//     }
//   }
// }
// _updateSizes = new WeakSet();
// _optimumx = new WeakMap();
// updateSizes_fn = function() {
//   this.setAttribute('sizes', this.offsetWidth * getterGet(_optimumx, this) +'px');
// };
// customElements.define("hdt-lazy", ImageLazy, { extends: "img" });
// Use <img is="hdt-lazy" data-sizes="auto" src="..">

var _resizeObserver, resizeObserver_fn;
class HeightObserver extends HTMLElement {
  constructor() {
    super();
    getterAdd(_resizeObserver, this)
    if (window.ResizeObserver) {
      new ResizeObserver(throttle(getterRunFn(_resizeObserver, this, resizeObserver_fn).bind(this))).observe(this);
    }
  }
  connectedCallback() {
    if (!window.ResizeObserver) html.style.setProperty(`--${this.getAttribute("prefix")}-height`, `${Math.round(this.clientHeight)}px`);
  }
};
_resizeObserver = new WeakSet();
resizeObserver_fn = function(entries) {
  entries.forEach((entry) => {
    if (entry.target === this) {
      const height = entry.borderBoxSize ? entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.borderBoxSize.blockSize : entry.target.clientHeight;
      html.style.setProperty(`--${this.getAttribute("prefix")}-height`, `${Math.round(height)}px`);
    }
  });
};
customElements.define("hdt-height-observer", HeightObserver);

// Header JS

class StickyHeader extends HeightObserver {
  constructor() {
    super();
  }

  connectedCallback() {
    this.checkTransparent();
    super.connectedCallback();
    this.stickyType = this.getAttribute('sticky-type');
    if (this.stickyType === 'none') return;

    this.header = this.closest('.hdt-section-header');
    this.headerIsAlwaysSticky = this.stickyType === 'always';
    this.headerBounds = {};

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = $4('predictive-search', this);

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.scrollY || html.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    //console.log(this.headerBounds)

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    // this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    //$$4('hdt-header-menu details[open]', this.header).forEach(disclosure => $4('summary', disclosure).dispatchEvent(new CustomEvent("click", { detail: { offClick: true }})));
    $$4('hdt-header-menu > details[open]', this.header).forEach(disclosure => disclosure.parentElement.toggle(false));
  }

  // closeSearchModal() {
    // this.searchModal = this.searchModal || $$4('details-modal', this.header);
    // this.searchModal.close(false);
  // }

  checkTransparent() {
    if ( !$4('.section-allow-transparent.hdt-section:first-child') || $4('.hdt-section-header + .shopify-section-group-header-group') ) return;
    html.setAttribute('enabled-transparent-header', '');
  }
}
customElements.define("hdt-sticky-header", StickyHeader);

var _event, _position, _isCenterOnScreen, _x, _needCalc,
_clickOutside, clickOutside_fn, _click_outside_handler = new WeakMap(),
_escape, escape_fn, _escape_handler = new WeakMap();
class MegaMenu extends Accordion {
  constructor() {
    super();
    if (_matchMedia('phone')) return;
    // this.clickOutsideHandler = this.clickOutside.bind(this);
    // this.escapeHandler = this.escape.bind(this);
    if (this.event === "hover") {
      new HoverIntent(
        getterGet(_details, this),
        {
          // required parameters
          onEnter: (el) => {
            //console.log(el)
            getterGet(_summary, this).classList.add('is_action-hover');
            this.toggle()
            //getterGet(_summary, el)?.dispatchEvent(new CustomEvent("click", { detail: { offClick: true }}))
            //this.toggle(true);
          },
          onExit: (el) => {
            getterGet(_summary, this).classList.remove('is_action-hover');
            this.toggle(false);
            //getterGet(_summary, el)?.dispatchEvent(new CustomEvent("click", { detail: { offClick: true }}))
            //this.toggle(false);
          },
          // default options
          exitDelay: 150,
          interval: 35,
          sensitivity: 3
        },
        getterGet(_summary, this)
      );
    }

    getterAdd(_clickOutside, this);
    getterAdd(_escape, this);
    getterAdd(_escape_handler, this, getterRunFn(_escape, this, escape_fn).bind(this));
    getterAdd(_click_outside_handler, this, getterRunFn(_clickOutside, this, clickOutside_fn).bind(this));
  }
  get expanded () {
    return getterGet(_summary, this).getAttribute("aria-expanded") === "true";
  }

  // get eventAttr() {
  //   return this._eventAttr = this._eventAttr || this.getAttribute("event");
  // }
  get event() {
    return getterGet(_event, this, !_matchMedia("supports-hover") ? "click" : this.getAttribute("event"));
  }
  get position() {
    return getterGet(_position, this, this.getAttribute('position') || 'bottom');
  }

  get isCenterOnScreen() {
    return getterGet(_isCenterOnScreen, this, this.position === 'center_on_screen');
  }

  get needCalc() {
    return getterGet(_needCalc, this, !getterGet(_details, this).hasAttribute('not-need-calc'));
  }

  get x() {
    return getterGet(_x, this, this.isCenterOnScreen ? '-50%' : '0');
  }

  _onSummaryClicked(event) {
    if ( !event?.detail?.offClick && getterGet(_summary, this).hasAttribute("data-url") && (this.event === "hover" || (this.expanded && this.hasAttribute("opened-able-click"))) ) {
      return window.location.href = getterGet(_summary, this).getAttribute("data-url");
    }
    event.preventDefault();
    getterGet(_summary, this).setAttribute('aria-expanded', `${!this.open}`);
    if (this.open) {
      //document.removeEventListener("click", getterRunFn(_clickOutside, this, clickOutside_fn).bind(this));
      document.removeEventListener("click", getterGet(_click_outside_handler, this));
      document.removeEventListener("keydown", getterGet(_escape_handler, this));
      timeline([
        [getterGet(_content, this), { opacity: [1, 0], visibility: ["visible", "hidden"], transform: [`translateX(${this.x}) translateY(0)`, `translateX(${this.x}) translateY(15px)`] }, { duration: 0.4, easing: [0.19, 1, 0.22, 1] }]
      ]).finished.then(() => {
        getterGet(_details, this).removeAttribute('open');
      });
    } else {
      //document.addEventListener("click", getterRunFn(_clickOutside, this, clickOutside_fn).bind(this));
      document.addEventListener("click", getterGet(_click_outside_handler, this));
      document.addEventListener("keydown", getterGet(_escape_handler, this));
      getterGet(_details, this).setAttribute('open', '');
      if ( this.needCalc && !this.isCenterOnScreen ) updatePositionFloatingEl.call(this, getterGet(_summary, this), getterGet(_content, this), null, this.position, false);
      timeline([
        [getterGet(_content, this), { opacity: [0, 1], visibility: ["hidden", "visible"], transform: [`translateX(${this.x}) translateY(15px)`, `translateX(${this.x}) translateY(0)`] }, { duration: 0.4, easing: [0.19, 1, 0.22, 1] }]
      ]).finished.then(() => {
      });
    }
  }
}
_event = new WeakMap();
_position = new WeakMap();
_isCenterOnScreen = new WeakMap();
_x = new WeakMap();
_needCalc = new WeakMap();
_clickOutside = new WeakSet();
_escape = new WeakSet();
clickOutside_fn = function(event) {
  if (this.event !== "click") return;
  if (!this.contains(event.target)) {
    //console.log('this', this,  $4('details[open]', this))
    //$4('details[open] summary', this)?.dispatchEvent(new CustomEvent("click", { detail: { offClick: true }}));
    this.toggle(false);
  }
};
escape_fn = function(event) {
  if (event.code === "Escape") {
    const details = event.target.closest('details[open]');
    //console.log('Escape', this, event.target);
    if (details ) {
      //getterGet(_summary, this).dispatchEvent(new CustomEvent("click", { detail: { offClick: true }}));
      this.toggle(false);
      event.stopPropagation();
    }
  }
};
customElements.define("hdt-header-menu", MegaMenu);

// Product card JS
var _color_limit, color_limit_fn,
_color_item_first, _color_item_last,
_color_resizeObserver, color_resizeObserver_fn,
_width_color_list, _click_color_viewmore, click_color_viewmore_fn, _color_slider,
isColorLimit = 'is--color-limit',
_delegate2,
_even_color, _color_changed_data, color_changed_data_fn,
_color_products, _color_product_urls, _color_product_url_first,
_color_on_hovered, color_on_hovered_fn, _create_img, create_img_fn, _color_vimgs,
_color_fieldset = new WeakMap();
class ColorList extends HTMLElement {
  constructor() {
    super();
    getterAdd(_delegate2, this , new Delegate(this));
    getterAdd(_color_changed_data, this);
    getterAdd(_color_on_hovered, this);
    getterAdd(_create_img, this);
    getterAdd(_color_products, this, this.closest('.hdt-card-product'));
    getterAdd(_color_product_urls, this, $$4('[data-pr-url]', getterGet(_color_products, this)));
    getterAdd(_color_fieldset, this, $4('fieldset', this));
  }
  connectedCallback() {
    // Check has variant image to change
    if ($$4('[type="radio"]:not([disabled])', this).length > 0 ) {
      getterGet(_delegate2, this).on("change", '[type="radio"]', getterRunFn(_color_changed_data, this, color_changed_data_fn).bind(this));
      getterGet(_delegate2, this).on("pointerover", '[type="radio"][data-vimg] + label', getterRunFn(_color_on_hovered, this, color_on_hovered_fn).bind(this), true);

      if (!_matchMedia('phone') && this.event == 'hover') {
        $$4('[type="radio"] + label', this).forEach((label) => {
          new HoverIntent(
            label,
            {
              onEnter: (el) => el.click(),
              onExit: (el) => {}, exitDelay: 100, interval: 100, sensitivity: 6
            }
          );
        });
      }
    }
    if (getterGet(_color_fieldset, this).childElementCount > 2) {
      getterAdd(_width_color_list, this, 0);
      //getterAdd(_width_color_first, this, 0);
      getterAdd(_color_item_first, this, getterGet(_color_fieldset, this).firstChild);
      getterAdd(_color_item_last, this, getterGet(_color_fieldset, this).lastChild);
      getterAdd(_color_resizeObserver, this);
      getterAdd(_color_slider, this, this.closest('.hdt-slider__products'));
      // if has more than 2 colors then run fn
      if (this.hasAttribute('auto-limit') ) {
        getterAdd(_color_limit, this);
        if (window.ResizeObserver) {
          let resizeObserver = new ResizeObserver(throttle(getterRunFn(_color_resizeObserver, this, color_resizeObserver_fn).bind(this)));
          resizeObserver.observe(this);
          this.addEventListener('unobserve', ()=> { resizeObserver.unobserve(this); resizeObserver = null });
        } else {
          getterRunFn(_color_limit, this, color_limit_fn).call(this);
        }
      }
      if (this.hasAttribute('action-all') ) {
        getterAdd(_click_color_viewmore, this);
        getterGet(_color_item_last, this).addEventListener("click", getterRunFn(_click_color_viewmore, this, click_color_viewmore_fn).bind(this));
        if (window.ResizeObserver && !this.hasAttribute('auto-limit')) {
          let resizeObserver2 = new ResizeObserver(throttle(getterRunFn(_color_resizeObserver, this, color_resizeObserver_fn).bind(this)));
          resizeObserver2.observe(this);
          this.addEventListener('unobserve2', ()=> { resizeObserver2.unobserve(this); resizeObserver2 = null });
        }
      }
    }
  }
  disconnectedCallback() {
    getterGet(_delegate2, this).off();
  }
  get event() {
    return getterGet(_even_color, this, !_matchMedia("supports-hover") ? "click" : this.getAttribute("event"));
  }
}
_color_limit = new WeakSet();
_color_item_first = new WeakMap();
_color_item_last = new WeakMap();
_color_resizeObserver = new WeakSet();
_click_color_viewmore = new WeakSet();
_width_color_list = new WeakMap();
//_width_color_first = new WeakMap();
_color_slider = new WeakMap();
_delegate2 = new WeakMap();
_even_color = new WeakMap();
_color_changed_data = new WeakSet();
_color_products = new WeakMap();
_color_product_urls = new WeakMap();
_color_product_url_first = new WeakMap();
_color_vimgs = new WeakMap();

color_limit_fn = function() {
  const color_item_width = getterGet(_color_item_first, this).getBoundingClientRect().width, //
        more_item_width  = getterGet(_color_item_last, this).getBoundingClientRect().width, // getBoundingClientRect().width or this.clientWidth
        computedStyles   = getComputedStyle(getterGet(_color_fieldset, this)),
        item_gap         = parseFloat(computedStyles.gap || computedStyles.columnGap || 10),
        countItem        = getterGet(_color_fieldset, this).childElementCount - 1,
        totalWidthGap    = color_item_width * countItem + (countItem - 1) * item_gap,
        { width }        = getterGet(_color_fieldset, this).getBoundingClientRect(),
        maxFit           = Math.floor(width / (color_item_width + item_gap)),
        maxFitWithMore   = Math.floor((width - more_item_width) / (color_item_width + item_gap ));

  //console.log('maxFit', maxFit, maxFitWithMore, item_gap, width, more_item_width, color_item_width)
  if (maxFit >= countItem || totalWidthGap <= getterGet(_width_color_list, this)) {
    getterGet(_color_item_last, this).setAttribute('hidden', '');
    $4('.'+isColorLimit, this)?.classList.remove(isColorLimit);
  } else {
    //console.log('maxFit', maxFit, maxFitWithMore, item_gap, width, more_item_width, color_item_width, getterGet(_color_item_first, this).clientWidth)
    getterGet(_color_fieldset, this).childNodes[maxFitWithMore]?.classList.add(isColorLimit);
    $4('.'+isColorLimit, this)?.classList.remove(isColorLimit);
    getterGet(_color_item_last, this).lastElementChild.textContent = `+${countItem - maxFitWithMore}`;
    getterGet(_color_item_last, this).style.opacity = 1;
  }
};
color_resizeObserver_fn = function(entries) {
    // Run slider if has
    if (getterGet(_color_slider, this)) getterGet(_slider_api, getterGet(_color_slider, this)).reInit();

    if ( getterGet(_width_color_list, this) == entries[0].contentRect.width ) return;
    getterAdd(_width_color_list, this, entries[0].contentRect.width, true);

    // if ( getterGet(_width_color_list, this) || (this.oldWidth == this.clientWidth) ) {
    //   //this.oldWidth = 0;
    //   return this.oldWidth = 0;
    // }
    // this.oldWidth = this.clientWidth;

    if (this.hasAttribute('auto-limit') ) {

      //if ( getterGet(_color_item_first, this).getBoundingClientRect().width == getterGet(_width_color_first, this) ) return;
      // Reset
      $4('.'+isColorLimit, this)?.classList.remove(isColorLimit);
      getterGet(_color_fieldset, this).childNodes[1]?.classList.add(isColorLimit);
      getterGet(_color_item_last, this).removeAttribute('hidden');
      getterGet(_color_item_last, this).style.opacity = 0;
      // Run fn
      getterRunFn(_color_limit, this, color_limit_fn).call(this);
      // setTimeout(() => {
      //   getterRunFn(_color_limit, this, color_limit_fn).call(this);
      // }, 0);
    } else {
      getterGet(_color_fieldset, this).childNodes[parseInt(this.getAttribute('maximum'))]?.classList.add(isColorLimit);
      getterGet(_color_item_last, this).removeAttribute('hidden');
    }
};
click_color_viewmore_fn = function(e) {
  e.preventDefault();
  this.dispatchEvent(new CustomEvent("unobserve", { cancelable: true, composed: true }));
  this.dispatchEvent(new CustomEvent("unobserve2", { cancelable: true, composed: true }));
  //getterAdd(_width_color_list, this, true, true);
  const $limit = $4('.'+isColorLimit, this);
  $limit?.classList.remove(isColorLimit);
  getterGet(_color_item_last, this).setAttribute('hidden', '');
  this.style.minHeight = this.clientHeight + 'px';
  animate(
    getterGet(_color_fieldset, this).children,
    //{ opacity: [0, 1], scale: [.5 ,1], y: [10 ,0] },
    { opacity: [0, 1], transform: ["scale(.5) translateY(10px)", "scale(1) translateY(0)"] },
    { duration: 0.35, delay: stagger(0.05, { easing: "ease-out" }), easing: "ease" }
  ).finished.then(() => {
    this.style.minHeight = null;
    //setTimeout(() => getterAdd(_width_color_list, this, false, true), 10);
    if (getterGet(_color_slider, this)) getterGet(_slider_api, getterGet(_color_slider, this)).reInit();
  });
  // focus
  $limit?.previousElementSibling.querySelector('input')?.focus();
};
color_changed_data_fn = function(e, target) {
  // Update variant url
  if ( getterGet(_color_product_urls, this).length ) {
    const url = UrlWithVariant.get(getterGet(_color_product_url_first, this, getterGet(_color_product_urls, this)[0].href), target.dataset.vid);
    getterGet(_color_product_urls, this).forEach((link) => {
      link.href = url;
    });
  }
  //getterRunFn(_update_img_variant_card, this, update_img_variant_card_fn).call(this, )
  // Update image
  const vimg = getterGet(_color_vimgs, target, target.getAttribute('data-vimg'));
  if (vimg) {
    const mediaMain = getterGet(_color_products, this).querySelector('.hdt-card-product__media--main');

    if ( vimg === mediaMain.getAttribute('src')) return;

    mediaMain.parentElement.removeAttribute('loaded');
    mediaMain.parentElement.setAttribute('loading', '');
    mediaMain.replaceWith(getterRunFn(_create_img, this, create_img_fn).call(this, vimg, mediaMain));
  }
};
_color_on_hovered = new WeakSet();
color_on_hovered_fn = function(e, target) {
  const radio = target.previousElementSibling;
  if (!radio ) return;
  const vimg = getterGet(_color_vimgs, radio, radio.getAttribute('data-vimg'));
  // Preload image
  if (vimg) {
    const mediaMain = getterGet(_color_products, this).querySelector('.hdt-card-product__media--main');
    if ( vimg !== mediaMain.getAttribute('src')) getterRunFn(_create_img, this, create_img_fn).call(this, vimg, mediaMain);
  }
};
_create_img = new WeakSet();
create_img_fn = function(vimg, mediaMain) {
  return createImg({
    src: vimg,
    width: mediaMain.getAttribute('width'),
    height: mediaMain.getAttribute('height'),
    alt: mediaMain.alt,
    onload: true,
    attrs: {
      class: mediaMain.className,
      sizes: mediaMain.sizes,
      'data-widths': mediaMain.getAttribute('data-widths') || '[]'
    }
  })
};
customElements.define("wrapp-hdt-color-list", ColorList);
/**
   * Returns a URL with a variant ID query parameter. Useful for updating window.history
   * with a new URL based on the currently select product variant.
   * @param {string} url - The URL you wish to append the variant ID to
   * @param {number} id  - The variant ID you wish to append to the URL
   * @returns {string} - The new url which includes the variant ID query parameter
   */
var cacheUrlVariant = {};
var UrlWithVariant = class {
  static get(url, id) {
    if (!url || !id)  return;
    if (cacheUrlVariant[id]) {
      return cacheUrlVariant[id];
    }
    url = new URL(url);
    url.searchParams.set("variant", id);
    return cacheUrlVariant[id] = url.toString();
  }
};
// Test
// console.log(UrlWithVariant.get('sssss', 1111))
// console.log(UrlWithVariant.get('sssss?xxx', 1111))
// console.log(UrlWithVariant.get('sssss?variant=1111', 22))
// console.log(UrlWithVariant.get('sssss?xxx&variant=1111', 22))
// console.log(cacheUrlVariant)


// Product JS
const {currencyFormat} = themeHDN.settings,
variantChange = "variant:change";

var _on_after_close, on_after_close_fn,
_section_ids_modal = new WeakMap();

class LazyModal extends Modal {
  constructor() {
    super();
    getterAdd(_on_after_close, this);
    getterAdd(_section_ids_modal, this, this.getAttribute('section-id'));
    this.addEventListener("dialog:doneClose", getterRunFn(_on_after_close, this, on_after_close_fn).bind(this));
    // if (themeHDN.settings.actionAfterATC === "open_cart_drawer") {
    //   document.addEventListener("variant:add", this.closeDialog.bind(this));
    // }
    this.addEventListener("dialog:beforeOpen", ()=> {
      const $badgesHidden = $$4('hdt-badge[update-hidden]', this);
      if ($badgesHidden.length) $badgesHidden.forEach((badge) => badge.updateHiddenParent())
    });
  }
  async openDialog(_animate = true, btnOpening) {
    const handle = btnOpening ? btnOpening.getAttribute("handle") : this.getAttribute("handle");
    if (!handle) return;
    document.dispatchEvent(new CustomEvent("theme:loading:doing", { bubbles: true }));
    //[this, ...this.controls].forEach((control) => control.setAttribute("aria-busy", "true"));
    btnOpening?.setAttribute("aria-busy", "true");
    const responseSection = await (await cachedFetch(`${window.Shopify.routes.root}products/${handle}?section_id=${getterGet(_section_ids_modal, this)}`)).text();
    document.dispatchEvent(new CustomEvent("theme:loading:done", { bubbles: true }));
    //[this, ...this.controls].forEach((control) => control.setAttribute("aria-busy", "false"));
    btnOpening?.setAttribute("aria-busy", "false");
    const domElement = new DOMParser().parseFromString(responseSection, "text/html"),
    newSectionModal = document.createRange().createContextualFragment(domElement.getElementById(`shopify-section-${getterGet(_section_ids_modal, this)}`).innerHTML);
    this.replaceChildren(...newSectionModal.children);
    rteWrapTable(this);
    accessibleLinks(this);
    localeUrl(this);
    Shopify?.PaymentButton?.init();
    document.dispatchEvent(new CustomEvent("currency:update"));
    return super.openDialog(_animate);
  }
  get controls() {
    return $$4(`[aria-controls="${this.id}"]`, this.getRootNode());
  }
}
_on_after_close = new WeakSet();
on_after_close_fn = function() {
  this.innerHTML = "";
};

class FetchButtonModal extends btnTooltip {
  constructor() {
    super();
    $id4(this.firstElementChild.getAttribute('aria-controls'))?.updateBtbsOpen(this);
  }
  connectedCallback() {
    super.connectedCallback();
    $4('hdt-tmp-quick')?.dispatchEvent(new CustomEvent("theme:update:id", { bubbles: false }));
  }
}

class TmpQuick extends HTMLElement {
  constructor() {
    super();
    this.getIDTemp();
    this.addEventListener('theme:update:id', () => this.getIDTemp());
  }
  //connectedCallback() {}
  async getIDTemp() {
    const $btn = $4('[aria-controls="hdt-quick-view-modal"], [aria-controls="hdt-quick-add-modal"]');
    if (!$btn || this.hasID) return;
    this.hasID = true;
    this.removeEventListener('theme:update:id', () => this.getIDTemp());
    let responseAsText,
    idCache = "themeQuick" + window.Shopify.theme.id;
    if (sessionStorage.getItem(idCache) && !Shopify.designMode) {
      responseAsText = sessionStorage.getItem(idCache);
    } else {
      responseAsText = await (await fetch(`${window.Shopify.routes.root}products/${$btn.getAttribute('handle')}?view=only_config`, {priority: 'low'})).text();
      sessionStorage.setItem(idCache, responseAsText)
    }
    const tmp = new DOMParser().parseFromString(responseAsText, "text/html");
    $$4('.hdt-main-section--quick-view, .hdt-main-section--quick-add', tmp).forEach( (modal)=> this.insertAdjacentHTML("afterend", modal.innerHTML));
    this.remove();
  }
}

customElements.define('hdt-lazy-modal', LazyModal);
customElements.define("wrapp-hdt-open-modal-btn", FetchButtonModal);
customElements.define('hdt-tmp-quick', TmpQuick);

var _on_submit, on_submit_fn, _pr_frm = new WeakMap();
class ProductForm extends HTMLElement {
  constructor() {
    super();
    getterAdd(_on_submit, this);
    getterAdd(_pr_frm, this, $4('form', this));
    getterGet(_pr_frm, this).addEventListener("submit", getterRunFn( _on_submit, this, on_submit_fn));
  }
  connectedCallback() {
    this.hideErrors = this.dataset.hideErrors === 'true';
    getterGet(_pr_frm, this).id.disabled = false;
  }
};
_on_submit = new WeakSet();
on_submit_fn = async function(e) {
  e.preventDefault();
  if (this.checkBreak) return;
  if (!this.checkValidity()) {
    this.reportValidity();
    return;
  }
  const submitButtons = Array.from(this.elements).filter((button) => button.type === "submit");
  submitButtons.forEach((submitButton) => {
    submitButton.setAttribute("disabled", "disabled");
    submitButton.setAttribute("aria-busy", "true");
  });
  document.dispatchEvent(new CustomEvent("theme:loading:doing", { bubbles: true }));
  let bundleSections = [];
  document.dispatchEvent(new CustomEvent("cart:push:section.id", { bubbles: true, detail: { sections: bundleSections } }));
  const formData = new FormData(this);
  formData.set("sections", bundleSections.join(","));
  //formData.set("sections_url", this.id.value ? `${Shopify.routes.root}variants/${this.id.value}` : window.location.pathname);
  const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
    body: formData,
    method: "POST",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
      // Needed for Shopify to check inventory
    }
  });
  submitButtons.forEach((submitButton) => {
    submitButton.removeAttribute("disabled");
    submitButton.removeAttribute("aria-busy");
  });
  const responseJson = await response.json();
  //console.log(response);
  document.dispatchEvent(new CustomEvent("theme:loading:done", { bubbles: true }));
  if (response.ok) {
    //console.log('Success: add to card', responseJson);
    const cartContent = await createCartPromise();
    cartContent.sections = responseJson.sections;
    this.dispatchEvent(new CustomEvent("variant:add", {
      bubbles: true,
      detail: {
        items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
        actionAfterATC: formData.get("action_added"),
        cart: cartContent
      }
    }));
    document.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "variant:add",
        actionAfterATC: formData.get("action_added"),
        cart: cartContent
      }
    }));
  } else {
    if (this.hideErrors) return;
    this.dispatchEvent(new CustomEvent("cart:add:error", {
      bubbles: true,
      detail: {
        isGiftCardRecipient: this.dataset.giftCardRecipient === 'true',
        error: responseJson.description
      }
    }));
  }
};
// https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-add-js
// var _fetch_atc = new WeakSet(), fetch_atc_fn;
// class ProductATC extends HTMLElement {
//   constructor() {
//     super();
//     getterAdd(_fetch_atc, this);
//   }
//   connectedCallback() {
//   }
// };
// fetch_atc_fn = async function(id, quantity){
//   let formData = {
//     'items': [{ id, quantity }]
//    };
//    fetch(window.Shopify.routes.root + 'cart/add.js', {
//      method: 'POST',
//      headers: {
//        'Content-Type': 'application/json'
//      },
//      body: JSON.stringify(formData)
//    })
//    .then(response => {
//      return response.json();
//    })
//    .catch((error) => {
//      console.error('Error:', error);
//    });
// };
// customElements.define('hdt-product-atc', ProductATC);

var _update_bundle_total, update_bundle_total_fn,
_update_total_bundle = new WeakMap();
class ProductFormBundle extends ProductForm {
  constructor() {
    super();
    getterAdd(_update_bundle_total, this);
  }
  connectedCallback() {
    getterAdd(_update_total_bundle, this, $4('[update-total]', this));
    this.totalPrice = Number(getterGet(_update_total_bundle, this).dataset.price);
    this.totalComparePrice = Number(getterGet(_update_total_bundle, this).dataset.cpprice);
    this.addEventListener("update:bundle:total", getterRunFn(_update_bundle_total, this, update_bundle_total_fn).bind(this));
  }
  disconnectedCallback() {
    this.removeEventListener("update:bundle:total", getterRunFn(_update_bundle_total, this, update_bundle_total_fn).bind(this));
  }
};
_update_bundle_total = new WeakSet();
update_bundle_total_fn = function(event) {
  if (event.detail.action == 'plus') {
    this.totalPrice = this.totalPrice + event.detail.remainPrice;
    this.totalComparePrice = this.totalComparePrice + event.detail.remainComparePrice;
  } else {
    this.totalPrice = this.totalPrice - event.detail.remainPrice;
    this.totalComparePrice = this.totalComparePrice - event.detail.remainComparePrice;
  }
  const $comapre = $4('hdt-compare-at-price', getterGet(_update_total_bundle, this));
  if ($comapre) {
    $comapre.toggleAttribute('hidden', this.totalComparePrice <= this.totalPrice);
    $4('.hdt-money', $comapre).outerHTML = `<span class="hdt-money">${formatMoney(this.totalComparePrice)}</span>`;
  }
  // $4('hdt-compare-at-price .hdt-money', getterGet(_update_total_bundle, this)).innerHTML = formatMoney(this.totalComparePrice);
  // $4('hdt-price .hdt-money', getterGet(_update_total_bundle, this)).innerHTML = formatMoney(this.totalPrice);
  $4('hdt-price .hdt-money', getterGet(_update_total_bundle, this)).outerHTML = `<span class="hdt-money">${formatMoney(this.totalPrice)}</span>`;
  document.dispatchEvent(new CustomEvent("currency:update"));
};

var _bundle_product, bundle_product_fn,
_bundle_items = new WeakMap();
class bundleProduct extends HTMLElement {
  #abortController
  constructor() {
    super();
    getterAdd(_bundle_product, this);
    getterAdd(_bundle_items, this, $$4('[name^="items[]"]', this));
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    const itemId = $4('[name="items[][id]"]', this);
    this.price = Number(itemId.dataset.price);
    this.comparePrice = Number(itemId.dataset.cpprice);
    this.addEventListener('change', getterRunFn(_bundle_product, this, bundle_product_fn).bind(this), { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get observes() {
    return this._observes = this._observes || $id4(this.getAttribute('observes'));
  }
}
_bundle_product = new WeakSet();
bundle_product_fn = function(event) {
  const target = event.target;
  if (target.tagName == 'SELECT') {
    const optionSelected = target.options[target.selectedIndex],
    oldPrice = this.price,
    oldComparePrice = this.comparePrice;

    this.price = Number(optionSelected.dataset.price);
    this.comparePrice = Number(optionSelected.dataset.cpprice);
    var action = 'plus',
    remainPrice = this.price - oldPrice,
    remainComparePrice = this.comparePrice - oldComparePrice;
    // Update price, qty, image
    $4('[update-price] hdt-compare-at-price', this).toggleAttribute('hidden', this.comparePrice <= this.price);
    // $4('[update-price] hdt-compare-at-price .hdt-money', this).innerHTML = formatMoney(this.comparePrice);
    // $4('[update-price] hdt-price .hdt-money', this).innerHTML = formatMoney(this.price);
    $4('[update-price] hdt-compare-at-price .hdt-money', this).outerHTML = `<span class="hdt-money">${formatMoney(this.comparePrice)}</span>`;
    $4('[update-price] hdt-price .hdt-money', this).outerHTML = `<span class="hdt-money">${formatMoney(this.price)}</span>`;
    $4('[update-qty]', this).value = optionSelected.dataset.qty;
    $4('[update-img]', this.observes || this).src = optionSelected.dataset.img;
    document.dispatchEvent(new CustomEvent("currency:update"));
    if ( !this.classList.contains('is-checked')) return;

  } else if (target.tagName == 'INPUT') {
    // Update disable slelect, qty
    getterGet(_bundle_items, this).forEach((item) => {
      item.toggleAttribute('disabled', !target.checked);
    });
    this.classList.toggle('is-checked', target.checked);
    var action = target.checked ? 'plus': 'minus',
    remainPrice = this.price,
    remainComparePrice = this.comparePrice;
    this.observes?.classList.toggle('is-checked', target.checked);
  }

  this.dispatchEvent(new CustomEvent("update:bundle:total", {
    bubbles: true,
    detail: {
      remainPrice,
      remainComparePrice,
      action
    }
  }));
};

var _on_variant_changed, on_variant_changed_fn,
_cart_error, _cart_error_fn;
class BuyButtons extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_on_variant_changed, this);
    getterAdd(_cart_error, this);
  }
  get form() {
    return document.forms[this.getAttribute("form")];
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    this.form?.addEventListener(variantChange, getterRunFn(_on_variant_changed, this, on_variant_changed_fn).bind(this), { signal: this.#abortController.signal });
    this.form?.addEventListener("cart:add:error", getterRunFn(_cart_error, this, _cart_error_fn).bind(this), { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
};
_on_variant_changed = new WeakSet();
on_variant_changed_fn = function(event) {
  const variant = event.detail.variant,
  submitButton = $4('button[type="submit"]', this);
  //paymentButton = $4(".shopify-payment-button", this);

  submitButton.disabled = !variant || !variant.available;
  submitButton.firstElementChild.textContent = themeHDN.extras[!variant ? 'unavailable' : variant.variant_state.pre_order ? 'preOrder' : variant.available ? 'addToCart' : 'soldOut'];
  //if (paymentButton) paymentButton.style.display = (variant && variant.available) ? "block" : "none";
  this.previousElementSibling.hidden = true;
  $4('hdt-price', this)?.removeAttribute('hidden');
};
_cart_error = new WeakSet();
_cart_error_fn = function(event) {
  if (event.detail.isGiftCardRecipient) return;
  this.previousElementSibling.hidden = false;
  this.previousElementSibling.lastElementChild.textContent = event.detail.error;
  this.form?.addEventListener("variant:add", () => this.previousElementSibling.hidden = true, {once : true} );
};

var _on_recipient_form_changed, on_recipient_form_changed_fn,
_cart_error2, _cart_error2_fn,
_displayErrorMessage, displayErrorMessage_fn,
_createErrorListItem, createErrorListItem_fn,
_clearErrorMessage, clearErrorMessage_fn;
// https://github.com/Shopify/dawn/blob/main/assets/recipient-form.js
class RecipientForm extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_on_recipient_form_changed, this);
    getterAdd(_cart_error2, this);
    getterAdd(_displayErrorMessage, this);
    getterAdd(_createErrorListItem, this);
    getterAdd(_clearErrorMessage, this);
    this.recipientFieldsLiveRegion = $4(`#Recipient-fields-live-region-${this.sectionId}`, this);
    this.checkboxInput = $4(`#Recipient-checkbox-${this.sectionId}`, this);
    this.checkboxInput.disabled = false;
    this.hiddenControlField = $4(`#Recipient-control-${this.sectionId}`, this);
    this.hiddenControlField.disabled = true;

    this.emailInput = $4(`#Recipient-email-${this.sectionId}`, this);
    this.nameInput = $4(`#Recipient-name-${this.sectionId}`, this);
    this.messageInput = $4(`#Recipient-message-${this.sectionId}`, this);
    this.sendonInput = $4(`#Recipient-send-on-${this.sectionId}`, this);
    this.offsetProperty = $4(`#Recipient-timezone-offset-${this.sectionId}`);
    if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

    this.errorMessageWrapper = $4('.hdt-form__message-wrapper', this);
    this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
    this.errorMessage = this.errorMessageWrapper?.querySelector('.hdt-error-message');
    this.defaultErrorHeader = this.errorMessage?.innerText;
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    this.checkboxInput.addEventListener('change', getterRunFn(_on_recipient_form_changed, this, on_recipient_form_changed_fn).bind(this), { signal: this.#abortController.signal });
    this.form?.addEventListener("cart:add:error", getterRunFn(_cart_error2, this, _cart_error2_fn).bind(this), { signal: this.#abortController.signal });
    this.form?.addEventListener("variant:add", getterRunFn(_clearErrorMessage, this, clearErrorMessage_fn).bind(this), { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get form() {
    return document.forms[this.getAttribute("form")];
  }
  get sectionId() {
    return this.dataset.sectionId;
  }

  inputFields() {
    return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
  }

  disableableFields() {
    return [...this.inputFields(), this.offsetProperty];
  }

  // clearInputFields() {
  //   this.inputFields().forEach((field) => (field.value = ''));
  // }

  enableInputFields() {
    this.disableableFields().forEach((field) => (field.disabled = false));
  }

  disableInputFields() {
    this.disableableFields().forEach((field) => (field.disabled = true));
  }
};
_on_recipient_form_changed = new WeakSet();
on_recipient_form_changed_fn = function() {
  if (this.checkboxInput.checked) {
    this.enableInputFields();
    this.recipientFieldsLiveRegion.innerText =  this.recipientFieldsLiveRegion.dataset.expanded;
  } else {
    this.disableInputFields();
    this.recipientFieldsLiveRegion.innerText = this.recipientFieldsLiveRegion.dataset.collapsed
  }
};
_cart_error2 = new WeakSet();
_cart_error2_fn = function(event) {
  if (!event.detail.isGiftCardRecipient) return;
  console.log(event.detail)
  getterRunFn(_displayErrorMessage, this, displayErrorMessage_fn).call(this, event.detail.error);
};

_displayErrorMessage = new WeakSet();
displayErrorMessage_fn = function(body) {
  getterRunFn(_clearErrorMessage, this, clearErrorMessage_fn).call(this);
  this.errorMessageWrapper.hidden = false;
  if (typeof body === 'object') {
    this.errorMessage.innerText = this.defaultErrorHeader;
    return Object.entries(body).forEach(([key, value]) => {
      const errorMessageId = `RecipientForm-${key}-error-${this.sectionId}`;
      const fieldSelector = `#Recipient-${key}-${this.sectionId}`;
      const message = `${value.join(', ')}`;
      const errorMessageElement = this.querySelector(`#${errorMessageId}`);
      const errorTextElement = errorMessageElement?.querySelector('.hdt-error-message');
      if (!errorTextElement) return;

      if (this.errorMessageList) {
        this.errorMessageList.appendChild(getterRunFn(_createErrorListItem, this, createErrorListItem_fn).call(this, fieldSelector, message));
      }

      errorTextElement.innerText = `${message}.`;
      errorMessageElement.removeAttribute('hidden');

      const inputElement = this[`${key}Input`];
      if (!inputElement) return;

      inputElement.setAttribute('aria-invalid', true);
      inputElement.setAttribute('aria-describedby', errorMessageId);
    });
  }

  this.errorMessage.innerText = body;
};

_createErrorListItem = new WeakSet();
createErrorListItem_fn = function(target, message) {
  const li = document.createElement('li');
  const a = document.createElement('a');
  a.setAttribute('href', target);
  a.innerText = message;
  li.appendChild(a);
  li.className = 'hdt-error-message';
  return li;
};

_clearErrorMessage = new WeakSet();
clearErrorMessage_fn = function() {
  this.errorMessageWrapper.hidden = true;

  if (this.errorMessageList) this.errorMessageList.innerHTML = '';

  this.querySelectorAll('.hdt-recipient-fields .hdt-form__message').forEach((field) => {
    field.setAttribute('hidden', '');
    const textField = field.querySelector('.hdt-error-message');
    if (textField) textField.innerText = '';
  });

  [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach((inputElement) => {
    inputElement.setAttribute('aria-invalid', false);
    inputElement.removeAttribute('aria-describedby');
  });
};

customElements.define("wrapp-hdt-pr-frm", ProductForm);
customElements.define("wrapp-hdt-pr-frm-bundle", ProductFormBundle);
customElements.define("hdt-bundle-product", bundleProduct);
customElements.define("hdt-buy-buttons", BuyButtons);
customElements.define('hdt-recipient-form', RecipientForm);

var _on_value_change, on_value_change_fn,
_variants_data,
_find_closest_variant, find_closest_variant_fn,
_update_variant_statuses, update_variant_statuses_fn,
_update_url, update_url_fn,
_master_input_change, master_input_change_fn;
class VariantPicker extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_on_value_change, this);
    getterAdd(_find_closest_variant, this);
    getterAdd(_update_variant_statuses, this);
    getterAdd(_update_url, this);
  }
  async connectedCallback() {
    this.#abortController = new AbortController();
    if (!this.hasAttribute('handle')) return;
    var variantsJSON = (await (await getJSONProduct.load(this.getAttribute('handle')))).variants;


    // Update variantsJSON when use hideSoldOutVariants ( update: remove variant sold out)
    if (this.hideSoldOutVariants ) {
      variantsJSON = variantsJSON.filter((variant) => variant.available);
    }

    // Update attr variant
    const tempContent = new DOMParser().parseFromString(this.nextElementSibling.textContent, "text/html");
    if (tempContent) {
      $$4('select > option', tempContent).forEach((option, index) => {
        const optionDataset = option.dataset;
        let currentVariant = variantsJSON[index];
        currentVariant = Object.assign( currentVariant, {
          // incoming : optionDataset.incoming === 'true',
          // next_incoming_date: optionDataset.nextincomingdate || null,
          // next_incoming_date_format: optionDataset.nextincomingdateformat || null,
          inventory_policy: optionDataset.inventorypolicy || null,
          inventory_quantity: parseInt(optionDataset.inventoryquantity),
          mdid: optionDataset.mdid || null
        });
        currentVariant.variant_state = {
          sold_out: !currentVariant.available,
          on_sale : currentVariant.compare_at_price > currentVariant.price,
          pre_order : currentVariant.inventory_management == 'shopify' && currentVariant.inventory_quantity <= 0 && currentVariant.available
        }
        // Fix if variant not exit a quantity_rule
        if (!currentVariant.quantity_rule) currentVariant.quantity_rule = { min: 1, max: null, increment: 1, max4: true }
        // Fix get a max qty of variant
        const { inventory_quantity, inventory_management, inventory_policy} = currentVariant;
        if (!currentVariant.quantity_rule.max && inventory_quantity > 0 && inventory_management != null && inventory_policy != 'continue') {
          currentVariant.quantity_rule.max = inventory_quantity;
          currentVariant.quantity_rule.max4 = true;
        }
      });
    }
    // console.log(variantsJSON)
    // Update _variants_data when use hideSoldOutVariants ( update: remove variant sold out)
    // if (this.hideSoldOutVariants ) {
    //   getterAdd(_variants_data, this, variantsJSON.filter((variant) => variant.available));
    // } else {
    //   getterAdd(_variants_data, this, variantsJSON);
    // }
    getterAdd(_variants_data, this, variantsJSON);
    // clear variantsJSON
    variantsJSON = null;
    //console.log(getterGet(_variants_data, this))
    this.masterInput = this.idELForm;
    // update url first time
    getterRunFn(_update_url, this, update_url_fn).call(this, true);

    if (!this.masterInput) return;
    this.masterInput.disabled = false;

    getterAdd(_master_input_change, this);
    this.addEventListener('change', getterRunFn(_on_value_change, this, on_value_change_fn).bind(this), { signal: this.#abortController.signal });
    this.masterInput.addEventListener('change', getterRunFn(_master_input_change, this, master_input_change_fn).bind(this), { signal: this.#abortController.signal });

    // To trigger when use type dropdown
    $$4('fieldset[type^="dropdown"]', this).forEach((fieldset) => {
      $4('hdt-popover', fieldset).addEventListener("richlist:change", (e) => {
        const input = $4(`input[type="hidden"][name="option${parseInt(fieldset.dataset.index) + 1}"]`, fieldset);
        if (input.value == e.detail.value) return;
        input.value = e.detail.value;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }, { signal: this.#abortController.signal });
    });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }

  // comment by kashif @ 17th Dec
  // get idELForm() {
  //   const formId = this.getAttribute("form");
  //   if (!document.forms[formId] ) {
  //     const formHtml = `<form id="${formId}" action="${Shopify.routes.root}cart/add.js" method="POST" hidden><input type="hidden" name="id" value="${this.getAttribute('selected-variant')}"></form>`;
  //     this.insertAdjacentHTML("afterend", formHtml);
  //   }
  //   return document.forms[formId].id;
  // }

  get idELForm() {
  const formId = this.getAttribute("form");

  // Ensure the form exists
  let form = document.getElementById(formId) || document.forms[formId];
  if (!form) {
    const formHtml = `
      <form id="${formId}" action="${Shopify.routes.root}cart/add.js" method="POST" hidden>
        <input type="hidden" name="id" value="${this.getAttribute('selected-variant')}">
      </form>`;
    this.insertAdjacentHTML("afterend", formHtml);
    form = document.getElementById(formId);
  }

  // Return the INPUT element, not the form id string
  return form?.querySelector('input[name="id"]') || null;
}


  get hideSoldOutVariants() {
    return this.hasAttribute("hide-sold-out-variants");
  }
  get updateUrl() {
    return this.getAttribute("update-url");
  }
  get updateStatus() {
    return this.hasAttribute("update-status");
  }
  get productMedia() {
    return this._productMedia = this._productMedia || $4(`hdt-product-media[form="${this.getAttribute("form")}"]`);
  }
  getvariantObjById(id) {
    return getterGet(_variants_data, this).find((variant) => variant.id == id);
  }

  updateOptions() {
    const fieldsets = $$4('fieldset', this);
    this.options = fieldsets.map((fieldset) => {
      return $$4('input', fieldset).find((input) => input.checked || input.type == 'hidden')?.value;
    }).filter(function( value ) {
      return value !== undefined && value !== '';
   })
  }
  updateMasterId() {
    this.currentVariant = getterGet(_variants_data, this).find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  selectVariantByID(id, jumpMedia = true) {
    if ( !this.hasAttribute('no-pick') ) this.selectVariantByVariantObj(this.getvariantObjById(id), jumpMedia);
  }
  selectVariantByVariantObj(variant, jumpMedia = true, overwrite = false) {
    if (typeof variant != 'object') return;
    // check variant can active
    if ( getterGet(_variants_data, this).includes(variant) ) {
      this.options = variant.options;
      this.currentVariant = variant;
      this.selectVariant(false, jumpMedia, overwrite);
    }
  }
  selectVariant(untriggerChangeEvent = false, jumpMedia = true, overwrite = false) {
    if (this.oldVariant && this.oldVariant.id === this.currentVariant.id && !overwrite) {
      return;
    }
    //console.log(this.options, this.currentVariant)
    this.oldVariant = this.currentVariant;

    this.masterInput.value = this.currentVariant.id;
    this.masterInput.dispatchEvent(new CustomEvent("change", { bubbles: true, detail: { hasVariant: true, untriggerChangeEvent } }));

    getterRunFn(_update_variant_statuses, this, update_variant_statuses_fn).call(this);
    getterRunFn(_update_url, this, update_url_fn).call(this);

    this.masterInput.form.dispatchEvent(new CustomEvent(variantChange, {
      bubbles: true,
      detail: {
        variant: this.currentVariant,
        jumpMedia
      }
    }));
  }
};
_variants_data = new WeakMap();
_on_value_change = new WeakSet();
on_value_change_fn = function(event) {
  if (!event.target.hasAttribute("is-value")) return;
  const fieldset = event.target.closest('fieldset');
  this.clickedCurrentIndex = parseInt(fieldset.dataset.index);
  this.clickedCurrentValue = event.target.value;
  //console.log(event)

  this.updateOptions();
  if (this.options.length < parseInt(this.dataset.size)) {
    $4('[update-value]', fieldset).textContent = this.clickedCurrentValue;
    const tmpOptions = ['nanthan94', 'nanthan94', "nanthan94"];
    tmpOptions[this.clickedCurrentIndex] = this.clickedCurrentValue;
    this.productMedia?.dispatchEvent(new CustomEvent('update:value', {
      detail: { options: tmpOptions }
    }));
    return;
  }
  this.removeAttribute('no-pick');
  this.updateMasterId();
  // Check unavailable
  if (!this.currentVariant) {
    getterRunFn(_find_closest_variant, this, find_closest_variant_fn).call(this);
  }
  this.selectVariant(true);
};
_master_input_change = new WeakSet();
master_input_change_fn = function(event) {

  if (!event.detail || !event.detail.hasVariant) {
    this.currentVariant = this.getvariantObjById(event.target.value);
  }
  if (!this.currentVariant) return;
  let arrInputChange = [];
  // Update value selected
  $$4('fieldset[data-index]', this).forEach((fieldset, index) => {
    // https://github.com/mathiasbynens/CSS.escape/blob/master/css.escape.js
    let value              = this.currentVariant.options[index],
        type               = fieldset.getAttribute('type'),
        updateValue        = $4('[update-value]', fieldset),
        input              = $4(`input[type="radio"][value="${CSS.escape(value)}"], input[type="hidden"][name="option${index + 1}"]`, fieldset),
        triggerChangeEvent = false;

    //console.log(value, input);
    if (type.startsWith('dropdown')) {
      triggerChangeEvent = input.value !== value;
      input.value = value;
      const richlist = $4('hdt-richlist', fieldset);
      if (richlist) richlist.selected = value;
    } else {
      triggerChangeEvent = !input.checked && input.value === value;
      input.checked = true;
    }
    if ( event.detail && event.detail.untriggerChangeEvent) triggerChangeEvent = false;

    if (updateValue) updateValue.textContent = value;

    if (triggerChangeEvent) arrInputChange.push(input);
    // if (triggerChangeEvent) {
    //   input.dispatchEvent(new CustomEvent("change", {
    //     bubbles: true
    //   }));
    // }
  });
  arrInputChange.forEach((input) => input.dispatchEvent(new CustomEvent("change", { bubbles: true })));
  arrInputChange = [];
};
_find_closest_variant = new WeakSet();
find_closest_variant_fn = function() {
  let found           ,
  optionSize          = parseInt(this.dataset.size),
  unRemoveSoldout     = !this.hideSoldOutVariants;
  if ( optionSize == 1 ) {
    found = getterGet(_variants_data, this).filter((variant) => variant.available);
  } else if ( optionSize == 3 ) {
    found = getterGet(_variants_data, this).filter((variant) => variant.option1 == this.options[0] && variant.option2 == this.options[1] && (unRemoveSoldout || variant.available));
  } else {
    found = getterGet(_variants_data, this).filter((variant) => variant.option1 == this.options[0] && (unRemoveSoldout || variant.available));
  }
  if (!found[0]) {
    found = getterGet(_variants_data, this).filter((variant) => variant.options[this.clickedCurrentIndex] == this.clickedCurrentValue && (unRemoveSoldout || variant.available));
    //console.log('found 2', found)
  }
  this.currentVariant = found[0];
  // this.masterInput.value = this.currentVariant.id;
  // this.masterInput.dispatchEvent(new CustomEvent("change", {
  //   bubbles: true,
  //   detail: { hasVariant: true, gotoMedia }
  // }));
};
_update_variant_statuses = new WeakSet();
// https://stackoverflow.com/questions/1960473/get-all-unique-values-in-a-javascript-array-remove-duplicates
function onlyUnique(value, index, array) {
  return array.indexOf(value) === index;
}
update_variant_statuses_fn = function() {
  if (!this.updateStatus) return;
  const variants_option2 = getterGet(_variants_data, this).filter((variant) => variant.option1 == this.currentVariant.option1),
  variants_option3 = getterGet(_variants_data, this).filter((variant) => variant.option1 == this.currentVariant.option1 && variant.option2 == this.currentVariant.option2),
  variants_option1_arr = getterGet(_variants_data, this).map((variant) => variant.option1).filter(onlyUnique),
  variants_option2_arr = variants_option2.map((variant) => variant.option2).filter(onlyUnique),
  variants_option3_arr = variants_option3.map((variant) => variant.option3).filter(onlyUnique),
  variants_option1_available_arr = getterGet(_variants_data, this).filter((variant) => variant.available).map((variant) => variant.option1).filter(onlyUnique),
  variants_option2_available_arr = variants_option2.filter((variant) => variant.available).map((variant) => variant.option2).filter(onlyUnique),
  variants_option3_available_arr = variants_option3.filter((variant) => variant.available).map((variant) => variant.option3).filter(onlyUnique);
  // console.log(variants_option2, variants_option3)
  // console.log(variants_option1_arr, variants_option2_arr, variants_option3_arr)
  // console.log(variants_option1_available_arr, variants_option2_available_arr, variants_option3_available_arr)

  $$4('fieldset[data-index]', this).forEach((fieldset, index) => {
    let index_option = ++index;
    $$4('[type="radio"], hdt-richlist > button', fieldset).forEach((input) => {
      let option_unavailable = true,
          option_soldout     = true;
      //console.log(index_option)
      switch(index_option) {
        case 1:
          if (variants_option1_arr.includes(input.value)) option_unavailable = false;
          if (variants_option1_available_arr.includes(input.value)) option_soldout = false;
          break;
        case 2:
          if (variants_option2_arr.includes(input.value)) option_unavailable = false;
          if (variants_option2_available_arr.includes(input.value)) option_soldout = false;
          break;
        default:
          if (variants_option3_arr.includes(input.value)) option_unavailable = false;
          if (variants_option3_available_arr.includes(input.value)) option_soldout = false;
      }
      input.classList.toggle('is-disabled', option_soldout);
      input.classList.toggle('is-unavailable', option_unavailable);
    });
  });
};
_update_url = new WeakSet();
update_url_fn = function(isFrist) {
  if (!this.updateUrl || !history.replaceState) return;
  const newUrl = new URL(window.location.href);
  const id = isFrist ? this.updateUrl : this.currentVariant.id;
  if (id) {
    newUrl.searchParams.set("variant", id);
  } else {
    newUrl.searchParams.delete("variant");
  }
  window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
}
// test
// document.addEventListener("variant:change", (event)=> {
//   console.log('event variant change')
//   console.log(event.detail.variant)
// });
class VariantChangeBase extends HTMLElement {
  constructor() {
    super();
    this._onVariantChanged = this.onVariantChanged.bind(this);
  }
  get form() {
    return this._form = this._form || document.forms[this.getAttribute("form")];
  }
  connectedCallback() {
    this.form?.addEventListener(variantChange, this._onVariantChanged);
  }
  disconnectedCallback() {
    this.form?.removeEventListener(variantChange, this._onVariantChanged);
  }
  onVariantChanged() { }
};
class Price extends VariantChangeBase {
  // get price() {
  //   return this._price = this._price || $4('.hdt-money', this);
  // }
  onVariantChanged(event) {
    
    const variant = event.detail.variant;

    $4('.hdt-money', this).outerHTML = `<span class="hdt-money">${formatMoney(variant.price, currencyFormat)}</span>`;
    this.classList.toggle("hdt-price-on-sale", variant.variant_state.on_sale);
    // CHANGE SELECTED VARIANT OPTION NAME 
    const selectedTitleEl = document.querySelector('.hdt-product-form__label.hdt-s-text.hdt-text-lg span.opt_name span');
    if (selectedTitleEl && variant?.title) {
      selectedTitleEl.textContent = variant.title;
    }

    document.dispatchEvent(new CustomEvent("currency:update"));
    this.dispatchEvent(new CustomEvent("price:update"));
  }
};
class CompareAtPrice extends Price {
  onVariantChanged(event) {
    const variant = event.detail.variant;
    this.hidden = !(variant.compare_at_price > variant.price);
    if (!this.hidden) {
      $4('.hdt-money', this).outerHTML = `<span class="hdt-money">${formatMoney(variant.compare_at_price, currencyFormat)}</span>`;
      //this.price.textContent = formatMoney(variant.compare_at_price, currencyFormat);
      document.dispatchEvent(new CustomEvent("currency:update"));
      this.dispatchEvent(new CustomEvent("price:update"));
    }
  }
};
class UnitPrice extends Price {
  onVariantChanged(event) {
    const variant = event.detail.variant;
    this.hidden = !variant.unit_price;
    if (!this.hidden) {
      //this.price.textContent = formatMoney(variant.unit_price, currencyFormat);
      $4('.hdt-money', this).outerHTML = `<span class="hdt-money">${formatMoney(variant.unit_price, currencyFormat)}</span>`;
      document.dispatchEvent(new CustomEvent("currency:update"));
      this.dispatchEvent(new CustomEvent("price:update"));
    }
  }
};
class QtyPrice extends Price {
  constructor() {
    super();
    this._onVariantChanged = this.onVariantChanged.bind(this);
  }
  get qty() {
    return this._qty || $4(`[name="quantity"][form="${this.getAttribute("form")}"]`);
  }
  onVariantChanged(event) {
    this.setAttribute('variant-price', event.detail.variant.price);
    this.hidden = false;
    this.updatPrice();
  }
  connectedCallback() {
    super.connectedCallback();
    this.qty?.addEventListener('change', this.updatPrice.bind(this) );
    this.qty?.addEventListener('input', debounce( this.updatPrice.bind(this), 300));
  }
  updatPrice() {
    const price = parseFloat(this.getAttribute('variant-price'));
    $4('.hdt-money', this).outerHTML = `<span class="hdt-money">${formatMoney(price * (this.qty ? this.qty.value : 1), currencyFormat)}</span>`;
    document.dispatchEvent(new CustomEvent("currency:update"));
  }
};
class Badge extends VariantChangeBase {
  constructor() {
    super();
    this.updateHiddenParent();
    if (this.parentElement) this.parentElement.classList.add('js-intent')
  }
  get is() {
    return this.getAttribute('is');
  }
  get type() {
    return this.getAttribute('type');
  }
  updateHiddenParent() {
    if (this.parentElement && this.hasAttribute('update-hidden')) {
      this.parentElement.removeAttribute('hidden');
      this.parentElement.hidden = !this.parentElement.clientHeight;
    }
  }

  onVariantChanged(event) {
    const variant = event.detail.variant
    this.hidden = (this.is != 'available') ? !variant.variant_state[this.is] : !variant.available;
    this.updateHiddenParent();
    const percentEl = $4('[percent]', this);
    if (!this.hidden && this.type === 'percentage' && percentEl) {
      const savePercent = ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price;
      if (savePercent != percentEl.textContent) percentEl.textContent = Math.max(1, Math.round(savePercent));
    }
  }
};
var _update_inventory_status, update_inventory_status_fn,
_show_quantity_inventory = new WeakMap(),
_threshold_inventory = new WeakMap(),
_progressBar_inventory = new WeakMap();
class VariantInventory extends VariantChangeBase {
  constructor() {
    super();
    getterAdd(_update_inventory_status, this);
    getterAdd(_show_quantity_inventory, this, this.hasAttribute('show-inventory-quantity'));
    getterAdd(_threshold_inventory, this, parseInt(this.getAttribute('inventory-threshold')));
    getterAdd(_progressBar_inventory, this, $4('.hdt-progress-bar', this));
  }
  get progressBar() {
    return getterGet(_progressBar_inventory, this);
  }
  onVariantChanged(event) {
    getterRunFn(_update_inventory_status, this,update_inventory_status_fn).call(this, event.detail.variant);
  }
};
_update_inventory_status = new WeakSet();
update_inventory_status_fn = function(variant){
  let stringSelector = '';
  if (variant.available) {
    // continue : Continue selling when the variant is out of stock.
    // deny : Stop selling when the variant is out of stock.
    if (variant.inventory_quantity > 0) {
      if (variant.inventory_quantity <= getterGet(_threshold_inventory, this) && variant.requires_shipping) {
        stringSelector = getterGet(_show_quantity_inventory, this) ? 'low-stock-count' : 'low-stock';
      } else {
        stringSelector = getterGet(_show_quantity_inventory, this)? 'in-stock-count' : 'in-stock';
      }
    } else {
      //stringSelector = variant.next_incoming_date && variant.requires_shipping ? 'not-ship-stock' :  variant.inventory_management == 'shopify' ? 'pre-order-stock' : 'in-stock';
      stringSelector = variant.inventory_management == 'shopify' ? 'pre-order-stock' : 'in-stock';
    }
  } else {
    stringSelector = 'out-of-stock';
  }
  // else {
  //   stringSelector = variant.incoming && variant.next_incoming_date ? 'will-in-stock' : 'out-of-stock';
  // }
  // if (stringSelector == 'not-ship-stock' || stringSelector == 'will-in-stock') {
  //   $$4('[data-incoming-date]', this).forEach((dateEl) => dateEl.textContent = variant.next_incoming_date_format);
  // }
  if (stringSelector == 'low-stock' || stringSelector == 'in-stock' || stringSelector == 'low-stock-count' || stringSelector == 'in-stock-count') {
    $$4('[data-quantity]', this).forEach((dateEl) => dateEl.textContent = variant.inventory_quantity);
    // update progress bar
    if (this.progressBar) {
      this.progressBar.hidden = false;
      this.progressBar.valueNow = variant.inventory_quantity > 0 ? variant.inventory_quantity : this.progressBar.getAttribute("aria-valuemax");
      //this.progressBar.classList.toggle('hdt-continue-instock', continueInstock);
    }
  } else {
    this.progressBar?.setAttribute('hidden', '') ;
  }
  $4('.hdt-stock-status:not([hidden])', this)?.setAttribute('hidden', '') ;
  $4(`.hdt-stock-status[${stringSelector || 'nt94'}]`, this)?.removeAttribute('hidden');
};
class VariantLive extends VariantChangeBase {
  get is() {
    return this.getAttribute('is'); // sku, available, barcode
  }
  onVariantChanged(event) {
    const variant = event.detail.variant;
    this.hidden = !variant || variant[this.is] === '';
    if (!this.hidden) {
      const that = $4('[update-value]', this) || this;
      that.innerText = variant[this.is];
    }
  }
};
var _pickup_availability, pickup_availability_fn;
class PickupAvailability extends VariantChangeBase {
  constructor() {
    super();
    getterAdd(_pickup_availability, this);
  }
  onVariantChanged(event) {
    getterRunFn(_pickup_availability, this, pickup_availability_fn).call(this, event.detail.variant);
  }
};
_pickup_availability = new WeakSet();
pickup_availability_fn = async function(variant) {
  if (!variant) {
    this.innerHTML = "";
  } else {
    const element = document.createElement("div");
    this.setAttribute('loading', '');
    element.innerHTML = await (await fetch(`${Shopify.routes.root}variants/${variant.id}?section_id=pickup-availability`)).text();
    this.replaceChildren(...element.querySelector("hdt-pickup-availability").childNodes);
    this.removeAttribute('loading', '');
  }
};
var _create_img2, create_img2_fn;
class VariantPreviewImg extends VariantChangeBase {
  constructor() {
    super();
    getterAdd(_create_img2, this);
  }
  onVariantChanged(event) {
    const variant = event.detail.variant,
    imgMain = $4('img', this);
    if (!variant || !variant.featured_image || !imgMain) return;
    imgMain.replaceWith(getterRunFn(_create_img2, this, create_img2_fn).call(this, variant.featured_image, imgMain));
  }
};
_create_img2 = new WeakSet();
create_img2_fn = function(objImage, imgMain) {
  return createImg(
    Object.assign(
      objImage,
      {
        onload: true,
        attrs: {
          class: imgMain.className,
          sizes: imgMain.sizes,
          'data-widths': imgMain.getAttribute('data-widths') || '[]'
        }
      }
    )
  )
};
class PaymentTerms extends VariantChangeBase {
  onVariantChanged(event) {
    if (event.detail.variant) {
      const inputId = $4('[name="id"]', this);
      inputId.value = event.detail.variant.id;
      inputId.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
};

class BackInStock extends VariantChangeBase {
  connectedCallback() {
    if ( this.hasAttribute('is-pr-default') ) return;
    this.select = $4('[back-instock-select]', this);
    this.originalText = $4('[back-instock-text]', this).textContent;
    this.elReplace = $4('[name="contact[product]"]', this);

    this.select.addEventListener('change', (e) => {
      this.elReplace.textContent = this.originalText.replace('nt94_name', this.select.selectedOptions[0].textContent).replace('nt94_vid', this.select.value);
    });

    super.connectedCallback();
  }
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (this.hasAttribute('toogle-hidden')) this.hidden = variant && variant.available;
    if (variant && !variant.available && this.select.value != variant.id) {
      this.select.value = variant.id;
      this.select.dispatchEvent(new Event("change", { bubbles: false }));
    }
  }
};
/**
* Update incoming mess
*/
class IncomingMess extends VariantChangeBase {
  connectedCallback() {
    if ( this.hasAttribute('is-pr-default') ) return;
    super.connectedCallback();
  }
  onVariantChanged(event) {
    const variant = event.detail.variant,
          nextincomingdateformat = JSON.parse(this.dataset.obj)[variant.id];
    this.hidden = !variant || !nextincomingdateformat;
    if (!nextincomingdateformat) return;
    $4('[data-incoming-date]', variant.available ? this.firstElementChild : this.lastElementChild).textContent = nextincomingdateformat;
    this.firstElementChild.hidden = !variant.available || !variant.requires_shipping;
    this.lastElementChild.hidden = !this.firstElementChild.hidden;
  }
};

var _sticky_select = new WeakMap(),
_formElement = new WeakMap(),
_quickOrderElement = new WeakMap(),
_intersection_observer = new WeakMap(),
_form_atc_visible,
form_atc_visible_fn,
_latestFormCondition = new WeakMap(),
stickyRunOne = true;
class StickyATC extends VariantChangeBase {
  #preVariantId;
  constructor() {
    super(...arguments);
    getterAdd(_form_atc_visible, this);
    getterAdd(_latestFormCondition, this, false);
    getterAdd(_intersection_observer, this, new IntersectionObserver(getterRunFn(_form_atc_visible, this, form_atc_visible_fn).bind(this)));
  }
  connectedCallback() {
    // show/hide sticky add to cart
    getterAdd(_formElement, this, document.forms[this.getAttribute("form")]);
    if (getterGet(_formElement, this)) {
      getterGet(_intersection_observer, this).observe(getterGet(_formElement, this));
      getterAdd(_quickOrderElement, this, $4('hdt-quick-order-list'));
      if (getterGet(_quickOrderElement, this)) getterGet(_intersection_observer, this).observe(getterGet(_quickOrderElement, this));
    }

    if ( this.hasAttribute('is-pr-default') ) return;
    getterAdd(_sticky_select, this, $4('[tag-select]', this));
    this.#preVariantId = getterGet(_sticky_select, this).value;
    super.connectedCallback();
    getterGet(_sticky_select, this).addEventListener('change', (e) => {
      this.variantPicker?.selectVariantByID(e.target.value, $4('.hdt-product-media__main hdt-slider')?.isActive);
    });
  }
  get variantPicker() {
    return this._variantPicker = this._variantPicker || $4(`hdt-variant-picker[form="${this.getAttribute("form")}"]`);
  }
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant && this.#preVariantId != variant.id) {
      getterGet(_sticky_select, this).value = variant.id;
      this.#preVariantId = getterGet(_sticky_select, this).value;
      //getterGet(_sticky_select, this).dispatchEvent(new Event("change", { bubbles: false }));
      // update img
      const imgMain = $4('[data-v-img]', this),
      featured_image = variant.featured_image;
      if (imgMain && featured_image) {
        const vimg = createImg({
          src: featured_image.src,
          width: imgMain.getAttribute('width'),
          height: imgMain.getAttribute('height'),
          alt: imgMain.alt,
          onload: true,
          attrs: {
            class: imgMain.className,
            sizes: imgMain.sizes,
            'data-widths': imgMain.getAttribute('data-widths') || '[]',
            'data-v-img': ''
          }
        });
        imgMain.replaceWith(vimg);
      }
      // Update qty
      $4('wrapp-hdt-pr-frm > form', this).dispatchEvent(new CustomEvent(variantChange, {
        bubbles: false,
        detail: { variant, jumpMedia: false }
      }));
      // Update btn atc
      $4('[name="add"]', this).disabled = !variant || !variant.available;
      $4('[name="add"]', this).firstElementChild.textContent = themeHDN.extras[!variant ? 'unavailable' : variant.variant_state.pre_order ? 'preOrder' : variant.available ? 'addToCart' : 'soldOut'];
    }
  }
};
_form_atc_visible = new WeakSet();
form_atc_visible_fn = function(entries){

  if (this.variantPicker?.hasAttribute('no-pick')) {
    stickyRunOne = false;
    document.body.style.setProperty('--sticky-atc-height', '0px');
    return;
  }

  document.body.style.removeProperty('--sticky-atc-height');
  const formEntry = entries.find((entry) => entry.target === getterGet(_formElement, this));
  const quickOrderEntry = getterGet(_quickOrderElement, this) ? entries.find((entry) => entry.target === getterGet(_quickOrderElement, this)) : false;
  // console.log(formEntry)
  if (formEntry) {
    getterAdd(_latestFormCondition, this, !formEntry.isIntersecting && formEntry.boundingClientRect.bottom < 0, true);
  }
  if (quickOrderEntry && getterGet(_quickOrderElement, this)) {
    getterAdd(_latestFormCondition, this, !quickOrderEntry.isIntersecting, true);
  }
  document.body.classList.toggle("sticky-shown", getterGet(_latestFormCondition, this));
  if (stickyRunOne && !getterGet(_latestFormCondition, this)) {
    setTimeout(() => {
      //getterAdd(_latestFormCondition, this, !formEntry.isIntersecting && (window.innerHeight + Math.round(window.scrollY)) >= document.body.offsetHeight, true);
      getterAdd(_latestFormCondition, this, (window.innerHeight + Math.round(window.scrollY)) >= document.body.offsetHeight, true);
      document.body.classList.toggle("sticky-shown", getterGet(_latestFormCondition, this));
      stickyRunOne = false
    }, 100);
  }
}

var _copy_to_clipboard, copy_to_clipboard_fn;
class CopyButton extends HTMLElement {
  constructor() {
    super();
    getterAdd(_copy_to_clipboard, this);
    this.addEventListener("click", getterRunFn(_copy_to_clipboard, this, copy_to_clipboard_fn).bind(this, this.input));
    this.actionCopy = !this.input ? 'textContent' : 'value';
    if (this.input && this.hasAttribute("get-document")) {
      this.closest('hdt-popover')?.addEventListener("dialog:beforeOpen", (event) => {
        this.input[this.actionCopy] = this.textCopy;
      });
    }
  }
  get input() {
    return $id4(this.getAttribute("text-id"));
  }
  get textCopy() {
    return this.hasAttribute("get-document") ? document.location.href : this.getAttribute("data-text") || "";
  }
};
_copy_to_clipboard = new WeakSet();
copy_to_clipboard_fn = async function(input) {
  if (!navigator.clipboard) return;
  await navigator.clipboard.writeText(this.textCopy);
  if (this.hasAttribute("data-success-message")) {
    input = input || this;
    const originalText = input[this.actionCopy];
    input[this.actionCopy] = this.getAttribute("data-success-message");
    setTimeout(() => {
      input[this.actionCopy] = originalText;
    }, 1500);
  }
};

var _native_share, native_share_fn;
class ShareButton extends HTMLElement {
  constructor() {
    super();
    getterAdd(_native_share, this);
    // https://dev.to/timhuang/a-simple-way-to-detect-if-browser-is-on-a-mobile-device-with-javascript-44j3
    //if (navigator.share && navigator.userAgent && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    if (navigator.share && !window.matchMedia("screen and (pointer: fine)").matches) {
      this.hidden = false;
      this.addEventListener("click", getterRunFn(_native_share, this, native_share_fn));
    }
  }
};
_native_share = new WeakSet();
native_share_fn = function() {
  navigator.share({
    title: this.getAttribute("share-title") || document.title,
    url: this.getAttribute("share-link") || document.location.href
  });
};

var _variant_toogle, variant_toogle_fn;
class VaraintToogle extends HTMLElement {
  constructor() {
    super();
    getterAdd(_variant_toogle, this);
  }
  connectedCallback() {
    if ( this.firstElementChild ) document.addEventListener(variantChange, getterRunFn(_variant_toogle, this, variant_toogle_fn).bind(this));
  }
};
_variant_toogle = new WeakSet();
variant_toogle_fn = function(event) {
  const variant = event.detail.variant;
  //console.log(event, variant)
  $$4(`[variant-id]:not([hidden])`, this).forEach((variantInfo) => variantInfo.hidden = true);
  if (variant && variant.id) $4(`[variant-id="${variant.id}"]`, this)?.removeAttribute('hidden');
};

customElements.define('hdt-variant-picker', VariantPicker);
customElements.define('hdt-price', Price);
customElements.define('hdt-compare-at-price', CompareAtPrice);
customElements.define('hdt-unit-price', UnitPrice);
customElements.define('hdt-qty-price', QtyPrice);
customElements.define('hdt-badge', Badge);
customElements.define('hdt-variant-inventory', VariantInventory);
customElements.define('hdt-variant-live', VariantLive);
customElements.define('hdt-pickup-availability', PickupAvailability);
customElements.define('hdt-variant-preview-img', VariantPreviewImg);
customElements.define('hdt-payment-terms', PaymentTerms);
customElements.define('hdt-back-instock', BackInStock);
customElements.define('hdt-incoming-mess', IncomingMess);
customElements.define('hdt-sticky-btn-atc', StickyATC);
customElements.define("wrapp-hdt-copy-btn", CopyButton);
customElements.define("wrapp-hdt-share-btn", ShareButton);
customElements.define('hdt-varaint-toogle-info', VaraintToogle);

// document.addEventListener("currency:update", (e) =>  {
//   const _detail = e.detail;
//   if (!_detail || _detail.length == 0) return;
//   console.log(_detail);
//   CurrencyConvertAll(oldCurrency, newCurrency, _detail, format)
// });
// const CurrencyConvertAll = (oldCurrency, newCurrency, selector, format = '') => {

// }

var _onLoadingStart, onLoadingStart_fn, _onLoadingEnd, onLoadingEnd_fn;
class LoadingBar extends HTMLElement {
  constructor() {
    super();
    getterAdd(_onLoadingStart, this);
    getterAdd(_onLoadingEnd, this);
    document.addEventListener("theme:loading:doing", getterRunFn(_onLoadingStart, this, onLoadingStart_fn).bind(this));
    document.addEventListener("theme:loading:done", getterRunFn(_onLoadingEnd, this, onLoadingEnd_fn).bind(this));
  }
};
_onLoadingStart = new WeakSet();
onLoadingStart_fn = function() {
  animate(this, { opacity: [0, 1], transform: ["scaleX(0)", "scaleX(0.8)"] }, { duration: 0.5 });
};
_onLoadingEnd = new WeakSet();
onLoadingEnd_fn = async function() {
  await animate(this, { transform: [null, "scaleX(1)"] }, { duration: 0.25 }).finished;
  animate(this, { opacity: 0 }, { duration: 0.25 });
};
customElements.define("hdt-loading-bar", LoadingBar);

class RevealItems extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (_matchMedia("motion") && this.enabledReveal && $$4(this.selector, this).length > 0) {
    inView(this, this.reveal.bind(this));
    }
  }
  //disconnectedCallback() { }
  get selector() {
    const _selector = this.getAttribute('selector') || '.hdt-card-product';
    return (this.prependEl || '') + _selector + (this.appendEl || '').replaceAll(/nathan/g, _selector);
  }
  get enabledReveal() {
    return this.getAttribute('reveal-on-scroll') === 'true';
  }
  reveal() {
    animate($$4((this.selector), this), {
      opacity: [0, 1],
      transform: ["translateY(30px)", "translateY(0)"],
    },
    {
      duration: 0.25,
      easing: "ease",
      delay: stagger(0.05, { start: 0.3, easing: "ease" })
    });
    // .finished.then(() => {
    //   this.appendEl = '';
    // });
   // this.setEl = null;
    // .finished.then(() => {
    //   this.setEl = null;
    // });
  }
}
customElements.define("hdt-reval-items", RevealItems);

// Load More
var _load_more_url, load_more_url_fn,
_lm_render, lm_render_fn,
_lm_a = new WeakMap();
const str_shopify_section = 'shopify-section';
class LoadMore extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_load_more_url, this);
    getterAdd(_lm_render, this);
    getterAdd(_lm_a, this, $4('a', this));
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    this.abortController2 = null;
    getterGet(_lm_a, this).addEventListener("click", getterRunFn(_load_more_url, this, load_more_url_fn).bind(this), { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get idcontrol() {
    return '#'+ getterGet(_lm_a, this).getAttribute("append");
  }
};
_load_more_url = new WeakSet();
load_more_url_fn = function(event) {
  event.preventDefault();
  const url = new URL(getterGet(_lm_a, this).href);
  url.searchParams.set("section_id", getterGet(_lm_a, this).getAttribute("section-id"));
  getterRunFn(_lm_render, this, lm_render_fn).call(this, {detail:{ url, id: this.idcontrol }})
};
_lm_render = new WeakSet();
lm_render_fn = async function(event) {
  // console.log(event)
  if (this.abortController2) {
    this.abortController2.abort();
  }
  this.abortController2 = new AbortController();
  const url            = event.detail.url,
        section_id     = url.searchParams.get("section_id"),
        page_number    = url.searchParams.get("page"),
        idSelector     = this.getAttribute('tab-id') || `${str_shopify_section}-${section_id}`,
        shopifySection = document.getElementById(idSelector) || document.getElementById(`${str_shopify_section}-${section_id}`),
        clonedUrl      = new URL(url);
  clonedUrl.searchParams.delete("section_id");

  const mainContent        = $4(event.detail.id, shopifySection),
        $paginationWrapper = $4("[loadmore-btn-wrapp]", shopifySection);
  try {
    $paginationWrapper.setAttribute('loading', '');
    const tempContent = new DOMParser().parseFromString(await (await fetch(url.toString(), { signal: this.abortController2.signal }).then((response) => {
      // if (response.status === 200) {
      //   const contentType = response.headers.get("Content-Type");
      //   if (contentType && (contentType.match(/application\/json/i) || contentType.match(/text\//i))) {
      //     response.clone().text().then((content) => {
      //       // cache
      //     });
      //   }
      // }
      return response;
    })).text(), "text/html");
    //console.log(tempContent)
    const newMainContent = $4(`.${str_shopify_section} ${event.detail.id}`, tempContent);
    mainContent.lastElementChild.classList.add(`point-effect-${page_number}`);
    mainContent.append(...document.importNode(newMainContent, true).childNodes);
    mainContent.dispatchEvent(new CustomEvent("products:update", { bubbles: true }));
    if (_matchMedia("motion")) {
      mainContent.prependEl = `.point-effect-${page_number} ~ `;
      mainContent.reveal();
    }

    const $newPaginationWrapper = $4("[loadmore-btn-wrapp]", $4('#'+idSelector, tempContent));
    if ($newPaginationWrapper) {
      $paginationWrapper.replaceChildren(...document.importNode($newPaginationWrapper, true).childNodes);
      $paginationWrapper.removeAttribute('loading');
    } else {
      $paginationWrapper.remove();
    }

  } catch (e) { }
};
customElements.define("wrapp-hdt-lm-url", LoadMore);
var _qty_forms, _qty_inputs,
_on_variant_changed2, on_variant_changed2_fn,
_on_cart_changed2, on_cart_changed2_fn,
_update_quantity_rules, update_quantity_rules_fn,
_set_quantity_boundries, set_quantity_boundries_fn,
ON_CHANGE_DEBOUNCE_TIMER = 300,
_variant_picker2 = new WeakMap();
class QuantityWrapp extends HTMLElement {
  #abortController;
  constructor() {
    super(...arguments);
    //this.changeEvent = new Event('change', { bubbles: true });
    getterAdd(_qty_inputs, this, $4('input', this));
    getterAdd(_on_variant_changed2, this);
    getterAdd(_on_cart_changed2, this);
    getterAdd(_update_quantity_rules, this);
    getterAdd(_set_quantity_boundries, this);
    getterAdd(_variant_picker2, this, $4(`hdt-variant-picker[form="${this.getAttribute("form")}"]`));
  }
  get input() {
    return getterGet(_qty_inputs, this);
  }
  get quantityForm() {
    return $id4(`Quantity-Form-${this.getAttribute('section-id')}`);
  }
  async connectedCallback() {
    this.#abortController = new AbortController();
    if (!this.input) return;
    getterAdd(_qty_forms, this, document.forms[(this.getAttribute("form") || this.input.getAttribute("form") || '').replace('id:','')]);
    //this.input = $4('input', this);
    this.input.addEventListener('change', this.onInputChange.bind(this), { signal: this.#abortController.signal });
    $$4('button', this).forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this), { signal: this.#abortController.signal })
    );
    this.buttonMinus = $4(".hdt-quantity__button[name='minus']", this);
    this.buttonPlus = $4(".hdt-quantity__button[name='plus']", this);
    this.validateQtyRules();

    // product form quantity
    if ( this.quantityForm && this.hasAttribute('handle') ) {

      if (getterGet(_variant_picker2, this)) {
        // Delay get a varaints to variant picker
        await getJSONProduct.load(this.getAttribute('handle'));
        this.variants = getterGet(_variants_data, getterGet(_variant_picker2, this));
      } else {
        this.variants = (await (await getJSONProduct.load(this.getAttribute('handle')))).variants;
        const varaintFirst = this.variants[0];
        if (!varaintFirst.quantity_rule) varaintFirst.quantity_rule = { min: 1, max: null, increment: 1, max4: true };
        if (!varaintFirst.quantity_rule.max) {
          varaintFirst.quantity_rule.max = this.input.dataset.max;
          varaintFirst.quantity_rule.max4 = true;
        }
        this.variants[0] = varaintFirst;
      }
      getterRunFn(_set_quantity_boundries, this, set_quantity_boundries_fn).call(this);
      getterGet(_qty_forms, this)?.addEventListener(variantChange, getterRunFn(_on_variant_changed2, this, on_variant_changed2_fn).bind(this), { signal: this.#abortController.signal });
      document.addEventListener("cart:change", getterRunFn(_on_cart_changed2, this, on_cart_changed2_fn).bind(this), { signal: this.#abortController.signal });
    }

    this.debouncedOnChange = debounce(() => {
      this.input.dispatchEvent(new CustomEvent("change", { bubbles: true, detail: { target: this.input } }));
    }, ON_CHANGE_DEBOUNCE_TIMER);
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }

  onInputChange() {
    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.debouncedOnChange();
    }
  }
  validateQtyRules() {
    const value = parseInt(this.input.value),
    _max = this.input.max || 9999,
    max = parseInt(String(_max) != 'null' ? _max : 9999);
    this.input.value = Math.min(value, max);
    if (this.hasAttribute('form')) {
      getterGet(_qty_forms, this)?.dispatchEvent(new CustomEvent("change", { bubbles: true, detail: { target: this.input } }));
    }
    //this.input.dispatchEvent(new CustomEvent("change", { bubbles: true, detail: { line: this.dataset.index, qty: value } }));
    if (this.input.min) this.buttonMinus.classList.toggle('disabled', value <= parseInt(this.input.min));
    this.buttonPlus.classList.toggle('disabled', value >= parseInt(max));
  }
}
_qty_forms = new WeakMap(),
_qty_inputs = new WeakMap();
_on_variant_changed2 = new WeakSet();
on_variant_changed2_fn = function(event) {
  const variant = event.detail.variant;
  //  if ( variant && variant.available) {
  //   getterRunFn(_update_quantity_rules, this, update_quantity_rules_fn).call(this, variant);
  //  }
  this.setAttribute('variant-id', variant ? variant.id : '');
  if (variant) getterRunFn(_update_quantity_rules, this, update_quantity_rules_fn).call(this, variant);
};
_on_cart_changed2 = new WeakSet();
on_cart_changed2_fn = async function(event) {
  if (!this.variants) return;
  //console.log(event)
  $4('.hdt-quantity__rules-cart', this.quantityForm).hidden = true;
  const currentVariant = this.variants.find((variant) => this.getAttribute('variant-id') == variant.id);
  // Check variant has changed in cart
  if (!currentVariant) return;
  const cartContent  = event.detail.cart || (await fetchCart),
        itemsChanged = cartContent.items.concat(cartContent.items_added || [], cartContent.items_removed || []),
        found        = itemsChanged.find((variant) => currentVariant.id == variant.variant_id);
  if (found) getterRunFn(_update_quantity_rules, this, update_quantity_rules_fn).call(this, currentVariant, cartContent);
};
_set_quantity_boundries = new WeakSet();
set_quantity_boundries_fn = function() {
  const data = {
    cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
    min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
    max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
    step: this.input.step ? parseInt(this.input.step) : 1,
  };
  let min = data.min;
  const max = data.max == null ? data.max : data.max - data.cartQuantity;
  if (max != null) min = Math.min(min, max);
  if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

  this.input.min = min;
  this.input.max = max;
  this.input.value = min;
  this.input.dispatchEvent(new Event('change'));
};
_update_quantity_rules = new WeakSet();
update_quantity_rules_fn = async function(item, cartContent = null) {
  cartContent = cartContent || (await fetchCart);
  // 1. update quantity__label
  const itemCountForVariant = cartContent.items.find( (lineItem) => lineItem.id === item.id);
  $4('.hdt-quantity__rules-cart', this.quantityForm).hidden = !itemCountForVariant;
  if (itemCountForVariant) $4('.hdt-quantity-cart', this.quantityForm).textContent = itemCountForVariant.quantity;

  // 2. update quantity__rules
  if (!item.quantity_rule) item.quantity_rule = { min: 1, max: null, increment: 1, max4: true }; // fix for product not has variants and not has quantity_rule
  const quantity_rule = item.quantity_rule,
  { increment, min, max} = themeHDN.extras.quantity;
  $4('.hdt-quantity__rules', this.quantityForm).innerHTML = (`${quantity_rule.increment > 1 ? `<span class="hdt-divider">${increment.replace('1904', quantity_rule.increment)}</span>` : ''}${quantity_rule.min > 1 ? `<span class="hdt-divider">${min.replace('1904', quantity_rule.min)}</span>` : ''}${quantity_rule.max != null && !quantity_rule.max4 ? `<span class="hdt-divider">${max.replace('1904', quantity_rule.max)}</span>` : ''}`);

  // 3. update quantity__input
  const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
  const rules = [`${itemCountForVariant ? itemCountForVariant.quantity : 0}`, 'min', 'max', 'increment'];
  for (const [index, attribute] of attributes.entries()) {
    const valueUpdated = index === 0 ? rules[index] : quantity_rule[rules[index]];
    if (valueUpdated !== null)  {
      this.input.setAttribute(attribute, valueUpdated);
    } else {
      this.input.removeAttribute(attribute);
    }
  }
  // setQuantityBoundries
  getterRunFn(_set_quantity_boundries, this, set_quantity_boundries_fn).call(this);
};
customElements.define('hdt-quantity-wrapp', QuantityWrapp);

var _block_required_froms,
_block_required_detect,
_block_required_on_change, block_required_on_change_fn,
_block_required_on_submit, block_required_on_submit_fn;
class BlockRequired extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_block_required_on_submit, this);
    getterAdd(_block_required_on_change, this);
    getterAdd(_block_required_detect, this, this.getAttribute('detect'));
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    const arrRequireds = $$4('[required]', this);
    //getterGet(_block_required_froms, this).checkBreak = false;
    if (arrRequireds.length == 0) return;
    getterAdd(_block_required_froms, this, document.forms[this.attrForm]);
    if (!getterGet(_block_required_froms, this)) return;
    arrRequireds.forEach((el) => { el.removeAttribute("required"); this.classList.add("is-required") } );
    //getterGet(_block_required_froms, this).checkBreak = ( $$4(`hdt-block-required [form="${this.attrForm}"]`).length != $$4(`hdt-block-required:not(.is-uncheck, .is-required) [form="${this.attrForm}"]`).length );
    this.updateBreak();
    if ( this.getAttribute('event') === 'change') {
      setTimeout(() => this.checked = $4('input:checked', this), 100); // fix when back tab will autocomplete
      this.addEventListener("change", getterRunFn(_block_required_on_change, this, block_required_on_change_fn).bind(this), { signal: this.#abortController.signal });
    } else {
      this.addEventListener("input", debounce( getterRunFn(_block_required_on_change, this, block_required_on_change_fn).bind(this), 150, { signal: this.#abortController.signal }));
    }
    getterGet(_block_required_froms, this).addEventListener("submit", getterRunFn(_block_required_on_submit, this, block_required_on_submit_fn).bind(this), { signal: this.#abortController.signal });
  }
  get attrForm() {
    return this._attrForm = this._attrForm || $4('[form]', this).getAttribute("form");
  }
  updateBreak() {
    getterGet(_block_required_froms, this).checkBreak = ( $$4(`hdt-block-required [form="${this.attrForm}"]`).length != $$4(`hdt-block-required:not(.is-uncheck, .is-required) [form="${this.attrForm}"]`).length );
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  createStyle() {
    const arr = [];
    let i,j = 0;
    for (i = 0; i < 10; i++) {
      arr.push(`translate3d(${arguments[j++]},0,0)`);
      if (j === arguments.length) j = 0;
    }
    return arr
  }
  /**
   * @param {any} value
   */
  set checked(value) {
    this.setChecked = value;
  }
  get checked() {
    return this.setChecked
  }
}
_block_required_froms = new WeakMap();
_block_required_detect = new WeakMap();
_block_required_on_change = new WeakSet();
block_required_on_change_fn = function() {
  this.checked = false;
  // checked, length
  if ( getterGet(_block_required_detect, this ) === 'checked') {
    if ($4('input:checked', this)) this.checked = true;
  } else {
    const input = $4('input[type="text"]', this) || $4('textarea', this);
    if (input && input.value.length > 0) this.checked = true;
  }
  // this.classList.remove('is-required');
  // this.classList.toggle('is-uncheck', !this.checked);
  this.classList.remove('is-uncheck');
  this.classList.toggle('is-required', !this.checked);
  this.updateBreak();
};
_block_required_on_submit = new WeakSet();
block_required_on_submit_fn = function(event) {
  if (this.checked) return;
  event.preventDefault();
  event.stopPropagation();
  this.classList.remove('is-required');
  this.classList.add('is-uncheck');
  //$4('label', this)?.focus();
  $4(`hdt-block-required.is-uncheck [form="${this.attrForm}"]`).focus();
  animate(
    this,
    {
      transform: this.createStyle(0, '-10px', '10px')
    },
    {
      offset: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
      duration: 1,
      ease: "ease"
    }
  );
};

customElements.define("hdt-block-required", BlockRequired);
class CheckedToUse extends HTMLElement {
  #abortController;
  constructor() {
    super();
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    const input = $id4(this.getAttribute('get-id'));
    if (input) {
      input.addEventListener('change', (e) => this.firstElementChild.toggleAttribute('disabled', !input.checked), { signal: this.#abortController.signal });
    } else {
      this.firstElementChild.removeAttribute('disabled');
    }
    this.addEventListener('click', (e) => {
      if (input.checked) return
      this.closest('form')?.dispatchEvent(new Event("submit", { bubbles: true }));
    }, { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
};
customElements.define("hdt-need-checked-to-use", CheckedToUse);

// CART
// update item
var _is_cart_dirty,
//_cart_on_submit, cart_on_submit_fn,
_cart_on_change, cart_on_change_fn,
_cart_form = new WeakMap();
class CartForm extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_is_cart_dirty, this, false);
    getterAdd(_cart_on_change, this);
    getterAdd(_cart_form, this, $4('form', this));
    //getterAdd(_cart_on_submit, this);
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    getterGet(_cart_form, this).addEventListener("change", getterRunFn(_cart_on_change, this, cart_on_change_fn), { signal: this.#abortController.signal });
    //getterGet(_cart_form, this).addEventListener("submit", getterRunFn(_cart_on_submit, this, cart_on_submit_fn), { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
}
_is_cart_dirty = new WeakMap();
_cart_on_change = new WeakSet();
cart_on_change_fn = async function(e) {
  //console.log(e)
  if (getterGet(_is_cart_dirty, this) || !e.target.hasAttribute('will-change-cart')) return;
  getterAdd(_is_cart_dirty, this, true, true);
  const target = e.detail && e.detail.target ? e.detail.target : e.target,
  lineItem = target.closest('.hdt-cart-item');
  //console.log(e,target,lineItem)
  document.dispatchEvent(new CustomEvent("theme:loading:doing", { bubbles: true }));
  lineItem?.classList.add('hdt-pe-none');
  let bundleSections = [];
  document.dispatchEvent(new CustomEvent("cart:push:section.id", { bubbles: true, detail: { sections: bundleSections } }));
  //console.log(bundleSections)
  // /fr/cart?locale=fr
  const cartContent = await (await fetch(`${Shopify.routes.root}cart/change.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      line: target.dataset.index,
      quantity: target.value || 0,
      sections: bundleSections.join(",")
    })
  })).json();
  getterAdd(_is_cart_dirty, this, false, true);
  document.dispatchEvent(new CustomEvent("theme:loading:done", { bubbles: true }));
  lineItem?.classList.remove('hdt-pe-none');
  document.dispatchEvent(new CustomEvent("cart:change", {
    bubbles: true,
    detail: {
      baseEvent: "line-item:change",
      cart: cartContent
    }
  }));
};
// _cart_on_submit = new WeakSet();
// cart_on_submit_fn = function() {
// };
// remove item
var _remove_item_on_cart, remove_item_on_cart_fn,
_remove_forms;
class RemoveItemOnCart extends btnTooltip {
  #abortController;
  constructor() {
    super();
    getterAdd(_remove_item_on_cart, this);
  }
  connectedCallback() {
    super.connectedCallback();
    getterAdd(_remove_forms, this, document.forms[(this.getAttribute("form") || '').replace('id:','')] || this.closest("form"));
    this.#abortController = new AbortController();
    this.abortController2 = null;
    this.addEventListener("click", getterRunFn(_remove_item_on_cart, this, remove_item_on_cart_fn).bind(this), { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }
}
_remove_forms = new WeakMap();
_remove_item_on_cart = new WeakSet();
remove_item_on_cart_fn = async function(e) {
  e.preventDefault();
  getterGet(_remove_forms, this).dispatchEvent(new CustomEvent("change", { bubbles: true, detail: { target: this } }));
};


// cart discount
class CartDiscount extends HTMLElement {
  #abortController;
  constructor() {
    super();
  }

  connectedCallback() {
    this.#abortController = new AbortController();
    
    // Add input handler to show/hide Apply button
    const input = this.querySelector('[data-cart-discount-input]');
    if (input) {
      input.addEventListener('input', this.handleInputChange.bind(this), { signal: this.#abortController.signal });
    }
    
    // Add click handler for Apply button
    const applyButton = this.querySelector('[data-cart-discount-apply]');
    if (applyButton) {
      applyButton.addEventListener('click', this.handleApplyClick.bind(this), { signal: this.#abortController.signal });
    }
    
    // Add click handler for remove discount buttons
    document.addEventListener('click', this.handleRemoveDiscount.bind(this), { signal: this.#abortController.signal });
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  handleInputChange(event) {
    const input = event.target;
    const applyButton = this.querySelector('[data-cart-mini-discount-apply]');
    if (applyButton) {
      applyButton.style.display = input.value ? 'inline-flex' : 'none';
    }
  }

  async handleApplyClick(event) {
    const input = this.querySelector('[data-cart-discount-input]');
    if (!input) return;

    const discount = input.value;
    const errorElement = this.querySelector('[data-cart-discount-error]');
    const sections = [this.closest('.shopify-section').id.replace('shopify-section-', '')];
    
    // Trigger loading start
    document.dispatchEvent(new CustomEvent('theme:loading:doing'));
    
    try {
      const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          discount: discount,
          sections: sections
        })
      });

      const data = await response.json();
      if (response.ok && data.discount_codes[0].applicable) {

        // Clear any previous error messages
        if (errorElement) {
          errorElement.textContent = '';
          errorElement.style.display = 'none';
        }

        // Refresh cart drawer if it exists
        const cartDrawer = document.querySelector('hdt-cart-drawer');
        if (cartDrawer) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }

        const cartMain = document.querySelector('#hdt-page-cart');
        if (cartMain) {
          const domElement = new DOMParser().parseFromString(data.sections[sections[0]], "text/html"),
          freeShippingBar = $4('.hdt-free-shipping-bar', domElement),
          section = this.closest('.shopify-section');
          let valueNow = 0;
          if (freeShippingBar) {
            valueNow = $4('.hdt-progress-bar', freeShippingBar).getAttribute('aria-valuenow');
            $4('.hdt-progress-bar', freeShippingBar).valueNow = $4('.hdt-progress-bar', section).getAttribute('aria-valuenow');
            $4('.hdt-progress-bar', freeShippingBar).style.setProperty('--progress-rate', $4('.hdt-progress-bar', section).style.getPropertyValue('--progress-rate'));
          }
          const newCartPage = $4('.shopify-section [main-content]', domElement).innerHTML;
          if (data.item_count === 0) {
            const controls = animate(section, { opacity: [1, 0], transform: ["translateY(0)", "translateY(30px)"] }, { duration: 0.25, easing: [0.25, 0.46, 0.45, 0.94] });
            await controls.finished;
            $4('[main-content]', section).innerHTML =  newCartPage;
            animate(section, { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] }, { duration: 0.25, easing: [0.25, 0.46, 0.45, 0.94] });
          } else {
            $4('[main-content]', section).innerHTML = newCartPage;
          }
          if (freeShippingBar) $4('.hdt-progress-bar', section).valueNow = valueNow;
          document.dispatchEvent(new CustomEvent("currency:update"));
          document.dispatchEvent(new CustomEvent("cart:page:render"));
        }
      } else {
        // Handle error case
        if (errorElement) {
          // errorElement.textContent = data.description || 'Invalid discount code';
          errorElement.style.display = 'block';
        }
        input.value = ''; // Clear invalid input
        const applyButton = this.querySelector('[data-cart-mini-discount-apply]');
        if (applyButton) {
          applyButton.style.display = 'none';
        }
      }
    } catch (error) {
      console.error('Error applying discount:', error);
      if (errorElement) {
        errorElement.textContent = 'Error applying discount code';
        errorElement.style.display = 'block';
      }
    } finally {
      // Trigger loading end
      document.dispatchEvent(new CustomEvent('theme:loading:done'));
    }
  }

  async handleRemoveDiscount(event) {
    const removeButton = event.target.closest('.hdt-discount-remove');
    const sections = [this.closest('.shopify-section').id.replace('shopify-section-', '')];
    if (!removeButton) return;

    const discountCode = removeButton.dataset.discountCode;
    if (!discountCode) return;

    // Trigger loading start
    document.dispatchEvent(new CustomEvent('theme:loading:doing'));

    try {
      const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          discount: '',
          sections: sections
        })
      });
      const data = await response.json();

      if (response.ok) {
        // Trigger cart refresh
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        
        // Update discount input if exists
        const discountInput = this.querySelector('[data-cart-discount-input]');
        if (discountInput) {
          discountInput.value = '';
        }

        const cartMain = document.querySelector('#hdt-page-cart');
        if (cartMain) {
          const domElement = new DOMParser().parseFromString(data.sections[sections[0]], "text/html"),
          freeShippingBar = $4('.hdt-free-shipping-bar', domElement),
          section = this.closest('.shopify-section');
          let valueNow = 0;
          if (freeShippingBar) {
            valueNow = $4('.hdt-progress-bar', freeShippingBar).getAttribute('aria-valuenow');
            $4('.hdt-progress-bar', freeShippingBar).valueNow = $4('.hdt-progress-bar', section).getAttribute('aria-valuenow');
            $4('.hdt-progress-bar', freeShippingBar).style.setProperty('--progress-rate', $4('.hdt-progress-bar', section).style.getPropertyValue('--progress-rate'));
          }
          const newCartPage = $4('.shopify-section [main-content]', domElement).innerHTML;
          if (data.item_count === 0) {
            const controls = animate(section, { opacity: [1, 0], transform: ["translateY(0)", "translateY(30px)"] }, { duration: 0.25, easing: [0.25, 0.46, 0.45, 0.94] });
            await controls.finished;
            $4('[main-content]', section).innerHTML =  newCartPage;
            animate(section, { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] }, { duration: 0.25, easing: [0.25, 0.46, 0.45, 0.94] });
          } else {
            $4('[main-content]', section).innerHTML = newCartPage;
          }
          if (freeShippingBar) $4('.hdt-progress-bar', section).valueNow = valueNow;
          document.dispatchEvent(new CustomEvent("currency:update"));
          document.dispatchEvent(new CustomEvent("cart:page:render"));
        }
      }
    } catch (error) {
      console.error('Error removing discount:', error);
    } finally {
      // Trigger loading end
      document.dispatchEvent(new CustomEvent('theme:loading:done'));
    }
  }
}
// ... existing code ...

// cart note
var _cart_note_on_change, cart_note_on_change_fn;
class CartNote extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_cart_note_on_change, this);
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    this.addEventListener("change", getterRunFn(_cart_note_on_change, this, cart_note_on_change_fn).bind(this), { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
}
_cart_note_on_change = new WeakSet();
cart_note_on_change_fn = function(event) {
  const note = event.target.value;
  fetch(`${Shopify.routes.root}cart/update.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ note }),
    keepalive: true
  });
  $$4('[data-label-note]').forEach((label) => {
    if (label.childElementCount === 2 ) {
      label.firstElementChild.toggleAttribute("hidden", note.length > 0);
      label.lastElementChild.toggleAttribute("hidden", note.length === 0);
    }
  });
};

var createCartPromise = () => {
  return new Promise(async (resolve) => {
    resolve(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
  });
};
var fetchCart = createCartPromise();
document.addEventListener("cart:change", (event) => {
  fetchCart = event.detail.cart;
});
document.addEventListener("cart:refresh", () => {
  fetchCart = createCartPromise();
});
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    fetchCart = createCartPromise();
  }
});
// cart count
var _refresh_cart_count, refresh_cart_count_fn;
class CartCount extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_refresh_cart_count, this);
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    document.addEventListener("cart:change", (event) => this.itemCount = event.detail.cart.item_count, { signal: this.#abortController.signal });
    document.addEventListener("cart:refresh", getterRunFn(_refresh_cart_count, this, refresh_cart_count_fn).bind(this), { signal: this.#abortController.signal });
    window.addEventListener("pageshow", getterRunFn(_refresh_cart_count, this, refresh_cart_count_fn).bind(this), { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  /**
   * @param {number} count
   */
  set itemCount(count) {
    this.innerText = count;
  }
}
_refresh_cart_count = new WeakSet();
refresh_cart_count_fn = async function() {
  this.itemCount = (await fetchCart)["item_count"];
};
// cart dot
class CartDot extends CartCount {
  /**
   * @param {number} count
   */
  set itemCount(count) {
    this.classList.toggle('is-visible', count > 0);
  }
}

// cart drawer
var _render_cart_drawer, render_cart_drawer_fn,
_cart_bundled_section, cart_bundled_section_fn,
_on_cart_change, on_cart_change_fn,
_on_page_show, on_page_show_fn,
_refresh_cart, refresh_cart_fn,
_cart_section_id;
// document.dispatchEvent(new CustomEvent("cart:refresh"));
class CartDrawer extends Drawer {
  constructor() {
    super();
    getterAdd(_cart_section_id, this, this.getAttribute('section-id'));
    getterAdd(_render_cart_drawer, this);
    getterAdd(_cart_bundled_section, this);
    getterAdd(_on_cart_change, this);
    getterAdd(_on_page_show, this);
    getterAdd(_refresh_cart, this);
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener("cart:push:section.id", getterRunFn(_cart_bundled_section, this, cart_bundled_section_fn).bind(this), { signal: this.abortController.signal });
    document.addEventListener("cart:change", getterRunFn(_on_cart_change, this, on_cart_change_fn).bind(this), { signal: this.abortController.signal });
    document.addEventListener("cart:refresh", getterRunFn(_refresh_cart, this, refresh_cart_fn).bind(this), { signal: this.abortController.signal });
    window.addEventListener("pageshow", getterRunFn(_on_page_show, this, on_page_show_fn).bind(this), { signal: this.abortController.signal });
  }
}
_cart_section_id = new WeakMap();
_render_cart_drawer = new WeakSet();
render_cart_drawer_fn = async function(html, item_count = null) {
  const domElement = new DOMParser().parseFromString(html, "text/html"),
  freeShippingBar = $4('.hdt-free-shipping-bar', domElement);
  let valueNow = 0;
  if (freeShippingBar) {
    valueNow = $4('.hdt-progress-bar', freeShippingBar).getAttribute('aria-valuenow');
    $4('.hdt-progress-bar', freeShippingBar).valueNow = $4('.hdt-progress-bar', this).getAttribute('aria-valuenow');
    $4('.hdt-progress-bar', freeShippingBar).style.setProperty('--progress-rate', $4('.hdt-progress-bar', this).style.getPropertyValue('--progress-rate'));
  }
  const newCartDrawer = document.createRange().createContextualFragment(domElement.getElementById(`shopify-section-${getterGet(_cart_section_id, this)}`).querySelector("hdt-cart-drawer").innerHTML),
  itemCount = item_count || (await fetchCart).item_count;
  if (itemCount === 0) {
    const controls = timeline([
      [this.selectorPartName("body"), { opacity: [1, 0] }, { duration: 0.15, easing: "ease-in" }],
      [this.selectorPartName("footer"), { opacity: [1, 0], transform: ["translateY(0)", "translateY(30px)"] }, { duration: 0.15, at: "<", easing: "ease-in" }]
    ]);
    await controls.finished;
    this.replaceChildren(...newCartDrawer.children);
    animate(this.selectorPartName("body"), { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] }, { duration: 0.25, easing: [0.25, 0.46, 0.45, 0.94] });
  } else {
    this.replaceChildren(...newCartDrawer.children);
  }
  if (freeShippingBar) $4('.hdt-progress-bar', this).valueNow = valueNow;
  document.dispatchEvent(new CustomEvent("currency:update"));
  document.dispatchEvent(new CustomEvent("cart:drawer:render"));
};
_cart_bundled_section = new WeakSet();
cart_bundled_section_fn = function(event) {
  event.detail.sections.push(getterGet(_cart_section_id, this));
};
_on_cart_change = new WeakSet();
on_cart_change_fn = function(event) {
  getterRunFn(_render_cart_drawer, this, render_cart_drawer_fn).call(this, event.detail.cart.sections[getterGet(_cart_section_id, this)], event.detail.cart.item_count);
  if (!event.detail.disabledDrawerChange) document.dispatchEvent(new CustomEvent("cart:drawer:change", { detail: { sections: event.detail.cart.sections } }));
  //const actionAfterATC = themeHDN.settings.pageType == 'cart' ? 'go_cart_page' : event.detail.actionAfterATC || themeHDN.settings.actionAfterATC;
  if (event.detail.baseEvent === "variant:add") {
    const actionAfterATC = event.detail.actionAfterATC || themeHDN.settings.actionAfterATC;
    if (actionAfterATC.indexOf('go_') > -1) {
      window.location.href = `${Shopify.routes.root}${actionAfterATC == 'go_cart_page' ? 'cart' : 'checkout'}`;
    } else if ( actionAfterATC == 'open_cart_drawer' ) {
      this.openDialog();
    }
  }
};
_on_page_show = new WeakSet();
on_page_show_fn = function(event) {
  if (!event.persisted) return;
  getterRunFn(_refresh_cart, this, refresh_cart_fn).call(this);
}
_refresh_cart = new WeakSet();
refresh_cart_fn = async function() {
  getterRunFn(_render_cart_drawer, this, render_cart_drawer_fn).call(this, await (await fetch(`${Shopify.routes.root}?section_id=${getterGet(_cart_section_id, this)}`)).text());
};


var _cart_page_bundled_section, cart_page_bundled_section_fn,
_cart_page_section_id,
_render_cart_page, render_cart_page_fn,
_on_cart_page_change, on_cart_page_change_fn;
class CartPageForm extends CartForm {
  #abortController;
  constructor() {
    super();
    getterAdd(_cart_page_section_id, this, getterGet(_cart_form, this).getAttribute('section-id'));
    getterAdd(_render_cart_page, this);
    getterAdd(_cart_page_bundled_section, this);
    getterAdd(_on_cart_page_change, this);
  }
  connectedCallback() {
    super.connectedCallback();
    this.#abortController = new AbortController();
    document.addEventListener("cart:change", getterRunFn(_on_cart_page_change, this, on_cart_page_change_fn).bind(this), { signal: this.#abortController.signal });
    document.addEventListener("cart:push:section.id", getterRunFn(_cart_page_bundled_section, this, cart_page_bundled_section_fn).bind(this), { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }
}
_cart_page_section_id = new WeakMap();
_render_cart_page = new WeakSet();
render_cart_page_fn = async function(html, item_count = null) {
  const domElement = new DOMParser().parseFromString(html, "text/html"),
  freeShippingBar = $4('.hdt-free-shipping-bar', domElement),
  section = this.closest('.shopify-section');
  let valueNow = 0;
  if (freeShippingBar) {
    valueNow = $4('.hdt-progress-bar', freeShippingBar).getAttribute('aria-valuenow');
    $4('.hdt-progress-bar', freeShippingBar).valueNow = $4('.hdt-progress-bar', section).getAttribute('aria-valuenow');
    $4('.hdt-progress-bar', freeShippingBar).style.setProperty('--progress-rate', $4('.hdt-progress-bar', section).style.getPropertyValue('--progress-rate'));
  }
  const newCartPage = $4('.shopify-section [main-content]', domElement).innerHTML,
  itemCount = item_count || (await fetchCart).item_count;
  if (itemCount === 0) {
    const controls = animate(section, { opacity: [1, 0], transform: ["translateY(0)", "translateY(30px)"] }, { duration: 0.25, easing: [0.25, 0.46, 0.45, 0.94] });
    await controls.finished;
    $4('[main-content]', section).innerHTML =  newCartPage;
    animate(section, { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] }, { duration: 0.25, easing: [0.25, 0.46, 0.45, 0.94] });
  } else {
    $4('[main-content]', section).innerHTML = newCartPage;
  }
  if (freeShippingBar) $4('.hdt-progress-bar', section).valueNow = valueNow;
  document.dispatchEvent(new CustomEvent("currency:update"));
  document.dispatchEvent(new CustomEvent("cart:page:render"));
};
_on_cart_page_change = new WeakSet();
on_cart_page_change_fn = function(event) {
  if (event.detail.baseEvent === "variant:add") return window.location.href = `${Shopify.routes.root}cart`;
  getterRunFn(_render_cart_page, this, render_cart_page_fn).call(this, event.detail.cart.sections[getterGet(_cart_page_section_id, this)], event.detail.cart.item_count);
};
_cart_page_bundled_section = new WeakSet();
cart_page_bundled_section_fn = function(event) {
  event.detail.sections.push(getterGet(_cart_page_section_id, this));
};

customElements.define("wrapp-hdt-cart-form", CartForm);
customElements.define("wrapp-hdt-cart-page-form", CartPageForm);
customElements.define("wrapp-remove-item-oncart", RemoveItemOnCart);
customElements.define("hdt-cart-note", CartNote);
customElements.define("hdt-cart-discount", CartDiscount);
customElements.define("hdt-cart-count", CartCount);
customElements.define("hdt-cart-dot", CartDot);
customElements.define("hdt-cart-drawer", CartDrawer);
// END CART
var _allow_update_progress_bar, _update_progress_bar, update_progress_bar_fn,
_color_progress_bar;
class ProgressBar extends HTMLElement {
  constructor() {
    super();
    getterAdd(_update_progress_bar, this);
    getterAdd(_allow_update_progress_bar, this, !this.hasAttribute("reveal-in-view"));
    getterAdd(_color_progress_bar, this, this.getAttribute('data-colors'));
  }
  static get observedAttributes() {
    return ["aria-valuenow", "aria-valuemax"];
  }
  connectedCallback() {
    if (this.hasAttribute("reveal-in-view")) {
      inView(this, () => {
        getterAdd(_allow_update_progress_bar, this, true, true);
        getterRunFn(_update_progress_bar, this, update_progress_bar_fn).call(this);
      }, { margin: "-50px 0px" });
    }
  }
  get progress() {
    return Math.min(1, this.getAttribute("aria-valuenow") / this.getAttribute("aria-valuemax"));
  }
  /**
   * @param {string} value
   */
  set valueMax(value) {
    this.setAttribute("aria-valuemax", value);
  }
  /**
   * @param {string} value
   */
  set valueNow(value) {
    this.setAttribute("aria-valuenow", value);
  }
  attributeChangedCallback() {
    if (getterGet(_allow_update_progress_bar, this)) {
      getterRunFn(_update_progress_bar, this, update_progress_bar_fn).call(this);
    }
  }
};
_color_progress_bar = new WeakMap();
_allow_update_progress_bar = new WeakMap();
_update_progress_bar = new WeakSet();
update_progress_bar_fn = function() {
  const findRange = (value, ranges) => {
    const sortedRanges = [...ranges].sort((a, b) => a - b);
    return sortedRanges.find((range, i) => 
      value >= range && (i === sortedRanges.length - 1 || value < sortedRanges[i + 1])
    ) ?? sortedRanges[0];
  };

  const colors = JSON.parse(getterGet(_color_progress_bar, this) ?? '{}');
  const fixedNum = parseFloat((this.progress + '').slice(0, 3));
  
  const ranges = Object.keys(colors)
    .map(Number)
    .sort((a, b) => a - b);
  
  const rangeValue = findRange(fixedNum, ranges);

  Object.entries(colors)?.forEach(([key, item]) => {
    this.parentElement?.classList.toggle(item, parseFloat(key) === rangeValue);
  });
  
  this.style.setProperty('--progress-rate', `${this.progress}`);
};
customElements.define("hdt-progress-bar", ProgressBar);


var _onCountryChanged, onCountryChanged_fn;
class CountryProvinceSelector extends HTMLElement {
  #abortController;
  constructor() {
    super(...arguments);
    getterAdd(_onCountryChanged, this);
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    this.countryEl = $4('[name="address[country]"]', this);
    this.provinceEl = $4('[name="address[province]"]', this);
    this.countryEl.addEventListener("change", getterRunFn(_onCountryChanged, this, onCountryChanged_fn).bind(this), { signal: this.#abortController.signal });
    if (this.getAttribute("country") !== "") {
      this.countryEl.selectedIndex = Math.max(0, Array.from(this.countryEl.options).findIndex((option) => option.textContent === this.getAttribute("country")));
    }
    this.countryEl.dispatchEvent(new Event("change"));
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
};
_onCountryChanged = new WeakSet();
onCountryChanged_fn = function() {
  const option = this.countryEl.options[this.countryEl.selectedIndex],
  provinces = JSON.parse(option.getAttribute("data-provinces"));
  this.provinceEl.parentElement.hidden = provinces.length === 0;
  this.provinceEl.disabled = provinces.length === 0;
  if (provinces.length === 0) {
    return;
  }
  this.provinceEl.innerHTML = "";
  provinces.forEach((data) => {
    const selected = data[1] === this.getAttribute("province") || data[0] === this.getAttribute("province");
    this.provinceEl.options.add(new Option(data[1], data[0], selected, selected));
  });
};
customElements.define("hdt-country-province-selector", CountryProvinceSelector);

/**
 * https://shopify.dev/docs/themes/ajax-api/reference/cart#generate-shipping-rates
 * https://community.shopify.com/c/shopify-design/cart-add-a-shipping-rates-calculator-to-your-cart/td-p/616554
 */
var _estimateShipping, estimateShipping_fn, _getAsyncShippingRates, getAsyncShippingRates_fn, _formatShippingRates, formatShippingRates_fn, _formatError, formatError_fn;
var ShippingCalculator = class extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_estimateShipping, this);
    getterAdd(_getAsyncShippingRates, this);
    getterAdd(_formatShippingRates, this);
    getterAdd(_formatError, this);
    this.langRates = JSON.parse( $4('template[data-lang-rates]', this).innerHTML );
  }
  currencyMulti(amount) {
    if (themeHDN.settings.currencyFormat.indexOf("with_comma_separator") !== -1) {
      amount = amount.replace(/[,.]/g, function(match) {
        return match === "," ? "." : ",";
      });
    }
    return parseFloat(amount.replace(/^[^0-9]+|[^0-9.]/g, '', ''), 10) * (parseFloat(Shopify.currency.rate) * (themeHDN.settings.currencyFormat.indexOf("with_comma_separator") == -1 ? 100 : 1));
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    this.submitButton = $4('[type="button"]', this);
    this.resultsElement = $4('[aria-live="polite"]', this);
    this.submitButton.addEventListener("click", getterRunFn(_estimateShipping, this, estimateShipping_fn).bind(this), { signal: this.#abortController.signal });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
};
_estimateShipping = new WeakSet();
estimateShipping_fn = async function(event) {
  event.preventDefault();
  const zip = $4('[name="address[zip]"]', this).value,
  country = $4('[name="address[country]"]', this).value,
  $province = $4('[name="address[province]"]', this),
  province = $province.disabled ? '' : $province.value;
  this.submitButton.setAttribute("aria-busy", "true");
  document.dispatchEvent(new CustomEvent("theme:loading:doing", { bubbles: true }));
  const prepareResponse = await fetch(`${Shopify.routes.root}cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`, { method: "POST" });
  document.dispatchEvent(new CustomEvent("theme:loading:done", { bubbles: true }));
  if (prepareResponse.ok) {
    const shippingRates = await getterRunFn(_getAsyncShippingRates, this, getAsyncShippingRates_fn).call(this, zip, country, province);
    getterRunFn(_formatShippingRates, this, formatShippingRates_fn).call(this, shippingRates);
  } else {
    const jsonError = await prepareResponse.json();
    getterRunFn(_formatError, this, formatError_fn).call(this, jsonError);
  }
  this.resultsElement.hidden = false;
  this.submitButton.removeAttribute("aria-busy");
};
_getAsyncShippingRates = new WeakSet();
getAsyncShippingRates_fn = async function(zip, country, province) {
  const response = await fetch(`${Shopify.routes.root}cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`);
  const responseAsText = await response.text();
  if (responseAsText === "null") {
    return getterRunFn(_getAsyncShippingRates, this, getAsyncShippingRates_fn).call(this, zip, country, province);
  } else {
    return JSON.parse(responseAsText).shipping_rates;
  }
};
_formatShippingRates = new WeakSet();
formatShippingRates_fn = function(shippingRates) {
  let ratesList = shippingRates.map((shippingRate) => {
    return `<li>${shippingRate.presentment_name}: ${ shippingRate.price == "0.00" ? this.langRates.free : `<span class="hdt-money">${formatMoney(this.currencyMulti(shippingRate.price), themeHDN.settings.currencyFormat)}</span>` }</li>`;
  });
  this.resultsElement.innerHTML = `
    <div class="hdt-mess__rates is--rates-success">
      <p>${shippingRates.length === 0 ? this.langRates.no_rates : shippingRates.length === 1 ? this.langRates.one_rate : this.langRates.multiple_rates}</p>
      ${ratesList === "" ? "" : `<ul role="list">${ratesList.join('')}</ul>`}
    </div>
  `;
  document.dispatchEvent(new CustomEvent("currency:update"));
};
_formatError = new WeakSet();
formatError_fn = function(errors) {
  let errorHtml = Object.keys(errors).map((errorKey) => {
    return `<li><span class="hdt-key__rate">${errorKey}:</span> ${errors[errorKey]}</li>`;
  });
  this.resultsElement.innerHTML = `
      <div class="hdt-mess__rates is--rates-error">
        <p>${this.langRates.errors}</p>
        <ul role="list">${errorHtml.join('')}</ul>
      </div>
    `;
};
customElements.define("hdt-shipping-calculator", ShippingCalculator);


// MEDIA PLAYER
class player extends HTMLElement {
  static get observedAttributes() {
    return ["playing"];
  }
  connectedCallback() {
    this._abortController = new AbortController();
    if (this.hasAttribute("autoplay")) {
      inView(this, this.play.bind(this), { margin: "0px 0px 0px 0px" });
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get playing() {
    return this.hasAttribute("playing");
  }
  get player() {
    return this._playerProxy = this._playerProxy || new Proxy(this._createPlayer(), {
      get: (target, prop) => {
        return async () => {
          target = await target;
          this._playerApi(target, prop);
        };
      }
    });
  }
  play() {
    if (!this.playing) {
      this.player.play();
    }
  }
  pause() {
    if (this.playing) {
      this.player.pause();
    }
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "playing") {
      if (oldValue === null && newValue === "") {
        this.dispatchEvent(new CustomEvent("media:play", { bubbles: true }));
        if (this.hasAttribute("group")) {
          Array.from(document.querySelectorAll(`[group="${this.getAttribute("group")}"]`)).filter((item) => item !== this).forEach((itemToPause) => {
            itemToPause.pause();
          });
        }
      } else if (newValue === null) {
        this.dispatchEvent(new CustomEvent("media:pause", { bubbles: true }));
      }
    }
  }
};
class ModelPlayer extends player {
  connectedCallback() {
    super.connectedCallback();
    this.player;
  }
  _createPlayer() {
    return new Promise((resolve) => {
      this.setAttribute("loaded", "");
      window.Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this._setupShopifyXr.bind(this)
        },
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: () => {
            const modelViewer = $4("model-viewer", this);
            modelViewer.addEventListener("shopify_model_viewer_ui_toggle_play", () => this.setAttribute("playing", ""));
            modelViewer.addEventListener("shopify_model_viewer_ui_toggle_pause", () => this.removeAttribute("playing"));
            resolve(new window.Shopify.ModelViewerUI(modelViewer, { focusOnPlay: true }));
          }
        }
      ]);
    });
  }
  _playerApi(target, action) {
    // console.log(target, action, target[action])
    // target[action]();
  }
  async _setupShopifyXr() {
    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", this._setupShopifyXr.bind(this));

    } else {
      const modelJson = $id4('ModelJson-' + this.getAttribute('section-id'));
      //console.log(JSON.parse(modelJson.textContent))
      window.ShopifyXR.addModels(JSON.parse(modelJson.textContent));
      window.ShopifyXR.setupXRElements();
      this.closest('hdt-slider')?.reInit()
    }
  }
};

var onYouTubePromise = new Promise((resolve) => {
  window.onYouTubeIframeAPIReady = () => resolve();
});
class VideoPlayer extends player {
  #mustRemoveControlsAfterSuspend = false;
  connectedCallback() {
    super.connectedCallback();
    if (!this.hasAttribute("autoplay")) {
      this.addEventListener("click", this.play, { once: true, signal: this._abortController.signal });
    }
    // if (this.hasAttribute("show-play-button") && !this.shadowRoot) {
    //   this.attachShadow({ mode: "open" }).appendChild(document.getElementById("video-media-default-template").content.cloneNode(true));
    // }
    if (this.getAttribute("type") === "video") {
      inView(this, () => {
        $4("video", this)?.setAttribute("preload", "metadata");
      }, { margin: "800px" });
    }
  }
  _createPlayer() {
    if (this.hasAttribute("host")) {
      this.setAttribute("loaded", "");
      return new Promise(async (resolve) => {
        const templateElement = $4("template", this);
        if (templateElement) {
          templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        }
        if (this.getAttribute('type') === 'background') {
          this.sizeBackgroundVideo();
          // Listen to resize to keep a background-size:cover-like layout
          window.addEventListener('resize', debounce( this.sizeBackgroundVideo.bind(this), 300));
        }
        const muteVideo = this.hasAttribute("autoplay") || _matchMedia("phone");
        const script = document.createElement("script");
        script.type = "text/javascript";
        if (this.getAttribute("host") === "youtube") {
          if (!window.YT || !window.YT.Player) {
            script.src = "https://www.youtube.com/iframe_api";
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          await onYouTubePromise;
          const player = new YT.Player($4("iframe", this), {
            events: {
              "onReady": () => {
                if (muteVideo) {
                  player.mute();
                }
                resolve(player);
              },
              "onStateChange": (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.setAttribute("playing", "");
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.removeAttribute("playing");
                }
              }
            }
          });
        }
        if (this.getAttribute("host") === "vimeo") {
          if (!window.Vimeo || !window.Vimeo.Player) {
            script.src = "https://player.vimeo.com/api/player.js";
            document.head.appendChild(script);
            await new Promise((resolve2) => {
              script.onload = resolve2;
            });
          }
          const player = new Vimeo.Player($4("iframe", this));
          if (muteVideo) {
            player.setMuted(true);
          }
          player.on("play", () => {
            this.setAttribute("playing", "");
          });
          player.on("pause", () => this.removeAttribute("playing"));
          player.on("ended", () => this.removeAttribute("playing"));
          resolve(player);
        }
      });
    } else {
      const videoElement = $4("video", this);
      this.setAttribute("loaded", "");
      videoElement.addEventListener("play", () => {
        this.setAttribute("playing", "");
        this.removeAttribute("suspended");
        if (this.#mustRemoveControlsAfterSuspend) {
          videoElement.controls = false;
        }
      });
      videoElement.addEventListener("pause", () => {
        if (!videoElement.seeking && videoElement.paused) {
          this.removeAttribute("playing");
        }
      });
      return videoElement;
    }
  }
  _playerApi(target, action) {
    if (this.getAttribute("host") === "youtube") {
      target[`${action}Video`]();
    } else {
      // video html5 + play
      if (action === "play" && !this.hasAttribute("host")) {
        target.play().catch((error) => {
          if (error.name === "NotAllowedError") {
            this.setAttribute("suspended", "");
            if (!this.hasAttribute("controls")) {
              this.#mustRemoveControlsAfterSuspend = true;
              target.controls = true;
            }
          }
        });
      } else {
        // vimeo or video html5 + pause
        target[action]();
      }
    }
  }
  sizeBackgroundVideo() {
    var iframeW  ,
    iframeH      ,
    marginLeft   ,
    marginTop    ,
    containerW   = this.clientWidth,
    containerH   = this.clientHeight;

    containerW / containerH < 16 / 9 ?
    (
       iframeW = containerH * (16 / 9),
       iframeH = containerH,
       marginLeft = -Math.round((iframeW - containerW) / 2),
       marginTop = -Math.round((iframeH - containerH) / 2)
    ) : (
       iframeH = (iframeW = containerW) * (9 / 16),
       marginTop = -Math.round((iframeH - containerH) / 2),
       marginLeft = -Math.round((iframeW - containerW) / 2)
    );
    $4("iframe", this).style.cssText = `max-width: 1000%; margin-left: ${marginLeft}px; margin-top: ${marginTop}px; width: ${iframeW}px; height: ${iframeH}px;`;
  }
};

import { PhotoSwipeLightbox, Zoom } from 'vendor';
var _on_variant_changed_media, on_variant_changed_media_fn,
_slider_main_select, slider_main_select_fn,
_lightbox_psw_media_init = new WeakMap(),
_media_image_click, media_image_click_fn,
_media_image_zoom, media_image_zoom_fn,
_update_group_media, update_group_media_fn;
class ProductMedia extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_on_variant_changed_media, this);
    getterAdd(_update_group_media, this);
    getterAdd(_slider_main_select, this);
    getterAdd(_media_image_click, this);
    getterAdd(_media_image_zoom, this);
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    this.form?.addEventListener(variantChange, getterRunFn(_on_variant_changed_media, this, on_variant_changed_media_fn).bind(this), { signal: this.#abortController.signal });
    if (this.sliderMain) {
      this.sliderMain.addEventListener('select:slide', getterRunFn(_slider_main_select, this, slider_main_select_fn).bind(this), { signal: this.#abortController.signal });
    }
    if (this.updateGroupFilter) this.addEventListener('update:value', getterRunFn(_update_group_media, this, update_group_media_fn).bind(this), { signal: this.#abortController.signal });
    
    if ((this.imageZoom == 'zoom' || this.imageZoom == 'zoom_lightbox') && _matchMedia('supports-hover')) {
      getterRunFn(_media_image_zoom, this, media_image_zoom_fn).call(this);
    }

    if (this.imageZoom != 'no') {
      if(this.imageZoom == 'zoom' && _matchMedia('supports-hover')) return; 
      $$4('.hdt-product-media__main [data-media-type="image"]', this).forEach((imageWrap) => {
        imageWrap.addEventListener("click", getterRunFn(_media_image_click, this, media_image_click_fn).bind(this, imageWrap), { signal: this.#abortController.signal });
      });
      this.addEventListener("lightbox:psw:open", (event) => this.openLightBox(event?.detail?.index));
    }
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get form() {
    return this._form = this._form || document.forms[this.getAttribute("form")];
  }
  get sliderMain() {
    return this._sliderMain = this._sliderMain || $4(`.hdt-product-media__main hdt-slider`, this);
  }
  get sliderThumb() {
    return this._sliderThumb = this._sliderThumb || $4(`hdt-slider-thumb`, this);
  }
  get variantPicker() {
    return this._variantPicker = this._variantPicker || $4(`hdt-variant-picker[form="${this.getAttribute("form")}"]`);
  }
  get updateGroupFilter() {
    return this.hasAttribute('can-has-media-group');
  }
  get imageZoom() {
    return this.getAttribute('image-zoom');
  }
  get sectionId() {
    return this.getAttribute('section-id');
  }
  /**
   * Create the PhotoSwipe instance if it does not already exist. This is done on demand, so until the lightbox is
   * open, nothing is created to not impact performance
   */
  get lightBox() {
    if (getterGet(_lightbox_psw_media_init, this)) {
      return getterGet(_lightbox_psw_media_init, this);
    }
    let secondaryZoomLevel = parseInt(this.getAttribute("max-zoom")) || 2;
    getterAdd(_lightbox_psw_media_init, this, new PhotoSwipeLightbox({
      pswpModule: () => import("photoswipe"),
      bgOpacity: 1,
      secondaryZoomLevel,
      maxZoomLevel: ++secondaryZoomLevel,
      closeTitle: themeHDN.extras.pswp.close,
      zoomTitle: themeHDN.extras.pswp.zoom,
      arrowPrevTitle: themeHDN.extras.pswp.prev,
      arrowNextTitle: themeHDN.extras.pswp.next,
      errorMsg: themeHDN.extras.pswp.errorMsg
    }));
    // getterGet(_lightbox_psw_media_init, this).on("uiRegister", __privateMethod(this, _registerLightboxUi, registerLightboxUi_fn).bind(this));
    getterGet(_lightbox_psw_media_init, this).addFilter("thumbEl", (thumbEl, data) => data.thumbEl);
    getterGet(_lightbox_psw_media_init, this).on('close', () => {
      const target = $$4('.hdt-product-media__main [data-media-type="image"]:not([hidden])')[getterGet(_lightbox_psw_media_init, this).pswp.currIndex];
      if (!target) return;
      if (this.sliderMain && this.sliderMain.isActive) {
        //this.sliderMain.goToIndex(currIndex, true);
        this.sliderMain.goToTarget(target, true);
      } else {
        target.scrollIntoView({ block: "start", behavior: "instant" });
      }
    });
    getterGet(_lightbox_psw_media_init, this).init();
    return getterGet(_lightbox_psw_media_init, this);
  }
  /**
   * Open the lightbox at the given index (by default, it opens the selected image)
   */
  openLightBox(index = 0) {
    const images = $$4('.hdt-product-media__main [data-media-type="image"]:not([hidden]) img[hdt-el]', this);
    const dataSource = images.map((image) => {
      return {
        thumbEl: image,
        src: image.src,
        srcset: image.srcset,
        msrc: image.currentSrc || image.src,
        width: parseInt(image.getAttribute("width")),
        height: parseInt(image.getAttribute("height")),
        alt: image.alt,
        thumbCropped: true
      };
    });
    this.lightBox.loadAndOpen(index, dataSource);
  }
};
_on_variant_changed_media = new WeakSet();
on_variant_changed_media_fn = function(event) {

  const variant = event.detail.variant;
  getterRunFn(_update_group_media, this, update_group_media_fn).call(this, variant);
  // if (this.updateGroupFilter) {
  //   let isreInit = false;
  //   variant.options.forEach((value, index) => {
  //     if ($$4(`[data-group-name="option${index}"][data-group-value="${value}"][hidden]`).length && this.sliderMain.isActive) {
  //       //console.log(this, $4('[data-media-type].is-selected hdt-video-player', this))
  //       $4('[data-media-type].is-selected hdt-video-player[loaded]', this)?.pause();
  //       isreInit = true;
  //     }
  //     //console.log(isreInit && this.sliderMain.isActive)
  //     $$4(`[data-group-name="option${index}"]`, this).forEach((media) => {
  //       if ( media.getAttribute('data-group-value') == value) {
  //         media.removeAttribute('hidden');
  //       } else {
  //         media.setAttribute('hidden', '');
  //       }
  //     });
  //   });
  //   if (isreInit) {
  //     this.sliderMain.reInit();
  //     this.sliderThumb?.reInit();
  //   }
  // }
  if (variant.mdid && event.detail.jumpMedia) {
    const media = $4(`.hdt-product-media__main [data-media-id="${variant.mdid}"]`, this);
    if (media) {
      if (this.sliderMain.isActive) {
        //this.disableSelectVariant = true;
        this.sliderMain.goToTarget(media);
      } else {
        //console.log(gotoMedia)
        media.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    }
  }
};
_update_group_media = new WeakSet();
update_group_media_fn = function(variantOrEvent) {
  const options = variantOrEvent.options || variantOrEvent.detail.options;
  if (!this.updateGroupFilter) return;
  let isreInit = false;
  options.forEach((value, index) => {
    if ($$4(`[data-group-name="option${index}"][data-group-value="${value}"][hidden]`).length && this.sliderMain.isActive) {
      //console.log(this, $4('[data-media-type].is-selected hdt-video-player', this))
      $4('[data-media-type].is-selected hdt-video-player[loaded]', this)?.pause();
      isreInit = true;
    }
    //console.log(isreInit && this.sliderMain.isActive)
    $$4(`[data-group-name="option${index}"]`, this).forEach((media) => {
      if ( media.getAttribute('data-group-value') == value) {
        media.removeAttribute('hidden');
      } else {
        media.setAttribute('hidden', '');
      }
    });
  });
  if (isreInit) {
    this.sliderMain.reInit();
    this.sliderThumb?.reInit();
  }
};
_slider_main_select = new WeakSet();
slider_main_select_fn = function(event) {
  //console.log('slider_main_select_fn: ', event.detail)
  // if (this.disableSelectVariant) {
  //   this.disableSelectVariant = false;
  //   return;
  // }
  const sliderApi = event.detail.sliderApi,
        selectedSlide = sliderApi.slideNodes()[sliderApi.selectedScrollSnap()],
        prevSlide = sliderApi.slideNodes()[sliderApi.previousScrollSnap()],
        mediaId   = selectedSlide.getAttribute('data-media-id') || null,
        variantsId = (selectedSlide.dataset.variantsId || '').split(';');

  // variantsId.indexOf(this.form.id.value to detech media has need run fn selected
  if (mediaId && this.variantPicker && this.hasAttribute('update-when-variant-change') && variantsId[0] && variantsId.indexOf(this.form.id.value) < 0 ) {
    //console.log('mediaId', mediaId)
    this.variantPicker.selectVariantByID(variantsId[0], false);
  }
  switch (prevSlide.getAttribute("data-media-type")) {
    case "video":
    case "external_video":
    //case "model":
      //$4('hdt-video-player[loaded], hdt-model-player[loaded]', prevSlide)?.pause();
      $4('hdt-video-player[loaded]', prevSlide)?.pause();
  }

  switch (selectedSlide.getAttribute("data-media-type")) {
    case "video":
    case "external_video":
      if (this.hasAttribute("autoplay-media")) $4('hdt-video-player', selectedSlide).play();
      break;
    case "model":
      if (!_matchMedia("phone")) $4('hdt-model-player', selectedSlide).play();
      break;
  }
};
_media_image_click = new WeakSet();
media_image_click_fn = function(imageWrap) {
  const imagesWrap = $$4('.hdt-product-media__main [data-media-type="image"]:not([hidden])', this);
  this.dispatchEvent(new CustomEvent("lightbox:psw:open", { bubbles: true, detail: { index: imagesWrap.indexOf(imageWrap) } }));
};
_media_image_zoom = new WeakSet();
media_image_zoom_fn = function() {
  var classFadeMedia = 'zoom_fade_media',
      classFadeInfo  = 'zoom_fade_info',
      options        = JSON.parse( this.getAttribute('zoom-options') ),
      zoomWrapper    = $id4(`product-zoom-${this.sectionId}`),
      info           = $id4(`product-info-${this.sectionId}`),
      zoomType       = options.type,  // external, inner, inner2 zoom
      zoomFactor     = options.magnify,
      isExternal     = zoomType  == 'external';

  if(Shopify.designMode) $4('.drift-zoom-pane, .drift-bounding-box')?.remove();
  html.classList.add(`zoom-type--${zoomType}`);
  $$4('.hdt-product-media__main [data-media-type="image"] img', this).forEach((image) => {
    new Zoom(image, {
      sourceAttribute: 'src',
      zoomFactor,
      inlinePane: !isExternal && zoomType == 'inner2',
      containInline: isExternal,
      paneContainer: isExternal ? zoomWrapper : image.parentElement,
      hoverBoundingBox: isExternal, //false , true
      handleTouch: false,
      onShow: () => {
       this.classList.add(classFadeMedia);
       info.classList.add(classFadeInfo);
      },
      onHide: () => {
       this.classList.remove(classFadeMedia);
       info.classList.remove(classFadeInfo);
      }
    });
  });
};

class OpenLightboxPSWMedia extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", () => this.dispatchEvent(new CustomEvent("lightbox:psw:open", { bubbles: true })));
  }
};

var _lightbox_psw_init, lightbox_psw_init_fn,
_lightbox_psws = new WeakMap();
class OpenLightboxPSW extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_lightbox_psw_init, this);
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    if (!this.dataset.objImg) return;
    getterRunFn(_lightbox_psw_init, this, lightbox_psw_init_fn).call(this);
    this.addEventListener("click", () => this.lightBox?.loadAndOpen(this.dataset.index || 0), { signal: this.#abortController.signal });
    //this.addEventListener("lightbox:pswp:open", () => this.openLightBox(this.dataset.index || 0));
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get lightBox() {
    return getterGet(_lightbox_psws, this);
  }
  get objImg() {
    return this.getAttribute('obj-img');
  }
};
_lightbox_psw_init = new WeakSet();
lightbox_psw_init_fn = function(){
  let dataSource = null;
  //if (this.dataset.objImg) {
    const _objImg = JSON.parse(this.dataset.objImg);
    _objImg.srcset = renderSrcset(_objImg.src, JSON.parse(this.dataset.widths || `[246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946, 2200, 2500, 3000, 3500, 4000, ${_objImg.width}]`));
     dataSource = [_objImg]
  // }
  // console.log(dataSource)
  // if (!dataSource) return;
  const options = {
    bgOpacity: 1,
    showHideAnimationType: 'fade', // 'zoom', 'fade', 'none
    pswpModule: () => import("photoswipe"),
    dataSource
  };
  getterAdd(_lightbox_psws, this, new PhotoSwipeLightbox(options));
  this.lightBox.init();
  // Clear memory
  dataSource = null;
}

var _lightbox_psw_init = new WeakMap();
class GalleryModal extends HTMLElement {
  #abortController;
  constructor() {
    super();
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    if (this.images.length == 0) return;
    console.log(this.lightbox)
    this.images.forEach( (image, index) => image.addEventListener('click', this.openLightBox.bind(this, index), { signal: this.#abortController.signal }));
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
  get images() {
    return $$4( this.getAttribute("selector") || "img", this)
  }
  get lightBox() {
    if (getterGet(_lightbox_psw_init, this)) return getterGet(_lightbox_psw_init, this);
    const {close, zoom, prev, next, errorMsg} = themeHDN.extras.pswp;

    let secondaryZoomLevel = parseInt(this.getAttribute("max-zoom")) || 2,
    dataSource = this.images.map((image) => {
      const {src, currentSrc, alt} = image;
      const srcset = renderSrcset(src, JSON.parse(image.dataset.widths || `[246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946, 2200, 2500, 3000, 3500, 4000, ${image.getAttribute("width")}]`));
      return {
        thumbnailElement: image,
        src,
        srcset,
        msrc: currentSrc || src,
        width: parseInt(image.getAttribute("width")),
        height: parseInt(image.getAttribute("height")),
        alt,
        thumbCropped: true
      };
    });

    getterAdd(_lightbox_psw_init, this, new PhotoSwipeLightbox({
      pswpModule: () => import("photoswipe"),
      //showHideAnimationType: 'zoom',
      dataSource,
      bgOpacity: 1,
      secondaryZoomLevel,
      maxZoomLevel: ++secondaryZoomLevel,
      closeTitle: close,
      zoomTitle: zoom,
      arrowPrevTitle: prev,
      arrowNextTitle: next,
      errorMsg: errorMsg
    }));
    getterGet(_lightbox_psw_init, this).init();
    // Clear memory
    dataSource = null;
    return getterGet(_lightbox_psw_init, this);
  }
  openLightBox(index = 0) {
    this.lightBox.loadAndOpen(index);
  }
};

customElements.define("hdt-video-player", VideoPlayer);
customElements.define("hdt-model-player", ModelPlayer);
customElements.define("hdt-product-media", ProductMedia);
customElements.define("wrapp-open-pswp-media", OpenLightboxPSWMedia);
customElements.define("wrapp-open-pswp-btn", OpenLightboxPSW);
customElements.define('hdt-gallery-modal', GalleryModal);

// END MEDIA PLAYER
var _items_compare_color = new WeakMap(),
_item_compare_color,
item_compare_color_fn;
class CompareToogle extends HTMLElement {
  #abortController;
  constructor() {
    super();
    getterAdd(_items_compare_color, this, $$4('.hdt-compare-color-item', this.closest('.hdt-modal__compare-color')));
    getterAdd(_item_compare_color, this);
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    this.indexOrder = 0;
    $$4('button', this).forEach((btn, index) => {
      ++this.indexOrder;
      btn.addEventListener('click', getterRunFn(_item_compare_color, this, item_compare_color_fn).bind(this, btn, index), { signal: this.#abortController.signal });
    });
  }
  disconnectedCallback() {
    this.#abortController.abort();
  }
}
_item_compare_color = new WeakSet();
item_compare_color_fn = function(btn, index) {
  const isHideColor = btn.classList.toggle('is-hide-color');
  btn.firstElementChild.toggleAttribute('hidden', isHideColor);
  btn.lastElementChild.toggleAttribute('hidden', !isHideColor);
  console.log(this.indexOrder, index, getterGet(_items_compare_color, this))
  if (isHideColor) {
    --this.indexOrder
    getterGet(_items_compare_color, this)[index].setAttribute('hidden', '');
  } else {
    ++this.indexOrder
    getterGet(_items_compare_color, this)[index].removeAttribute('hidden');
    getterGet(_items_compare_color, this)[index].style.order = this.indexOrder;
  }
};
customElements.define("hdt-compare-color-toogle", CompareToogle);

// TF
class closeAnnounceWrap extends HTMLElement {
  constructor() {
    super();
    if (sessionStorage.getItem(announceSize) === "true") {
      announceSize = null;
      return;
    }
    this.addEventListener('click', (e) => {
      if (!Shopify.designMode) sessionStorage.setItem(announceSize, "true");
      let $section = this.closest('.hdt-section-group');
      $section.style.setProperty('overflow', 'hidden');
      animate($section, { height: [`${$section.clientHeight}px`, '0px'] }).finished.then(() => {
        $section.classList.add('hdt-announcement-hidden');
        announceSize = null; // announceSize can be garbage collected
      });
    });
  }
}
customElements.define("wrapp-close-announce", closeAnnounceWrap);

// --------------------------
// lazyHTML- https://web.dev/articles/fetch-priority
// --------------------------
class lazyHTML extends HTMLElement {
  #abortController;
  check = true;
  constructor() {
    super();
  }
  connectedCallback() {
    this.#abortController = new AbortController();
    const options = {
      priority: this.getAttribute('priority') || 'low',
      signal: this.#abortController.signal
    },
    url = this.url || this.getAttribute('url') || `${Shopify.routes.root}?section_id=${this.getAttribute('section-id')}`;
    if (url) this.lazyFetch(url, options);
  }
  disconnectedCallback() {
    if (this.check) this.#abortController.abort();
  }
  async lazyFetch(url, options) {
    const response = await cachedFetch(url, '', options),
          tempDiv  = new DOMParser().parseFromString(await response.text(), "text/html");
    this.check = false;
    const formLocal = $4('.shopify-localization-form', tempDiv);
    if (formLocal) {
      const language = $id4('localization_form_language');
      $4('[name="return_to"]', formLocal).value = language && language.return_to ? language.return_to.value : location.pathname;
    }
    this._replace(tempDiv);
  }
  _replace(tempDiv) {
    this.replaceWith(...tempDiv.body.children);
    this.dispatchEvent(new CustomEvent("lazyhtml:added", { bubbles: true }));
  }
}
// --------------------------
// Lazy Submenu
// --------------------------
var cachMenuURl = new Map();
class lazySubmenu extends lazyHTML {
  check = true;
  url = `${Shopify.routes.root}search?type=product&q=submenu${this.getAttribute('key') || ''}&section_id=${this.dataset.section}`;
  constructor() {
    super();
  }
  async lazyFetch(url, options) {
    if (!cachMenuURl.has(url)) {
      cachMenuURl.set(url, true);
      const response = await cachedFetch(url, '', options),
            tempDiv  = new DOMParser().parseFromString(await response.text(), "text/html");
      this.check = false;
      this._replace(tempDiv);
      $$4(`hdt-lazy-submenu[data-section="${this.dataset.section}"]:not([id="${this.id}"])`).forEach( (el) => {
        el.dispatchEvent(new CustomEvent(`loaded:lazy`, { bubbles: false, detail: { tempDiv } }));
      });
    } else {
      this.addEventListener('loaded:lazy', (event) => this._replace( event.detail.tempDiv) );
    }
  }
  _replace(tempDiv) {
    this.innerHTML = tempDiv.querySelector(`#${this.id}`).innerHTML;
    this.dispatchEvent(new CustomEvent("products:update", { bubbles: true }));
    this.dispatchEvent(new CustomEvent("lazyhtml:added", { bubbles: true }));
  }
}

customElements.define("hdt-lazy-html", lazyHTML);
customElements.define("hdt-lazy-submenu", lazySubmenu);

// end TF

(() => {
  // LIST
  // 1. Reveal
  // 2. Scrollbar Width
  // 3. Hover 3d button
  // 4. Table, iframe wrapper

  // 1. Reveal
  const reveal_attribute = 'hdt-reveal';
  const reveal_ANIMATION_OFFSCREEN_CLASSNAME = reveal_attribute + '--offscreen';
  const reveal_ANIMATION_CANCEL_CLASSNAME = reveal_attribute + '--cancel';
  const _animationend = (e) => {
    const elementTarget = e.target;
    //console.log("Animation ended", e.target, this, elementTarget.isAnimationend);
    if (elementTarget.isAnimationend) {
      //console.log("Animation ended 2", e.target, this);
      // setTimeout(() => {
      // }, 0);
        elementTarget.setAttribute('animationend','');
        elementTarget.removeEventListener("animationend", _animationend)
    }
  };

  function onIntersection(elements, observer) {
    //console.log(elements, observer)
    elements.forEach((element, index) => {
      const elementTarget = element.target;
      elementTarget.setAttribute('observed','');
      if (element.isIntersecting) {
        //console.log(elementTarget)
        if (elementTarget.classList.contains(reveal_ANIMATION_OFFSCREEN_CLASSNAME)) {
          elementTarget.classList.remove(reveal_ANIMATION_OFFSCREEN_CLASSNAME);
          if (elementTarget.hasAttribute('timeline')) elementTarget.style.setProperty('--animation-order', index);
        }
        observer.unobserve(elementTarget);
      } else {
        elementTarget.classList.add(reveal_ANIMATION_OFFSCREEN_CLASSNAME);
        elementTarget.classList.remove(reveal_ANIMATION_CANCEL_CLASSNAME);
      }
      elementTarget.isAnimationend = true;
      elementTarget.addEventListener("animationend", _animationend);
    });
  }

  function intRevealScrollTrigger(rootEl = document, isDesignModeEvent = false) {
    const animationTriggerElements = $$4(`[${reveal_attribute}]:not([observed])`, rootEl);
    if (animationTriggerElements.length === 0) return;

    if (isDesignModeEvent) {
      animationTriggerElements.forEach((element) => {
        element.classList.add(reveal_attribute + '--design-mode');
      });
      return;
    }
    // animationTriggerElements.forEach((element) => {
    //     const observer = inView(
    //     element, onIntersection,
    //     { margin: "0px 0px -50px 0px" }
    //   )
    // });

    const observer = new IntersectionObserver(onIntersection, {
      rootMargin: '0px 0px -50px 0px',
    });
    animationTriggerElements.forEach((element) => observer.observe(element) );
  }
  if (themeHDN.settings.revealInView && matchMedia("motion")) {
    html.classList.add('hdt-reveal-in-view')
    window.addEventListener('DOMContentLoaded', () => intRevealScrollTrigger());

    if (Shopify.designMode) {
      document.addEventListener(adnmEvts.seLoad, (event) => intRevealScrollTrigger(event.target, true));
      document.addEventListener(adnmEvts.seReorder, () => intRevealScrollTrigger(document, true));
    }
  }

  // 2. Scrollbar Width
  // https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
  const getScrollbarWidth = () => {
    const scrollbarWidth = window.innerWidth - document.body.clientWidth;
    if (scrollbarWidth >= 0) html.style.setProperty("--scrollbar-w", `${scrollbarWidth}px`);
    // calc first section height full
    const firstSection = $4('#MainContent .hdt-section');
    if (!firstSection) return;
    const fullFirst = $4('.md\\:hdt-height--full, .hdt-height--full', firstSection);
    if (fullFirst && fullFirst.offsetTop < window.innerHeight) firstSection.style.setProperty("--fill-height-first", `${100 - fullFirst.offsetTop / (window.innerHeight / 100)}vh`);
  };
  getScrollbarWidth();
  window.addEventListener("resize", throttle(getScrollbarWidth));

  // 3. Hover 3d button
  // https://vault.uicore.co/corporate/
  if (_matchMedia("supports-hover")) {
    var $buttons3d = $$4('.hdt-btn-effect-3d');
    $buttons3d.forEach((btn) => {
      btn.addEventListener('mousemove', function(e) {
        const pos = btn.getBoundingClientRect();
        const mx = e.clientX - pos.left - pos.width / 2;
        const my = e.clientY - pos.top - pos.height / 2;
        // btn.setProperty('--rx', `${ dy/-1 }deg`)
        btn.style.transform = 'translate(' + mx * 0.15 + 'px, ' + my * 0.3 + 'px)';
        btn.style.transform += 'rotate3d(' + mx * -0.1 + ', ' + my * -0.3 + ', 0, 12deg)';
        if (btn.children[0]) {
          btn.children[0].style.transition = 'all .2s linear';
          btn.children[0].style.transform = 'translate(' + mx * 0.07 + 'px, ' + my * 0.14 + 'px)'
        }
      });
      btn.addEventListener('mouseleave', function() {
        btn.style.transform = 'translate3d(0px, 0px, 0px)';
        btn.style.transform += 'rotate3d(0, 0, 0, 0deg)';
          if (btn.children[0]) btn.children[0].style.transform = 'translate3d(0px, 0px, 0px)'
      });
    });
  }

  // 4. Table, iframe wrapper
  // Theme-specific selectors to make tables scrollable
  rteWrapTable();
  accessibleLinks();
  localeUrl();

  // ADDED: Kityfly and Nathan
  // https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
  // https://stackoverflow.com/questions/2915833/how-to-check-browser-for-touchstart-support-using-js-jquery
  // https://stackoverflow.com/questions/27173272/300ms-delay-removal-using-fastclick-js-vs-using-ontouchstart
  // if (navigator.userAgent && /iPad|iPhone|iPod/.test(navigator.userAgent)) {
  //   $4('meta[name="viewport"]', document.head).content = "width=device-width, initial-scale=1.0, height=device-height, minimum-scale=1.0, maximum-scale=1.0";
  // } else  if ("ontouchend" in document) {
  //   let indexFixFristClick = 0;
  //   const FixFristClick = () => { ++indexFixFristClick; if( indexFixFristClick > 1) document.removeEventListener('touchend', FixFristClick) };
  //   document.addEventListener('touchend', FixFristClick);
  // }
  if (navigator.userAgent && /iPad|iPhone|iPod/.test(navigator.userAgent)) {
    $4('meta[name="viewport"]', document.head).content = "width=device-width, initial-scale=1.0, height=device-height, minimum-scale=1.0, maximum-scale=1.0";
  }
  if ("ontouchend" in document) {
    let indexFixFristClick = 0;
    const FixFristClick = () => { ++indexFixFristClick; if( indexFixFristClick > 1) document.removeEventListener('touchend', FixFristClick) };
    document.addEventListener('touchend', FixFristClick);
  }
  if ( !$4('hdt-cart-drawer') && themeHDN.settings.pageType != 'cart') {
    document.addEventListener("variant:add", (event) => {
      const actionAfterATC = event.detail.actionAfterATC || themeHDN.settings.actionAfterATC;
      if (actionAfterATC.indexOf('go_') > -1) window.location.href = `${Shopify.routes.root}${actionAfterATC == 'go_cart_page' ? 'cart' : 'checkout'}`;
    });
  }
  if ($4('hdt-cart-drawer')) {
    document.addEventListener("variant:add", (event) => {
      if ($4('#hdt-quick-view-modal')?.hasAttribute('open') && $4('#CartDrawer')?.hasAttribute('open')) $4('#hdt-quick-view-modal').closeDialog();
    });
  }

})();

export {
  $4, $$4, $id4, getterAdd, getterGet, getterRunFn,
  isRTL,
  getUID,
  throttle,
  debounce,
  formatMoney,
  btnTooltip,
  _matchMedia,
  cachedFetch,
  Drawer,
  VariantChangeBase,
  localeUrl
}